// Debug Mode Control — JRSBASE-V8.3.0-09102026-BYOB — debug always ON — sync
// Console: mrkDebug.* always runs (line-item debug fields still controlled separately).
(function() {
  var DEBUG_MODE = true;

  var _themeId = String(window._bcThemeId || window._mrkThemeId || 'base');
  var _themeVersion = String(window._bcThemeVersion || window._mrkThemeVersion || 'JRSBASE-V8.3.0-09102026-BYOB');
  var _prefix = '[' + _themeVersion + '][' + _themeId + ']';
  var _makeWriter = function(method) {
    if (!DEBUG_MODE) return function(){};
    return function() {
      var args = Array.prototype.slice.call(arguments);
      args.unshift(_prefix);
      if (console && typeof console[method] === 'function') {
        console[method].apply(console, args);
      }
    };
  };

  var debugObj = window.bcDebug || window.betterConversionsDebug || window.mrkDebug || {};
  debugObj.enabled = DEBUG_MODE;
  debugObj.log = _makeWriter('log');
  debugObj.warn = _makeWriter('warn');
  debugObj.error = _makeWriter('error');
  debugObj.info = _makeWriter('info');
  window.bcDebug = debugObj;
  window.betterConversionsDebug = debugObj;
  window.mrkDebug = debugObj;
})();
window.__noopLog = function(){};

var JRS_BUILD_VERSION = '7.0.0';
var JRS_BUILD_DATE = '2026-08-20';
var JRS_THEME_NAME = 'base';
// When true, _debug_* and _regular_product_debug_log are added to line item properties (visible in Shopify admin on every order).
var JRS_DEBUG_PROPERTIES_IN_CART = true;

// Initialize customizer debug tracker - Updated 2026-09-03 (v8.2.0)
if (!window.customizerDebugTracker) {
  window.customizerDebugTracker = {
    sessionId: Date.now().toString(36) + Math.random().toString(36).substr(2, 9),
    addSequence: 0,
    userActions: [],
    stepChanges: [],
    errors: [],
    buildVersion: typeof JRS_BUILD_VERSION !== 'undefined' ? JRS_BUILD_VERSION : 'unknown',
    themeName: typeof JRS_THEME_NAME !== 'undefined' ? JRS_THEME_NAME : 'base'
  };
}

// Global cache to map logo URLs to their original filenames
// This ensures that when the same logo is reused, we preserve the original filename
if (!window.logoFilenameCache) {
  window.logoFilenameCache = {};
}

/**
 * Get the original filename for a logo URL
 * Checks cache first, then extracts from URL as fallback
 * Also checks if we've seen this base filename before (for timestamped uploads)
 * @param {string} logoUrl - The logo URL
 * @returns {string} - The original filename
 */
function getOriginalLogoFilename(logoUrl) {
  if (!logoUrl || typeof logoUrl !== 'string') return '';
  
  // Normalize URL (remove query params, decode if needed)
  var normalizedUrl = String(logoUrl).split('?')[0];
  normalizedUrl = decodeURIComponent(normalizedUrl);
  
  var result = '';
  
  // Check cache first (exact URL match)
  if (window.logoFilenameCache[normalizedUrl]) {
    var cached = window.logoFilenameCache[normalizedUrl];
    // If cache has timestamped name, strip to base so we always show clean filename
    var cachedMatch = cached && String(cached).match(/^logo_\d+_(.+)$/);
    result = cachedMatch ? cachedMatch[1] : (cached || '');
  } else {
    // Extract filename from URL
    try {
      var urlPath = normalizedUrl.split('?')[0];
      var fileName = urlPath.split('/').pop();
      
      // If filename matches pattern "logo_TIMESTAMP_BASENAME.ext", always return only BASENAME.ext
      if (fileName && fileName.indexOf('logo_') === 0) {
        var match = fileName.match(/^logo_\d+_(.+)$/);
        if (match && match[1]) {
          result = match[1];
          if (!window.logoFilenameCache[normalizedUrl]) {
            window.logoFilenameCache[normalizedUrl] = result;
          }
        } else {
          result = fileName || '';
        }
      } else {
        result = fileName || '';
      }
    } catch(e) {
      result = '';
    }
  }
  
  // Normalize so same file always has same name (e.g. "_TYR3894 1.png" and "_TYR3894_1.png" -> "_TYR3894_1.png")
  return normalizeLogoFilename(result);
}

/**
 * Normalize logo filename to a canonical form (same as upload sanitization).
 * So the same file always has the same filename regardless of source (cache vs URL).
 * e.g. "_TYR3894 1.png" and "_TYR3894_1.png" both become "_TYR3894_1.png"
 * @param {string} filename - Raw filename
 * @returns {string} - Normalized filename
 */
function normalizeLogoFilename(filename) {
  if (!filename || typeof filename !== 'string') return '';
  var s = filename.trim();
  var lastDot = s.lastIndexOf('.');
  var base = lastDot !== -1 ? s.substring(0, lastDot) : s;
  var ext = lastDot !== -1 ? s.substring(lastDot) : '';
  base = base.replace(/[^a-zA-Z0-9_-]/g, '_');
  return base + ext;
}

/**
 * Store the original filename for a logo URL
 * @param {string} logoUrl - The logo URL
 * @param {string} originalFilename - The original filename from the file upload
 */
function storeOriginalLogoFilename(logoUrl, originalFilename) {
  if (!logoUrl || !originalFilename) return;
  
  // Normalize URL (remove query params, decode if needed)
  var normalizedUrl = String(logoUrl).split('?')[0];
  normalizedUrl = decodeURIComponent(normalizedUrl);
  
  // Store in cache (only if not already stored to preserve first upload)
  if (!window.logoFilenameCache[normalizedUrl] && originalFilename) {
    window.logoFilenameCache[normalizedUrl] = originalFilename;
  }
}

/**
 * Track user actions on customizer
 */
function trackCustomizerUserAction(action, details) {
  window.customizerDebugTracker.userActions.push({
    action: action,
    timestamp: new Date().toISOString(),
    details: details || {}
  });
  mrkDebug.log('[Customizer User Action]', action, details);
}

/**
 * Track step changes
 */
function trackCustomizerStep(fromStep, toStep) {
  window.customizerDebugTracker.stepChanges.push({
    from: fromStep,
    to: toStep,
    timestamp: new Date().toISOString()
  });
}

/**
 * Generate comprehensive debug properties for customized items
 */
function generateCustomizerDebugProperties(itemType, context) {
  context = context || {};
  if (!JRS_DEBUG_PROPERTIES_IN_CART) return {};
  if (window.customizerDebugTracker) window.customizerDebugTracker.addSequence = (window.customizerDebugTracker.addSequence || 0) + 1;
  var sessionId = (window.customizerDebugTracker && window.customizerDebugTracker.sessionId) || '';
  var source = itemType === 'plain' ? 'customizer_form_plain' : 'customizer_form_child';
  return {
    _debug_version: '7.0.0',
    _debug_build_date: '2026-08-20',
    _debug_session_id: sessionId,
    _debug_add_source: source,
    _debug_add_timestamp: new Date().toISOString(),
    _debug_theme: typeof JRS_THEME_NAME !== 'undefined' ? JRS_THEME_NAME : 'base'
  };
}

const moneyFormat = window.theme.moneyFormat;

// Helper function to normalize position names for consistent key matching
// This ensures storage and retrieval use the same key format
function normalizePositionKey(positionName) {
    if (!positionName) return '';
    return positionName.toString().trim().toLowerCase().replace(/\s+/g, '_');
}

// Initialize Regular Product User Journey Tracker - Updated 2026-02-15
if (!window.regularProductUserJourney) {
  window.regularProductUserJourney = {
    startTime: new Date().toISOString(),
    pageLoad: new Date().toISOString(),
    interactions: [],
    stateChanges: [],
    errors: [],
    timing: {}
  };
}

function trackRegularProductInteraction(action, details) {
  if (!window.regularProductUserJourney) {
    window.regularProductUserJourney = {
      startTime: new Date().toISOString(),
      interactions: [],
      stateChanges: [],
      errors: [],
      timing: {}
    };
  }
  
  try {
    var interaction = {
      action: action,
      timestamp: new Date().toISOString(),
      timeSinceStart: Date.now() - new Date(window.regularProductUserJourney.startTime).getTime(),
      details: details || {}
    };
    
    window.regularProductUserJourney.interactions.push(interaction);
    // mrkDebug.log('[REGULAR PRODUCT JOURNEY]', action, details);
  } catch(e) {
    // mrkDebug.error('[REGULAR PRODUCT JOURNEY] Error tracking interaction:', e);
  }
}

function trackRegularProductStateChange(state, before, after) {
  if (!window.regularProductUserJourney) return;
  
  try {
    window.regularProductUserJourney.stateChanges.push({
      state: state,
      timestamp: new Date().toISOString(),
      before: before,
      after: after
    });
  } catch(e) {
    // mrkDebug.error('[REGULAR PRODUCT JOURNEY] Error tracking state change:', e);
  }
}

function trackRegularProductError(error, context) {
  if (!window.regularProductUserJourney) {
    window.regularProductUserJourney = {
      startTime: new Date().toISOString(),
      interactions: [],
      stateChanges: [],
      errors: [],
      timing: {}
    };
  }
  
  try {
    window.regularProductUserJourney.errors.push({
      error: error,
      context: context || {},
      timestamp: new Date().toISOString()
    });
    // mrkDebug.error('[REGULAR PRODUCT ERROR]', error, context);
  } catch(e) {
    // mrkDebug.error('[REGULAR PRODUCT JOURNEY] Error tracking error:', e);
  }
}

// Track page initialization
try {
  trackRegularProductInteraction('page_loaded', {
    url: window.location.href,
    userAgent: navigator.userAgent,
    customizationEnabled: typeof $ !== 'undefined' && $('.mrk-product-csutomizer').length > 0
  });
} catch(e) {
  // mrkDebug.error('[REGULAR PRODUCT] Error tracking page load:', e);
}

/**
 * Format money values based on your shop currency settings
 * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
 * or 3.00 dollars
 * @param  {String} format - shop money_format setting
 * @return {String} value - formatted value
 */
function formatMoney(cents, format) { 
    if (typeof cents === 'string') {
        cents = cents.replace('.', '');
    }
    let value = '';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || moneyFormat;

    function formatWithDelimiters(
        number,
        precision = 2,
        thousands = ',',
        decimal = '.'
    ) {
        if (isNaN(number) || number == null) {
            return 0;
        }

        number = (number / 100.0).toFixed(precision);

        const parts = number.split('.');
        const dollarsAmount = parts[0].replace(
            /(\d)(?=(\d\d\d)+(?!\d))/g,
            `$1${thousands}`
        );
        const centsAmount = parts[1] ? decimal + parts[1] : '';

        return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_single':
            value = formatWithDelimiters(cents, 1);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
    }

    return formatString.replace(placeholderRegex, value);
}

function preparePreview(file, container) {
    // Reset potential changes from previous uploads
    $(container).find('.mrk-progress').show();
    $(container).find('.mrk-upload').css('width', '0%');
    $(container).find('.mrk-error-message span').text('');

    // Display the file name and show the preview
    $(container).find('.mrk-filename span[data-mrk-name]').text(file.name);
    $(container).find('.preview-template').show();
}

function uploadFile(file, container) {
    // Order #55892: Reject PDF and other non-image types so logo preview and fulfillment get valid image URLs
    var allowedMimes = ['image/png', 'image/jpeg', 'image/jpg', 'image/svg+xml', 'image/webp'];
    var isPdf = file && (file.type === 'application/pdf' || (file.name && file.name.toLowerCase().slice(-4) === '.pdf'));
    if (file && (isPdf || (file.type && allowedMimes.indexOf(file.type) === -1 && file.type.indexOf('image/') !== 0))) {
        var errEl = $(container).find('.mrk-error-message span');
        if (errEl.length) errEl.text('Please upload a PNG, JPG, SVG or WebP file. PDFs are not supported for logo upload.');
        $(container).find('.mrk-progress').hide();
        $('.mrk-steps-footer').removeClass('loading').removeClass('mrk-disable-btn');
        return;
    }
    var formData = new FormData();
    // Sanitize filename: prefix with 'logo_' + timestamp to avoid server rejection
    // for filenames starting with digits or containing patterns like _480x
    var ext = file.name.lastIndexOf('.') !== -1 ? file.name.substring(file.name.lastIndexOf('.')) : '';
    var baseName = file.name.lastIndexOf('.') !== -1 ? file.name.substring(0, file.name.lastIndexOf('.')) : file.name;
    var sanitizedName = 'logo_' + Date.now() + '_' + baseName.replace(/[^a-zA-Z0-9_-]/g, '_') + ext;
    formData.append('file', file, sanitizedName);

    $.ajax({
        url: 'https://jrsindustrial-files.com',
        type: 'POST',
        data: formData,
        cache: false,
        contentType: false,
        processData: false,
        beforeSend: function() {
            $('.mrk-steps-footer').addClass('loading');
        },
        xhr: function() {
            var xhr = new XMLHttpRequest();
            xhr.upload.addEventListener("progress", function(e) {
                if (e.lengthComputable) {
                    var percentComplete = (e.loaded / e.total) * 100;
                    $(container).find('.mrk-upload').css('width', percentComplete + '%');
                }
            });
            return xhr;
        },
        success: function(response) {
            try {
                // Validate response
                if (!response || !response.filePath) {
                    throw new Error('Invalid response from upload server');
                }
                
            // mrkDebug.log(response);
            // response = JSON.parse(response);
            var url = 'https://jrsindustrial-files.com/' + response.filePath;
                
                // Track logo upload success (Order #56166/#55753: position from the section that received the upload)
                var $uploadSection = $(container).closest('.mrk-step-upload-logo-position, [class*="mrk-step-upload-your-logo-position"]');
                var positionName = null;
                if ($uploadSection.length) {
                    positionName = $uploadSection.find('.logo-position-checkbox:checked').attr('data-position-name') ||
                        $uploadSection.find('.logo-position-checkbox').first().attr('data-position-name');
                }
                if (!positionName) {
                    positionName = $('.logo-position-checkbox:checked').first().attr('data-position-name') || 'Unknown';
                    if (positionName === 'Unknown') {
                        mrkDebug.log('[Upload] Position fallback to Unknown — upload container not inside a position section');
                    }
                }
                trackRegularProductInteraction('logo_uploaded', {
                    success: true,
                    url: url,
                    fileName: file ? file.name : 'Unknown',
                    fileSize: file ? file.size : 0,
                    fileType: file ? file.type : 'Unknown',
                    position: positionName,
                    uploadTime: new Date().toISOString()
                });
                
                // CRITICAL FIX (LOGO-URL-001): Store logo URL in session memory immediately
                if (!window._currentSessionLogoData) {
                    window._currentSessionLogoData = {};
                }
                window._currentSessionLogoData[positionName] = {
                    logoUrl: encodeURI(url), // CRITICAL FIX (LOGO-URL-003): Encode URL for spaces/special chars
                    fileName: file ? file.name : 'Unknown',
                    timestamp: Date.now(),
                    source: 'upload_success_handler'
                };
                
                // Store original filename in global cache for reuse
                if (file && file.name) {
                    storeOriginalLogoFilename(url, file.name);
                }
                
                mrkDebug.log('[Upload] Logo URL stored in session memory:', {
                    position: positionName,
                    url: url ? url.substring(0, 60) + '...' : 'MISSING',
                    timestamp: Date.now()
                });
                
            $(container).find('.mrk-image img').attr('src', url); // Set the image source
                
                // Safely handle localStorage
                try {
                    var logos = JSON.parse(localStorage.getItem('logos') || '[]');
                    if (Array.isArray(logos)) {
            logos.push(url);
            localStorage.setItem('logos', JSON.stringify(logos));
                    }
                } catch(e) {
                    // mrkDebug.warn('[Regular Product] Failed to save logo to localStorage:', e);
                }
                
            $(container).find('.input-file-logo').val(url);
            // Order #52352: Trace logo URL source for debugging missing URL in bundle_raw
            if (typeof console !== 'undefined') {
              try {
                var uploadInput = $(container).find('[name="properties[Uploaded Logo]"]');
                if (uploadInput.length) uploadInput.val(url);
                mrkDebug.log('[CUSTOMIZER] Logo URL set (upload):', { url: url ? url.substring(0, 60) + '...' : url, hasValue: !!url, timestamp: Date.now() });
              } catch (e) {}
            }
            $(container).find('.mrk-progress').hide(); // Hide the progress bar on success
            //Ak custom code
            $(container).find('.mrk-success-message').css('display','block');
            //End Ak custom code
            $('.mrk-steps-footer').removeClass('loading');
            $('.mrk-steps-footer').removeClass('mrk-disable-btn');
                
                var nextBtn = document.querySelector(".mrk-steps-footer");
                if (nextBtn) {
                    var firstChild = nextBtn.querySelector(".mrk-next-btn");
                    if (firstChild && firstChild.firstElementChild) {
                        firstChild.firstElementChild.classList.remove("disabled");
                    }
                }
            } catch(e) {
                trackRegularProductError('Logo upload success handler error', {
                    error: e.message,
                    stack: e.stack
                });
                // mrkDebug.error('[Regular Product] Error in upload success handler:', e);
            }
        },
        error: function(jqXHR, textStatus, errorThrown) {
            try {
                var $uploadSectionErr = $(container).closest('.mrk-step-upload-logo-position, [class*="mrk-step-upload-your-logo-position"]');
                var positionName = $uploadSectionErr.length ? ($uploadSectionErr.find('.logo-position-checkbox:checked').attr('data-position-name') || $uploadSectionErr.find('.logo-position-checkbox').first().attr('data-position-name')) : null;
                if (!positionName) positionName = $('.logo-position-checkbox:checked').first().attr('data-position-name') || 'Unknown';
                trackRegularProductInteraction('logo_upload_failed', {
                    success: false,
                    fileName: file ? file.name : 'Unknown',
                    fileSize: file ? file.size : 0,
                    fileType: file ? file.type : 'Unknown',
                    position: positionName,
                    error: textStatus,
                    errorThrown: errorThrown,
                    uploadTime: new Date().toISOString()
                });
                
                trackRegularProductError('Logo upload failed', {
                    textStatus: textStatus,
                    errorThrown: errorThrown,
                    status: jqXHR ? jqXHR.status : 'unknown'
                });
                
            var statusCode = jqXHR ? jqXHR.status : 'unknown';
            var responseBody = '';
            try { responseBody = jqXHR ? jqXHR.responseText || jqXHR.responseJSON : ''; } catch(re) {}
            mrkDebug.error('[Regular Product] Logo upload failed:', {
                fileName: file ? file.name : 'Unknown',
                textStatus: textStatus,
                errorThrown: errorThrown,
                httpStatus: statusCode,
                responseBody: responseBody ? (responseBody.substring ? responseBody.substring(0, 200) : JSON.stringify(responseBody).substring(0, 200)) : ''
            });
            var errorMsg = 'Upload error: ' + textStatus;
            if (statusCode && statusCode !== 'unknown') errorMsg += ' (HTTP ' + statusCode + ')';
            if (errorThrown) errorMsg += ' - ' + errorThrown;
            $(container).find('.mrk-error-message span').text(errorMsg);
            $(container).find('.mrk-progress').hide(); // Hide the progress bar on error
            } catch(e) {
                // mrkDebug.error('[Regular Product] Error in upload error handler:', e);
            }
        }
    });
}
// customizer steps
function calculatePrice() {
    var sizes = $('.mrk-qty-item'),
        totalPrice = 0;
    const positions = $('[name="logo-position"]:checked');
    const isEmbroidery = $('[name="application-type"]:checked').val() == 'Embroidery' ? true : false;
    const positionsPrice = getAllPositionsPrice(isEmbroidery, positions);
    const logoTypePrice = Number($('[name="logo-type"]:checked').attr('price')) || 0;
    hideAndShowPositions(isEmbroidery);
    sizes.each(function() {
        var qty = Number($(this).val());
        var price = 0;
        if (qty > 0) {
            var variantPrice = Number($(this).attr('price'));
            var price = positionsPrice;
            var finalPrice = (price * qty) + (variantPrice * qty) + logoTypePrice;
            totalPrice = totalPrice + finalPrice;
        }
    });
    var positionsCount = $('.mrk-checked-position').length + $('[name="mrk-main-logo-position"]:checked').length;
    // $('#positionCount').html(positionsCount);
    $('.mrk-final-price').html(formatMoney(totalPrice));
}

function hideAndShowPositions(isEmbroidery) {
    if (isEmbroidery) {
        $('.mrk-step-2').addClass('mrk-embroidery-active').removeClass('mrk-print-active');
    } else {
        $('.mrk-step-2').addClass('mrk-print-active').removeClass('mrk-embroidery-active');
    }
}

function getAllPositionsPrice(isEmbroidery, positions) {
    var priceTotal = 0,
        price;
    positions.each(function() {
        if (isEmbroidery) {
            price = Number($(this).data('embroideryprice'));
        } else {
            price = Number($(this).data('printprice'));
        }
        priceTotal = priceTotal + price;
    })
    return priceTotal;
}

function getAllPositionsVariants(positions, qty, ParentVariantId) {
    window.__noopLog('[getAllPositionsVariants] ✅ Function called!', {
        positionsLength: positions ? positions.length : 0,
        positionsType: positions ? (positions.jquery ? 'jQuery' : typeof positions) : 'null',
        qty: qty,
        parentVariantId: ParentVariantId
    });
    
    var allPositionsItem = [],
        positionData = [];
    
    // CRITICAL FIX: Early return if no positions are checked
    // This prevents reading stale hidden fields when user intentionally adds product without customization
    // Strengthened check to handle all edge cases: null, undefined, empty jQuery objects, empty arrays
    var positionsLength = 0;
    if (positions) {
        // Handle jQuery objects and arrays
        if (typeof positions.length === 'number') {
            positionsLength = positions.length;
        } else if (positions.jquery || positions.constructor === jQuery) {
            // jQuery object - use .length property
            positionsLength = positions.length || 0;
        }
    }
    
    window.__noopLog('[getAllPositionsVariants] Position length check:', {
        positionsLength: positionsLength,
        willEarlyReturn: !positions || positionsLength === 0
    });
    
    if (!positions || positionsLength === 0) {
        window.__noopLog('[getAllPositionsVariants] 🛡️ EARLY RETURN - No positions checked');
        // Debug logging for early return
        if (window.regularProductDebugLog && window.regularProductDebugLog.steps) {
            window.regularProductDebugLog.steps.push({
                step: 'getAllPositionsVariants_early_return',
                status: 'success',
                details: {
                    reason: 'No positions checked - skipping hidden fields read to prevent stale data',
                    checkedPositions: 0,
                    parentVariantId: ParentVariantId,
                    qty: qty,
                    positionsType: positions ? (positions.jquery ? 'jQuery' : typeof positions) : 'null/undefined',
                    positionsLength: positionsLength
                },
                time: new Date().toISOString()
            });
        }
        // CRITICAL: Console log for visibility - early return prevents reading stale hidden fields
        mrkDebug.log('[Regular Product] 🛡️ SAFEGUARD: getAllPositionsVariants early return - No positions checked', {
            positions: positions ? (positions.jquery ? 'jQuery object' : typeof positions) : 'null/undefined',
            positionsLength: positionsLength,
            parentVariantId: ParentVariantId,
            qty: qty,
            reason: 'Skipping hidden fields read to prevent stale data'
        });
        return allPositionsItem; // Return empty array immediately
    }
    
    window.__noopLog('[getAllPositionsVariants] ✅ Position check passed, continuing...');
    
    window.__noopLog('[getAllPositionsVariants] ✅ Position check passed, continuing...');
    
    // mrkDebug.log('[Regular Product] getAllPositionsVariants called:', {
        // checkedPositions: positions.length,
        // qty: qty,
        // ParentVariantId: ParentVariantId
    // });
    
    // BUG FIX (Order #53563 - BUG 1): Priority-based data source selection
    // Priority 1: Check preserved data from memory (set in addBulkItems)
    // Priority 2: Check DOM hidden fields
    // Priority 3: DOM fallback (later in code)
    var dataSource = 'unknown';
    var hiddenFieldsCount = 0;
    var hiddenFieldsParsed = 0;
    
    window.__noopLog('[getAllPositionsVariants] Checking data sources...');
    
    if (window._preservedPositionData && window._preservedPositionData.length > 0) {
        window.__noopLog('[getAllPositionsVariants] Using preserved memory data:', window._preservedPositionData.length, 'items');
        // Use preserved data from memory (highest priority)
        positionData = window._preservedPositionData;
        dataSource = 'preserved_memory';
        hiddenFieldsParsed = positionData.length;
        
        if (window.regularProductDebugLog && window.regularProductDebugLog.steps) {
            window.regularProductDebugLog.steps.push({
                step: 'position_data_from_preserved_memory',
                status: 'success',
                details: {
                    preservedCount: positionData.length,
                    source: 'preserved_memory',
                    reason: 'Using defensively preserved data from memory (BUG 1 fix)'
                },
                time: new Date().toISOString()
            });
        }
    } else {
        window.__noopLog('[getAllPositionsVariants] Reading from DOM hidden fields...');
        // Fallback to reading from DOM hidden fields
        $('.mrk-hidden-field-item').each(function() {
            hiddenFieldsCount++;
            try {
                var htmlContent = $(this).html();
                if (htmlContent && htmlContent.trim() !== '') {
                    var parsed = JSON.parse(htmlContent);
                    positionData.push(parsed);
                    hiddenFieldsParsed++;
                }
            } catch(e) {
                console.error('[getAllPositionsVariants] Failed to parse hidden field:', e.message);
                // Track parsing errors
                if (window.regularProductDebugLog && window.regularProductDebugLog.warnings) {
                    window.regularProductDebugLog.warnings.push({
                        message: 'Failed to parse hidden field',
                        details: {
                            error: e.message,
                            htmlContentLength: $(this).html().length
                        },
                        time: new Date().toISOString()
                    });
                }
                // mrkDebug.error('[Regular Product] Failed to parse hidden field:', e, $(this).html());
            }
        });
        
        window.__noopLog('[getAllPositionsVariants] Hidden fields processed:', {
            found: hiddenFieldsCount,
            parsed: hiddenFieldsParsed
        });
        
        dataSource = 'hidden_fields';
    }
    
    window.__noopLog('[getAllPositionsVariants] Position data collected:', {
        count: positionData.length,
        source: dataSource
    });
    
    // Track data source
    if (window.regularProductDebugLog && window.regularProductDebugLog.steps) {
        window.regularProductDebugLog.steps.push({
            step: 'positionData_collection',
            status: positionData.length > 0 ? 'success' : 'warning',
            details: {
                hiddenFieldsCount: hiddenFieldsCount,
                hiddenFieldsParsed: hiddenFieldsParsed,
                positionDataCollected: positionData.length,
                checkedPositions: positions.length,
                source: dataSource
            },
            time: new Date().toISOString()
        });
    }
    
    // mrkDebug.log('[Regular Product] Hidden fields found:', positionData.length);
    
    // --------------------------------------------------------------------
    // Hotfix: Deduplicate hidden-field entries per position index
    // --------------------------------------------------------------------
    // When a customer uploads twice and clicks Finish twice, updateMeta() used to
    // append duplicate hidden fields (e.g. two blobs both containing "Position 1",
    // "Logo Id 1", etc.). The old parsing logic treated each blob as the next index
    // (Position 2, Position 3...), producing warnings like positionIndex: 2 and
    // causing stale logo IDs / missing properties in cart items.
    //
    // We dedupe by the index embedded in the property keys so the most recent blob
    // for a given position wins.
    function inferPositionIndexFromHiddenField(obj) {
        if (!obj || typeof obj !== 'object') return null;
        // Prefer explicit "Position N" keys first
        for (var k in obj) {
            if (!Object.prototype.hasOwnProperty.call(obj, k)) continue;
            var m = k.match(/^Position (\d+)$/);
            if (m && m[1]) return parseInt(m[1], 10);
        }
        // Fallback to any of the other indexed keys
        for (var k2 in obj) {
            if (!Object.prototype.hasOwnProperty.call(obj, k2)) continue;
            var m2 = k2.match(/^(?:Application Method|Logo Type|Logo Id|Logo|_logoVariant)\s+(\d+)$/);
            if (m2 && m2[1]) return parseInt(m2[1], 10);
        }
        return null;
    }
    
    if (positionData && positionData.length > 1) {
        try {
            var byIndex = {};
            positionData.forEach(function(item, idx) {
                var inferred = inferPositionIndexFromHiddenField(item) || (idx + 1);
                // Last one wins (most recently appended is typically the latest Finish)
                byIndex[inferred] = item;
            });
            var indices = Object.keys(byIndex)
                .map(function(k) { return parseInt(k, 10); })
                .filter(function(n) { return !isNaN(n) && n > 0; })
                .sort(function(a, b) { return a - b; });
            positionData = indices.map(function(i) { return byIndex[i]; });
        } catch(e) {
            // If anything goes wrong, keep original positionData (best-effort)
        }
    }
    
    // If no hidden fields found or count doesn't match checked positions, collect from DOM
    if (positionData.length === 0 || positionData.length < positions.length) {
        dataSource = 'DOM_fallback';
        // Track DOM fallback
        if (window.regularProductDebugLog && window.regularProductDebugLog.warnings) {
            window.regularProductDebugLog.warnings.push({
                message: 'Hidden fields missing or incomplete, using DOM fallback',
                details: {
                    checkedPositions: positions.length,
                    hiddenFieldsFound: positionData.length,
                    reason: positionData.length === 0 ? 'no_hidden_fields' : 'count_mismatch'
                },
                time: new Date().toISOString()
            });
        }
        // mrkDebug.warn('[Regular Product] Hidden fields missing or incomplete. Checked positions:', positions.length, 'Hidden fields:', positionData.length);
        // mrkDebug.warn('[Regular Product] Collecting position data directly from DOM...');
        
        // CRITICAL FIX: Check if user wants no customization - if so, skip DOM fallback entirely
        var userWantsNoCustomization = window.userWantsNoCustomization === true;
        var timeSinceNoCustomizationClick = window.userWantsNoCustomizationTimestamp 
          ? (Date.now() - window.userWantsNoCustomizationTimestamp) 
          : Infinity;
        
        if (userWantsNoCustomization && timeSinceNoCustomizationClick < 5000) {
          mrkDebug.log('[Regular Product] 🚫 DOM FALLBACK SKIPPED - User wants no customization', {
            timestamp: window.userWantsNoCustomizationTimestamp,
            timeSinceClick: timeSinceNoCustomizationClick,
            positionsLength: positions ? positions.length : 0
          });
          return allPositionsItem; // Return empty array - no position variants
        }
        
        window.__noopLog('[getAllPositionsVariants] Starting DOM fallback parsing...');
        // Collect position data directly from DOM (similar to bundle fallback)
        var domPositionData = [];
        positions.each(function(index) {
            window.__noopLog('[getAllPositionsVariants] Processing position', index + 1, 'of', positions.length);
            var $position = $(this);
            var positionName = $position.val();
            // CRITICAL FIX: Find container that contains the application-method-container
            // Since we remove .logo-position-checked class when clearing, traverse up DOM tree
            var $positionContainer = $position.closest('.logo-position-checked');
            if ($positionContainer.length === 0) {
                // Fallback: traverse up to find parent with application-method-container
                var $parent = $position.parent();
                while ($parent.length > 0 && $parent[0] !== document.body) {
                    if ($parent.find('.application-method-container').length > 0) {
                        $positionContainer = $parent;
                        break;
                    }
                    $parent = $parent.parent();
                }
            }
            // Final fallback: use immediate parent (typical structure: checkbox -> label -> container)
            if ($positionContainer.length === 0) {
                $positionContainer = $position.closest('label').parent();
            }
            
            if ($positionContainer.length === 0) {
                // mrkDebug.warn('[Regular Product] Position container not found for:', positionName);
                return;
            }
            
            // Get application method - also try finding it relative to checkbox if container search failed
            var applicationMethod = 'Print'; // default
            var $applicationInput = $positionContainer.find('.application-method-container-input:checked');
            if ($applicationInput.length === 0) {
                // Fallback: find application method near the checkbox
                $applicationInput = $position.closest('label').siblings('.application-method-container').find('input:checked');
            }
            if ($applicationInput.length) {
                applicationMethod = $applicationInput.val();
            }
            
            // Get variant ID based on application method
            var variantId;
            if (applicationMethod === 'Embroidery') {
                variantId = Number($position.data('embroideryvariant'));
            } else {
                variantId = Number($position.data('printvariant'));
            }
            
            // Get logo type
            var logoType = $positionContainer.attr('data-logo-type') || 
                          ($('[name="logo-type"]:checked').length ? $('[name="logo-type"]:checked').val() : 'Unknown');
            
            // CRITICAL FIX: Extract position index from checkbox name attribute (like getLogoDetails does)
            // This ensures we use the correct index that matches the DOM structure
            var idxPosition = null;
            var positionNameAttr = $position.attr('name');
            if (positionNameAttr) {
                // Extract the last character/number from the name attribute (e.g., "position-1" -> "1")
                var match = positionNameAttr.match(/(\d+)$/);
                if (match) {
                    idxPosition = match[1];
                }
            }
            // Fallback to array index + 1 if name attribute doesn't contain a number
            if (!idxPosition) {
                idxPosition = (index + 1).toString();
            }
            
            // Get logo details
            var logo = '';
            var logo_id = null;
            var logoIdSource = 'not_found';
            var logoUrlSource = 'not_found';
            
            // Try to get logo ID from checkbox data attribute first
            logo_id = $position.attr('data-logo-id') || $position.data('logo-id') || $position.attr('data-logoId') || $position.data('logoId');
            if (logo_id) {
                logoIdSource = 'checkbox_data_attribute';
                logo_id = Number(logo_id);
            }
            
            // If still no logo ID, try to get from logo selection inputs
            if (!logo_id) {
                var $logoSelectionInput = $positionContainer.find('input[type="radio"]:checked[data-logo-id]');
                if ($logoSelectionInput.length === 0) {
                    $logoSelectionInput = $positionContainer.find('input[type="radio"]:checked').first();
                }
                if ($logoSelectionInput.length) {
                    logo_id = $logoSelectionInput.attr('data-logo-id') || $logoSelectionInput.data('logo-id') || $logoSelectionInput.attr('data-logoId') || $logoSelectionInput.data('logoId');
                    if (logo_id) {
                        logoIdSource = 'logo_selection_input';
                        logo_id = Number(logo_id);
                    }
                }
            }
            
            // BUG FIX (Order #53563 - BUG 2): Check session memory before generating random ID
            if (!logo_id && window._currentSessionLogoData) {
                // Try to find logo data by position name in session memory
                var sessionLogoData = window._currentSessionLogoData[positionName];
                if (sessionLogoData && sessionLogoData.logoId) {
                    logo_id = sessionLogoData.logoId;
                    logoIdSource = 'session_memory';
                    
                    if (window.regularProductDebugLog && window.regularProductDebugLog.steps) {
                        window.regularProductDebugLog.steps.push({
                            step: 'logo_id_from_session_memory',
                            status: 'success',
                            details: {
                                positionName: positionName,
                                logoId: logo_id,
                                logoType: sessionLogoData.logoType,
                                source: 'session_memory',
                                reason: 'Retrieved from updateMeta session storage (BUG 2 fix)'
                            },
                            time: new Date().toISOString()
                        });
                    }
                }
            }
            
            // Generate random logo ID only as last resort
            if (!logo_id) {
                logo_id = Math.floor(Math.random() * (999998 + 1));
                logoIdSource = 'random_generated';
                // Track logo ID generation
                if (window.regularProductDebugLog && window.regularProductDebugLog.warnings) {
                    window.regularProductDebugLog.warnings.push({
                        message: 'Generated random logo ID for position (DOM fallback)',
                        details: {
                            positionName: positionName,
                            logoId: logo_id,
                            source: 'DOM_fallback',
                            reason: 'No logo ID found in hidden fields, checkbox, logo selection inputs, or session memory'
                        },
                        time: new Date().toISOString()
                    });
                }
            }
            
            // Get logo URL - try multiple sources
            if (logoType === 'Upload Your Logo') {
                // CRITICAL FIX (LOGO-URL-001): Priority 0 - Check preserved logo URLs from hidden fields
                // CRITICAL FIX (LOGO-URL-003): Fix undefined variable bug - use idxPosition not positionIndex
                if (!logo && window._preservedLogoUrls && window._preservedLogoUrls[idxPosition]) {
                    logo = window._preservedLogoUrls[idxPosition];
                    logoUrlSource = 'preserved_hidden_field_data_attribute';
                    mrkDebug.log('[Regular Product] Logo URL from preserved hidden field data attribute:', {
                        positionName: positionName,
                        positionIndex: idxPosition,
                        logoUrl: logo.substring(0, 60) + '...'
                    });
                }
                
                // Try .input-file-logo first (only if not found in preserved)
                if (!logo) {
                    var $logoInput = $positionContainer.find('.input-file-logo');
                    if ($logoInput.length && $logoInput.val()) {
                        logo = $logoInput.val();
                        logoUrlSource = 'positionContainer_input_file_logo';
                    }
                }
                
                if (!logo) {
                    // Try position-specific container (like getLogoDetails does)
                    var $positionSpecificContainer = $(`.mrk-step-upload-your-logo-position-${idxPosition}`);
                    if ($positionSpecificContainer.length) {
                        var $propInput = $positionSpecificContainer.find('input[name="properties[Uploaded Logo]"]');
                        if ($propInput.length && $propInput.val()) {
                            logo = $propInput.val();
                            logoUrlSource = 'position_specific_container_uploaded_logo';
                        }
                    }
                    // Fallback to properties input in position container
                    if (!logo) {
                        var $propInput = $positionContainer.find('[name="properties[Uploaded Logo]"]');
                        if ($propInput.length && $propInput.val()) {
                            logo = $propInput.val();
                            logoUrlSource = 'positionContainer_properties_uploaded';
                        }
                    }
                    // Last resort: check preview image src
                    if (!logo) {
                        var $previewImg = $positionContainer.find('.mrk-image img, .preview-template img');
                        if ($previewImg.length && $previewImg.attr('src') && $previewImg.attr('src').indexOf('http') === 0) {
                            logo = $previewImg.attr('src');
                            logoUrlSource = 'preview_image_src';
                        }
                    }
                    
                    // BUG FIX (Order #53563 - BUG 2): Final fallback - check session memory
                    if (!logo && window._currentSessionLogoData) {
                        var sessionData = window._currentSessionLogoData[positionName];
                        if (sessionData && sessionData.logoUrl) {
                            logo = sessionData.logoUrl;
                            logoUrlSource = 'session_memory';
                            mrkDebug.log('[Regular Product] Upload logo URL from session memory (BUG 2 fix):', {
                                positionName: positionName,
                                logoUrl: logo.substring(0, 60) + '...'
                            });
                        }
                    }
                }
            } else if (logoType === 'Existing Logo') {
                // CRITICAL FIX: Match getLogoDetails approach - search in position-specific container first
                var $positionSpecificContainer = $(`.mrk-step-existing-logo-position-${idxPosition}`);
                if ($positionSpecificContainer.length) {
                    var $propInput = $positionSpecificContainer.find('input[name="properties[Existing Logo]"]');
                    if ($propInput.length && $propInput.val()) {
                        logo = $propInput.val();
                        logoUrlSource = 'position_specific_container_existing_logo';
                    }
                }
                
                // Fallback 1: Check same-logo mode container
                if (!logo) {
                    var $sameLogoInput = $('.input-file-logo-existing-original[name="properties[Existing Logo]"]');
                    if ($sameLogoInput.length && $sameLogoInput.val()) {
                        logo = $sameLogoInput.val();
                        logoUrlSource = 'same_logo_mode_container';
                    }
                }
                
                // Fallback 2: Check .input-file-logo in position container (set by handleInputChange)
                if (!logo) {
                    var $logoInput = $positionContainer.find('.input-file-logo');
                    if ($logoInput.length && $logoInput.val()) {
                        logo = $logoInput.val();
                        logoUrlSource = 'positionContainer_input_file_logo';
                    }
                }
                
                // Fallback 3: Check properties input in position container
                if (!logo) {
                    var $propInput = $positionContainer.find('[name="properties[Existing Logo]"]');
                    if ($propInput.length && $propInput.val()) {
                        logo = $propInput.val();
                        logoUrlSource = 'positionContainer_properties_existing';
                    }
                }
                
                // Fallback 4: Check checked existing logo radio button (expand search to popup/global)
                if (!logo) {
                    // Search globally, not just within position container
                    var $existingLogoRadio = $('.mrk-existing-logo-item:checked');
                    if ($existingLogoRadio.length === 0) {
                        // Also check within popup container
                        $existingLogoRadio = $('.mrk-customizer-popup-form .mrk-existing-logo-item:checked');
                    }
                    if ($existingLogoRadio.length && $existingLogoRadio.val()) {
                        logo = $existingLogoRadio.val();
                        logoUrlSource = 'global_radio_button';
                    }
                }
                
                // Fallback 5: Check preview image src
                if (!logo) {
                    var $previewImg = $positionContainer.find('.mrk-image img, .preview-template img');
                    if ($previewImg.length && $previewImg.attr('src') && $previewImg.attr('src').indexOf('http') === 0) {
                        logo = $previewImg.attr('src');
                        logoUrlSource = 'preview_image_src';
                    }
                }
                
                // BUG FIX (Order #53563 - BUG 2): Fallback 6 - Check session memory
                if (!logo && window._currentSessionLogoData) {
                    var sessionData = window._currentSessionLogoData[positionName];
                    if (sessionData && sessionData.logoUrl) {
                        logo = sessionData.logoUrl;
                        logoUrlSource = 'session_memory';
                        mrkDebug.log('[Regular Product] Logo URL from session memory (BUG 2 fix):', {
                            positionName: positionName,
                            logoUrl: logo.substring(0, 60) + '...'
                        });
                    }
                }
            } else if (logoType === 'Text Logo') {
                // CRITICAL FIX (TEXT-LOGO-001): Read actual text content from DOM
                var textLogoData = {};
                var hasTextContent = false;
                
                // Try position-specific container first (different-logo mode)
                var $textLogoContainer = $(`.mrk-step-text-logo-position-${idxPosition}`);
                if ($textLogoContainer.length) {
                    // Read up to 4 text lines
                    var text1 = $textLogoContainer.find('input.logoText-position-1').val() || '';
                    var text2 = $textLogoContainer.find('input.logoText-position-2').val() || '';
                    var text3 = $textLogoContainer.find('input.logoText-position-3').val() || '';
                    var text4 = $textLogoContainer.find('input.logoText-position-4').val() || '';
                    var color = $textLogoContainer.find('.logoColor-position').val() || '';
                    var font = $textLogoContainer.find('.font-family-position').val() || '';
                    var note = $textLogoContainer.find('textarea.notesLogoText-position').val() || '';
                    
                    mrkDebug.log('[Text Logo DOM Read] position-specific:', {
                        positionName: positionName,
                        text1: text1 || '(empty)',
                        color: color || '(empty)',
                        font: font || '(empty)'
                    });
                    
                    if (text1) {
                        textLogoData.text1 = text1;
                        hasTextContent = true;
                    }
                    if (text2) textLogoData.text2 = text2;
                    if (text3) textLogoData.text3 = text3;
                    if (text4) textLogoData.text4 = text4;
                    if (color) textLogoData.color = color;
                    if (font) textLogoData.font = font;
                    if (note) textLogoData.note = note;
                    
                    logoUrlSource = 'text_logo_position_container';
                }
                
                // Fallback: Try same-logo mode container
                if (!hasTextContent) {
                    // CRITICAL FIX: Try multiple selector patterns to find text inputs
                    // Pattern 1: Same logo mode (.logoText-original)
                    // Pattern 2: Different logo mode (.logoText-position-N)
                    // Pattern 3: Fallback to position-specific containers
                    var text1 = $('.logoText-original-1[name="properties[Text Line]"]').val() || 
                                $(`.logoText-position-${idxPosition}`).val() ||
                                $positionContainer.find('.logoText').val() || '';
                                
                    var text2 = $('.logoText-original-2[name="properties[Text Line 2]"]').val() || 
                                $(`.logoText-position-${idxPosition}-2`).val() ||
                                $positionContainer.find('.logoText-2').val() || '';
                                
                    var text3 = $('.logoText-original-3[name="properties[Text Line 3]"]').val() || 
                                $(`.logoText-position-${idxPosition}-3`).val() ||
                                $positionContainer.find('.logoText-3').val() || '';
                                
                    var text4 = $('.logoText-original-4[name="properties[Text Line 4]"]').val() || 
                                $(`.logoText-position-${idxPosition}-4`).val() ||
                                $positionContainer.find('.logoText-4').val() || '';
                                
                    var color = $('.logoColor-original').val() || 
                                $(`.logoColor-position-${idxPosition}`).val() ||
                                $positionContainer.find('.logoColor').val() || '';
                                
                    var font = $('.font-family-original').val() || 
                               $(`.font-family-position-${idxPosition}`).val() ||
                               $positionContainer.find('.font-family').val() || '';
                    
                    var note = $('.notesLogoText-original').val() || 
                               $(`.notesLogoText-position-${idxPosition}`).val() ||
                               $positionContainer.find('textarea.notesLogoText').val() || '';
                    
                    mrkDebug.log('[Text Logo DOM Read] fallback same-logo:', {
                        positionName: positionName,
                        text1: text1 || '(empty)',
                        color: color || '(empty)',
                        font: font || '(empty)'
                    });
                    
                    if (text1) {
                        textLogoData.text1 = text1;
                        hasTextContent = true;
                    }
                    if (text2) textLogoData.text2 = text2;
                    if (text3) textLogoData.text3 = text3;
                    if (text4) textLogoData.text4 = text4;
                    if (color) textLogoData.color = color;
                    if (font) textLogoData.font = font;
                    if (note) textLogoData.note = note;
                    
                    logoUrlSource = 'text_logo_same_logo_container';
                }
                
                // Store text content in logo variable (will be used for Logo property)
                logo = hasTextContent ? textLogoData.text1 : 'Text Logo';
                
                // Store all text data for later use
                if (hasTextContent) {
                    if (!window._textLogoData) {
                        window._textLogoData = {};
                    }
                    var normalizedKey = normalizePositionKey(positionName);
                    window._textLogoData[normalizedKey] = textLogoData;
                    
                    mrkDebug.log('[Text Logo Storage] Stored text data for position:', {
                        rawPositionName: positionName,
                        normalizedKey: normalizedKey,
                        hasText1: !!textLogoData.text1,
                        text1Preview: textLogoData.text1 ? textLogoData.text1.substring(0, 20) : 'NONE',
                        hasColor: !!textLogoData.color,
                        hasFont: !!textLogoData.font,
                        hasNote: !!textLogoData.note,
                        allKeysInWindow: Object.keys(window._textLogoData)
                    });
                    
                    mrkDebug.log('[Regular Product] Text Logo content captured from DOM:', {
                        positionName: positionName,
                        text1: textLogoData.text1 ? textLogoData.text1.substring(0, 50) : 'empty',
                        hasMultipleLines: !!(textLogoData.text2 || textLogoData.text3 || textLogoData.text4),
                        color: textLogoData.color || 'not set',
                        font: textLogoData.font || 'not set',
                        source: logoUrlSource,
                        idxPosition: idxPosition,
                        inputsFound: {
                            text1Selectors: $('.logoText-original-1[name="properties[Text Line]"]').length + ' + ' + $(`.logoText-position-${idxPosition}`).length + ' + ' + $positionContainer.find('.logoText').length,
                            text2Selectors: $('.logoText-original-2[name="properties[Text Line 2]"]').length + ' + ' + $(`.logoText-position-${idxPosition}-2`).length + ' + ' + $positionContainer.find('.logoText-2').length,
                            colorSelectors: $('.logoColor-original').length + ' + ' + $(`.logoColor-position-${idxPosition}`).length + ' + ' + $positionContainer.find('.logoColor').length
                        }
                    });
                } else {
                    mrkDebug.warn('[Regular Product] Text Logo selected but no text content found:', {
                        positionName: positionName,
                        idxPosition: idxPosition,
                        containerFound: $textLogoContainer.length > 0
                    });
                }
            }
            
            var positionIndex = index + 1;
            
            // Enhanced debug logging for DOM fallback logo retrieval
            mrkDebug.log('[Regular Product] DOM Fallback - Logo retrieved:', {
                positionIndex: positionIndex,
                idxPosition: idxPosition,
                positionName: positionName,
                positionNameAttr: positionNameAttr,
                logoType: logoType,
                logoUrl: logo ? logo.substring(0, 60) + '...' : 'MISSING',
                logoUrlSource: logoUrlSource,
                logoId: logo_id,
                logoIdSource: logoIdSource,
                hasPositionSpecificContainer: $(`.mrk-step-existing-logo-position-${idxPosition}`).length > 0,
                hasSameLogoInput: $('.input-file-logo-existing-original[name="properties[Existing Logo]"]').length > 0,
                hasLogoInput: $positionContainer.find('.input-file-logo').length > 0,
                logoInputValue: $positionContainer.find('.input-file-logo').val() || 'empty',
                hasPropInput: $positionContainer.find('[name="properties[Uploaded Logo]"], [name="properties[Existing Logo]"]').length > 0,
                hasGlobalRadio: $('.mrk-existing-logo-item:checked').length > 0,
                globalRadioValue: $('.mrk-existing-logo-item:checked').val() || 'none'
            });
            
            var positionObj = {
                [`Application Method ${positionIndex}`]: applicationMethod,
                [`Position ${positionIndex}`]: positionName,
                [`Logo Type ${positionIndex}`]: logoType,
                [`Logo Id ${positionIndex}`]: logo_id,
                [`Logo ${positionIndex}`]: logo,
                [`_logoVariant${positionIndex}`]: variantId
            };
            
            domPositionData.push(positionObj);
            // mrkDebug.log('[Regular Product] Collected from DOM - Position', positionIndex, ':', positionName, 'Method:', applicationMethod, 'Variant:', variantId);
        });
        
        // Use DOM data if hidden fields are missing or incomplete
        if (domPositionData.length > positionData.length) {
            // mrkDebug.log('[Regular Product] Using DOM-collected data. Count:', domPositionData.length);
            positionData = domPositionData;
            
            // Track DOM data usage
            if (window.regularProductDebugLog && window.regularProductDebugLog.steps) {
                window.regularProductDebugLog.steps.push({
                    step: 'positionData_DOM_fallback_used',
                    status: 'success',
                    details: {
                        domDataCount: domPositionData.length,
                        hiddenFieldsCount: positionData.length - domPositionData.length,
                        source: 'DOM_fallback'
                    },
                    time: new Date().toISOString()
                });
            }
        }
    }
    
    // If still no data, try sessionStorage
    if (positionData.length === 0) {
        try {
            var stored = JSON.parse(sessionStorage.getItem('bundle_positions') || '[]');
            if (stored.length > 0) {
                // mrkDebug.warn('[Regular Product] No hidden fields found, attempting recovery from sessionStorage');
                stored.forEach(function(item) {
                    if (item.properties) {
                        positionData.push(item.properties);
                    }
                });
            }
        } catch(e) {
            // mrkDebug.warn('[Regular Product] Failed to recover from sessionStorage:', e);
        }
    }
    
    if (positionData.length === 0) {
        // mrkDebug.error('[Regular Product] ❌ CRITICAL: No positions data found! Checked positions:', positions.length);
        // mrkDebug.error('[Regular Product] This will result in missing charges!');
        return allPositionsItem;
    }
    
    // mrkDebug.log('[Regular Product] Processing', positionData.length, 'position data items');
    
    // Process each position data item
    positionData.forEach(function(positionDataItem, index) {
        // Use the embedded index if present (e.g. "Position 1"), otherwise fall back to array order.
        var positionIndex = inferPositionIndexFromHiddenField(positionDataItem) || (index + 1);
        var idxPosition = positionIndex.toString(); // CRITICAL FIX: Declare idxPosition for use in debug logs and position-specific selectors
        var id;
        var isEmbroidery = positionDataItem[`Application Method ${positionIndex}`] == 'Embroidery';
        var positionName = positionDataItem[`Position ${positionIndex}`];
        var logo = positionDataItem[`Logo ${positionIndex}`];
        var logo_id = positionDataItem[`Logo Id ${positionIndex}`];
        var logoType = positionDataItem[`Logo Type ${positionIndex}`] || 'Unknown'; // CRITICAL FIX: Extract logo type from position data
        var logoUrlSource = dataSource === 'hidden_fields' ? 'hidden_fields' : 'preserved_memory'; // CRITICAL FIX: Declare logoUrlSource
        var logoIdSource = 'not_found'; // CRITICAL FIX: Declare logoIdSource (will be set below)
        
        // CRITICAL FIX (v4.3.1): Extract text logo data directly from hidden field / preserved memory data
        // The positionDataItem already contains Logo Text N, Logo Color N, etc. from updateMeta() -> getLogoDetails()
        // Previously, the code relied on window._textLogoData which was only populated in the DOM fallback path
        var textLogoDataFromHiddenField = null;
        if (logoType === 'Text Logo') {
            var ht1 = positionDataItem['Logo Text ' + positionIndex] || '';
            var ht2 = positionDataItem['Logo Text 2 ' + positionIndex] || '';
            var ht3 = positionDataItem['Logo Text 3 ' + positionIndex] || '';
            var ht4 = positionDataItem['Logo Text 4 ' + positionIndex] || '';
            var hColor = positionDataItem['Logo Color ' + positionIndex] || '';
            var hFont = positionDataItem['Logo Font ' + positionIndex] || '';
            var hNote = positionDataItem['Note ' + positionIndex] || '';
            
            if (ht1 || hColor || hFont || hNote) {
                textLogoDataFromHiddenField = {
                    text1: ht1, text2: ht2, text3: ht3, text4: ht4,
                    color: hColor, font: hFont, note: hNote
                };
            }
            
            mrkDebug.log('[getAllPositionsVariants] Text logo data from hidden field:', {
                positionIndex: positionIndex,
                positionName: positionName,
                hasData: !!textLogoDataFromHiddenField,
                text1: ht1 || '(empty)',
                color: hColor || '(empty)',
                font: hFont || '(empty)',
                note: hNote || '(empty)',
                source: dataSource
            });
        }
        
        window.__noopLog('[getAllPositionsVariants] Processing position data item:', {
            positionIndex: positionIndex,
            idxPosition: idxPosition,
            positionName: positionName,
            logoType: logoType,
            hasLogo: !!logo,
            hasLogoId: !!logo_id,
            dataSource: dataSource,
            logoUrlSource: logoUrlSource
        });
        
        // Add debug logging for logo URL
        mrkDebug.log('[Regular Product] Logo URL read for position:', {
          positionIndex: positionIndex,
          positionName: positionName,
          logoUrl: logo ? logo.substring(0, 60) + '...' : 'MISSING',
          logoId: logo_id || 'MISSING',
          dataSource: dataSource
        });
        
        // Track logo ID source - update based on data source and whether logo_id exists
        logoIdSource = dataSource === 'hidden_fields' ? 'hidden_fields' : 'preserved_memory';
        if (!logo_id) {
            logoIdSource = 'missing';
            // Track missing logo ID
            if (window.regularProductDebugLog && window.regularProductDebugLog.warnings) {
                window.regularProductDebugLog.warnings.push({
                    message: 'Logo ID missing for position',
                    details: {
                        positionName: positionName,
                        positionIndex: positionIndex,
                        dataSource: dataSource
                    },
                    time: new Date().toISOString()
                });
            }
        }
        
        // mrkDebug.log('[Regular Product] Processing position', positionIndex, ':', {
            // position: positionName,
            // method: isEmbroidery ? 'Embroidery' : 'Print',
            // logo: logo ? 'Yes' : 'No',
            // logoId: logo_id
        // });
        
        // Find matching position checkbox
        var found = false;
        var variantIdSource = 'unknown';
        positions.each(function() {
            if ($(this).val() == positionName) {
                found = true;
                if (isEmbroidery) {
                    id = Number($(this).data('embroideryvariant'));
                    variantIdSource = 'DOM_embroideryvariant';
                } else {
                    id = Number($(this).data('printvariant'));
                    variantIdSource = 'DOM_printvariant';
                }
                
                // Validate variant ID
                if (!id || id === 0 || isNaN(id)) {
                    // mrkDebug.error('[Regular Product] Invalid variant ID for position:', positionName, {
                        // isEmbroidery: isEmbroidery,
                        // embroideryVariant: $(this).data('embroideryvariant'),
                        // printVariant: $(this).data('printvariant')
                    // });
                    variantIdSource = 'invalid';
                    return false; // Continue to next position
                }
                
                // Validate parent variant ID
                if (!ParentVariantId || ParentVariantId === 0 || isNaN(ParentVariantId)) {
                    // mrkDebug.error('[Regular Product] Invalid ParentVariantId:', ParentVariantId);
                    return false;
                }
                
                // ====================================================================
                // CRITICAL FIX: Quantity Parameter Usage (Order #51231)
                // ====================================================================
                // PROBLEM: The qty parameter passed to getAllPositionsVariants should
                // be used directly when building items. However, if there's any code
                // that reads quantity from hidden fields or other sources, it might
                // overwrite the correct per-size quantity.
                //
                // SOLUTION: Always use the qty parameter directly, and ensure buildItem
                // receives the correct quantity for THIS specific parent variant.
                // ====================================================================
                
                // CRITICAL: Validate quantity matches main product quantity
                // Each position should have the SAME quantity as the main product
                // Use the qty parameter directly - this is the current size's quantity
                var positionQuantity = qty; // Explicitly use the parameter passed to this function
                
                if (positionQuantity <= 0 || isNaN(positionQuantity)) {
                    // mrkDebug.error('[Regular Product] ❌ Invalid quantity for position:', {
                        // position: positionName,
                        // qty: positionQuantity,
                        // ParentVariantId: ParentVariantId
                    // });
                    trackRegularProductError('Invalid quantity for position variant', {
                        position: positionName,
                        qty: positionQuantity,
                        ParentVariantId: ParentVariantId
                    });
                    return false;
                }
                
                // CRITICAL: Use positionQuantity (from qty parameter) directly
                // Do NOT read quantity from hidden fields or other sources
                // BUG FIX (Order #53563 - BUG 4): Pass logo context for debug properties
                var normalizedKey = normalizePositionKey(positionName);
                
                var logoContext = {
                    logoSource: logoType === 'Upload Your Logo' ? 'upload' : 
                                logoType === 'Existing Logo' ? 'existing' : 
                                logoType === 'Text Logo' ? 'text' : 'unknown',
                    logoType: logoType || '',
                    logoValue: logo || '',
                    // CRITICAL FIX (v4.3.1): Prefer text data from hidden field / preserved memory (primary path)
                    // Fallback to window._textLogoData (DOM fallback path) if hidden field data unavailable
                    textLogoData: (logoType === 'Text Logo') 
                                  ? (textLogoDataFromHiddenField 
                                     || (window._textLogoData && window._textLogoData[normalizedKey] ? window._textLogoData[normalizedKey] : null))
                                  : null
                };
                
                // DIAGNOSTIC: Log text logo data retrieval attempt
                if (logoType === 'Text Logo') {
                    mrkDebug.log('[Text Logo Retrieval] Attempted to retrieve text data:', {
                        rawPositionName: positionName,
                        normalizedKey: normalizedKey,
                        logoType: logoType,
                        hasWindow_textLogoData: !!window._textLogoData,
                        keysAvailable: window._textLogoData ? Object.keys(window._textLogoData) : [],
                        keyExists: window._textLogoData ? !!window._textLogoData[normalizedKey] : false,
                        retrievedData: logoContext.textLogoData ? 'YES' : 'NULL',
                        text1FromData: logoContext.textLogoData ? logoContext.textLogoData.text1 : 'NO DATA'
                    });
                }
                
                // DIAGNOSTIC: Log logoContext creation for text logos
                if (logoType === 'Text Logo') {
                    mrkDebug.log('[getAllPositionsVariants] Logo context created for text logo:', {
                        positionName: positionName,
                        idxPosition: idxPosition,
                        hasWindowTextLogoData: !!window._textLogoData,
                        windowTextLogoDataKeys: window._textLogoData ? Object.keys(window._textLogoData) : [],
                        hasDataForThisPosition: window._textLogoData && !!window._textLogoData[normalizedKey],
                        contextHasTextData: !!logoContext.textLogoData,
                        text1FromContext: logoContext.textLogoData ? logoContext.textLogoData.text1 : 'NO TEXT DATA IN CONTEXT'
                    });
                }
                
                // CRITICAL DEBUG (LOGO-URL-001): Log logo URL state before building item
                if (window.regularProductDebugLog && window.regularProductDebugLog.steps) {
                    window.regularProductDebugLog.steps.push({
                        step: 'logo_url_before_buildItem',
                        status: logo ? 'success' : 'warning',
                        details: {
                            positionIndex: idxPosition, // CRITICAL FIX (LOGO-URL-003): was positionIndex (undefined)
                            positionName: positionName,
                            hasLogoUrl: !!logo,
                            logoUrlLength: logo ? logo.length : 0,
                            logoUrlPreview: logo ? logo.substring(0, 60) + '...' : 'MISSING',
                            logoUrlSource: logoUrlSource || 'unknown',
                            logoId: logo_id,
                            logoIdSource: logoIdSource || 'unknown',
                            dataSource: dataSource
                        },
                        time: new Date().toISOString()
                    });
                }
                
                var builtItem = buildItem(id, positionQuantity, ParentVariantId, logo, logo_id, logoContext);
                if (builtItem) {
                    // CRITICAL FIX: Persist the same details we log, otherwise downstream
                    // code sees "unknown" for Position / Application Method and cart validation
                    // can incorrectly think the child item is missing.
                    if (builtItem.properties) {
                        // CRITICAL FIX: Add _logoposition to enable correct index extraction in cart recovery
                        builtItem.properties._logoposition = positionIndex;
                        builtItem.properties.Position = positionName || '';
                        builtItem.properties['Application Method'] = isEmbroidery ? 'Embroidery' : 'Print';
                        var logoTypeValue = positionDataItem[`Logo Type ${positionIndex}`];
                        if (logoTypeValue) builtItem.properties['Logo Type'] = logoTypeValue;
                        var logoVariantValue = positionDataItem[`_logoVariant${positionIndex}`];
                        if (logoVariantValue) builtItem.properties._logoVariant = logoVariantValue;
                        
                        // CRITICAL FIX (TEXT-LOGO-001): Add text logo properties
                        var normalizedKeyForText = normalizePositionKey(positionName);
                        if (logoType === 'Text Logo' && window._textLogoData && window._textLogoData[normalizedKeyForText]) {
                            var textData = window._textLogoData[normalizedKeyForText];
                            
                            mrkDebug.log('[getAllPositionsVariants] Retrieved text data for child:', {
                                position: positionName,
                                normalizedKey: normalizedKeyForText,
                                hasText1: !!textData.text1,
                                text1: textData.text1,
                                hasColor: !!textData.color,
                                hasFont: !!textData.font,
                                hasNote: !!textData.note
                            });
                            
                            if (textData.text1) builtItem.properties['Logo Text'] = textData.text1;
                            if (textData.text2) builtItem.properties['Logo Text 2'] = textData.text2;
                            if (textData.text3) builtItem.properties['Logo Text 3'] = textData.text3;
                            if (textData.text4) builtItem.properties['Logo Text 4'] = textData.text4;
                            if (textData.color) builtItem.properties['Logo Color'] = textData.color;
                            if (textData.font) builtItem.properties['Logo Font'] = textData.font;
                            if (textData.note) builtItem.properties['Note'] = textData.note;
                        }
                    }
                    
                    // Track position variant building with detailed info
                    if (window.regularProductDebugLog && window.regularProductDebugLog.steps) {
                        var variantDetails = {
                            variantId: id,
                            quantity: positionQuantity, // Use positionQuantity, not qty (for clarity)
                            logoId: logo_id || 'missing',
                            position: positionName || 'unknown',
                            applicationMethod: isEmbroidery ? 'Embroidery' : 'Print',
                            parentVariantId: ParentVariantId,
                            variantIdSource: variantIdSource,
                            logoIdSource: logoIdSource,
                            hasLogoId: !!(logo_id),
                            hasPosition: !!(positionName),
                            hasApplicationMethod: true,
                            hasLogo: !!(logo),
                            builtSuccessfully: true,
                            logoType: builtItem.properties['Logo Type'] || null,
                            logoText: builtItem.properties['Logo Text'] || null,
                            logoColor: builtItem.properties['Logo Color'] || null,
                            logoFont: builtItem.properties['Logo Font'] || null,
                            note: builtItem.properties['Note'] || null,
                            hasLogoText: !!(builtItem.properties['Logo Text'])
                        };
                        
                        window.regularProductDebugLog.steps.push({
                            step: 'position_variant_built',
                            status: 'success',
                            details: variantDetails,
                            time: new Date().toISOString()
                        });
                    }
                    
                    // CRITICAL VALIDATION: Ensure built item has correct quantity
                    // Compare against positionQuantity (the qty parameter), not any other source
                    if (builtItem.quantity !== positionQuantity) {
                        // mrkDebug.error('[Regular Product] ❌ QUANTITY MISMATCH! Position variant quantity does not match:', {
                            // position: positionName,
                            // expectedQty: positionQuantity,
                            // actualQty: builtItem.quantity,
                            // id: id,
                            // parentVariantId: ParentVariantId
                        // });
                        trackRegularProductError('Quantity mismatch in built item', {
                            position: positionName,
                            expectedQty: positionQuantity,
                            actualQty: builtItem.quantity,
                            id: id,
                            parentVariantId: ParentVariantId
                        });
                        // Fix the quantity to match the parameter passed to this function
                        builtItem.quantity = positionQuantity;
                        if (builtItem.properties && builtItem.properties._qty) {
                            builtItem.properties._qty = positionQuantity;
                        }
                    }
                    
                    allPositionsItem.push(builtItem);
                    // mrkDebug.log('[Regular Product] ✅ Added position variant:', {
                        // id: id,
                        // position: positionName,
                        // qty: qty,
                        // builtItemQty: builtItem.quantity,
                        // match: builtItem.quantity === qty
                    // });
                } else {
                    // Track failed build
                    if (window.regularProductDebugLog && window.regularProductDebugLog.errors) {
                        window.regularProductDebugLog.errors.push({
                            message: 'buildItem returned null',
                            details: {
                                variantId: id,
                                quantity: qty,
                                logoId: logo_id || 'missing',
                                position: positionName || 'unknown',
                                applicationMethod: isEmbroidery ? 'Embroidery' : 'Print',
                                parentVariantId: ParentVariantId,
                                variantIdSource: variantIdSource,
                                logoIdSource: logoIdSource
                            },
                            time: new Date().toISOString()
                        });
                    }
                    // mrkDebug.error('[Regular Product] buildItem returned null for:', {
                        // id: id,
                        // qty: qty,
                        // ParentVariantId: ParentVariantId,
                        // logo: logo,
                        // logo_id: logo_id
                    // });
                    trackRegularProductError('buildItem returned null', {
                        id: id,
                        qty: qty,
                        position: positionName
                    });
                }
                return false; // Break the loop
            }
        });
        
        if (!found) {
            // mrkDebug.warn('[Regular Product] ⚠️ Position not found in checked positions:', positionName);
        }
    });

    // mrkDebug.log('[Regular Product] ✅ All position variants prepared:', allPositionsItem.length, 'items (Expected:', positions.length, ')');
    
    // CRITICAL VALIDATION: Check for quantity mismatches
    var quantityMismatches = [];
    var expectedQty = qty;
    allPositionsItem.forEach(function(item, index) {
        if (item.quantity !== expectedQty) {
            quantityMismatches.push({
                index: index,
                position: item.properties && item.properties.Position ? item.properties.Position : 'Unknown',
                expectedQty: expectedQty,
                actualQty: item.quantity,
                variantId: item.id
            });
        }
    });
    
    if (quantityMismatches.length > 0) {
        // mrkDebug.error('[Regular Product] ❌ CRITICAL: Quantity mismatches detected!', {
            // mainProductQty: expectedQty,
            // mismatches: quantityMismatches,
            // totalPositions: allPositionsItem.length
        // });
        trackRegularProductError('Quantity mismatches in position variants', {
            mainProductQty: expectedQty,
            mismatches: quantityMismatches,
            totalPositions: allPositionsItem.length
        });
        
        // Fix quantities to match main product
        allPositionsItem.forEach(function(item) {
            if (item.quantity !== expectedQty) {
                // mrkDebug.warn('[Regular Product] 🔧 Fixing quantity from', item.quantity, 'to', expectedQty);
                item.quantity = expectedQty;
                if (item.properties && item.properties._qty) {
                    item.properties._qty = expectedQty;
                }
            }
        });
    }
    
    // Validate all quantities match
    var allQuantitiesMatch = allPositionsItem.every(function(item) {
        return item.quantity === expectedQty;
    });
    
    if (!allQuantitiesMatch) {
        // mrkDebug.error('[Regular Product] ❌ WARNING: Not all position variants have matching quantities!');
        trackRegularProductError('Position variants have mismatched quantities', {
            mainProductQty: expectedQty,
            positionQuantities: allPositionsItem.map(function(item) {
                return {
                    qty: item.quantity,
                    variantId: item.id
                };
            })
        });
    }
    
    if (allPositionsItem.length < positions.length) {
        // mrkDebug.error('[Regular Product] ❌ WARNING: Missing position variants! Expected:', positions.length, 'Got:', allPositionsItem.length);
        trackRegularProductError('Missing position variants', {
            expected: positions.length,
            got: allPositionsItem.length
        });
    }
    
    // Add quantity validation to debug log
    if (window.regularProductDebugLog && window.regularProductDebugLog.data) {
        if (!window.regularProductDebugLog.data.quantityValidation) {
            window.regularProductDebugLog.data.quantityValidation = {};
        }
        window.regularProductDebugLog.data.quantityValidation[ParentVariantId] = {
            mainProductQty: expectedQty,
            positionVariantsCount: allPositionsItem.length,
            allQuantitiesMatch: allQuantitiesMatch,
            quantityMismatches: quantityMismatches,
            positionQuantities: allPositionsItem.map(function(item) {
                return {
                    qty: item.quantity,
                    variantId: item.id,
                    position: item.properties && item.properties.Position ? item.properties.Position : 'Unknown'
                };
            })
        };
    }
    
    window.__noopLog('[getAllPositionsVariants] ✅ Returning', allPositionsItem.length, 'position variants');
    return allPositionsItem;
}

// Helper function to extract position variants from main variant properties
function extractPositionVariantsFromProperties(properties, positions, qty, ParentVariantId) {
  var allPositionsItem = [];
  
  if (!properties || typeof properties !== 'object') {
    // mrkDebug.error('[Regular Product] extractPositionVariantsFromProperties: Invalid properties');
    return allPositionsItem;
  }
  
  // mrkDebug.log('[Regular Product] extractPositionVariantsFromProperties: Processing properties');
  
  // Find all position indices from properties
  var positionIndices = [];
  for (var prop in properties) {
    if (/^Position ?\d+$/.test(prop)) {
      // Tracker conformance (2026-08-20): keys are now "Position1"; the space
      // form "Position 1" is only seen on carts created before the rename.
      var match = prop.match(/^Position ?(\d+)$/);
      if (match && match[1]) {
        var index = parseInt(match[1], 10);
        if (positionIndices.indexOf(index) === -1) {
          positionIndices.push(index);
        }
      }
    }
  }
  
  // mrkDebug.log('[Regular Product] Found position indices:', positionIndices);
  
  // Process each position index
  positionIndices.forEach(function(index) {
    var positionName = properties[`Position ${index}`] || properties[`Position ${index}`];
    var applicationMethod = properties[`Application Method ${index}`] || properties[`Application Method ${index}`] || 'Print';
    var logoType = properties[`Logo Type ${index}`] || properties[`Logo Type ${index}`] || '';
    var logoId = properties[`Logo Id ${index}`] || properties[`Logo Id ${index}`] || '';
    var logoVariant = properties[`_logoVariant${index}`] || '';
    var logo = properties[`Logo ${index}`] || properties[`Logo ${index}`] || '';
    
    // Get logo text fields
    var logoText = properties[`Logo Text ${index}`] || '';
    var logoText2 = properties[`Logo Text 2 ${index}`] || '';
    var logoText3 = properties[`Logo Text 3 ${index}`] || '';
    var logoText4 = properties[`Logo Text 4 ${index}`] || '';
    var logoColor = properties[`Logo Color ${index}`] || '';
    var logoFont = properties[`Logo Font ${index}`] || '';
    
    if (!positionName) {
      // mrkDebug.warn('[Regular Product] Position name missing for index', index);
      return; // Skip this position
    }
    
    // Find matching position checkbox in DOM to get variant ID
    var variantID = null;
    var $positionCheckbox = positions.filter(function() {
      return $(this).val() === positionName;
    });
    
    if ($positionCheckbox.length > 0) {
      if (applicationMethod === 'Embroidery') {
        variantID = Number($positionCheckbox.data('embroideryvariant'));
      } else {
        variantID = Number($positionCheckbox.data('printvariant'));
      }
    }
    
    // If we couldn't find variant ID from DOM, try to find it from all position checkboxes
    if (!variantID || variantID === 0 || isNaN(variantID)) {
      // Try to find by position name in all checkboxes
      $('.logo-position-checkbox').each(function() {
        if ($(this).val() === positionName) {
          if (applicationMethod === 'Embroidery') {
            variantID = Number($(this).data('embroideryvariant'));
          } else {
            variantID = Number($(this).data('printvariant'));
          }
          return false; // Break the loop
        }
      });
    }
    
    if (!variantID || variantID === 0 || isNaN(variantID)) {
      // mrkDebug.error('[Regular Product] ❌ Cannot determine variant ID for position from properties:', {
        // positionName: positionName,
        // applicationMethod: applicationMethod,
        // index: index,
        // logoVariant: logoVariant
      // });
      trackRegularProductError('Cannot determine variant ID from properties', {
        positionName: positionName,
        applicationMethod: applicationMethod,
        index: index
      });
      return; // Skip this position
    }
    
    // Validate parent variant ID
    if (!ParentVariantId || ParentVariantId === 0 || isNaN(ParentVariantId)) {
      // mrkDebug.error('[Regular Product] Invalid ParentVariantId:', ParentVariantId);
      return; // Skip this position
    }
    
    // Build the position variant item
    // BUG FIX (Order #53563 - BUG 4): Pass logo context for debug properties
    var logoContext = {
        logoSource: logoType === 'Upload Your Logo' ? 'upload' : 
                    logoType === 'Existing Logo' ? 'existing' : 
                    logoType === 'Text Logo' ? 'text' : 'unknown',
        logoType: logoType || '',
        logoValue: logo || ''
    };
    var builtItem = buildItem(variantID, qty, ParentVariantId, logo, logoId, logoContext);
    
    if (builtItem) {
      // Add all logo details to properties
      // CRITICAL FIX: Add _logoposition to enable correct index extraction in cart recovery
      builtItem.properties._logoposition = index;
      if (positionName) builtItem.properties.Position = positionName;
      if (applicationMethod) builtItem.properties['Application Method'] = applicationMethod;
      if (logoType) builtItem.properties['Logo Type'] = logoType;
      if (logoVariant) builtItem.properties._logoVariant = logoVariant;
      
      // Add text logo fields if they exist
      if (logoText) builtItem.properties['Logo Text'] = logoText;
      if (logoText2) builtItem.properties['Logo Text 2'] = logoText2;
      if (logoText3) builtItem.properties['Logo Text 3'] = logoText3;
      if (logoText4) builtItem.properties['Logo Text 4'] = logoText4;
      if (logoColor) builtItem.properties['Logo Color'] = logoColor;
      if (logoFont) builtItem.properties['Logo Font'] = logoFont;
      
      // Add note if exists
      var note = properties[`Note ${index}`] || properties[`Note ${index}`] || '';
      if (note) builtItem.properties.Note = note;
      
      allPositionsItem.push(builtItem);
      // mrkDebug.log('[Regular Product] ✅ Extracted position variant from properties:', {
        // position: positionName,
        // qty: qty,
        // variantID: variantID,
        // parentVariantId: ParentVariantId,
        // applicationMethod: applicationMethod
      // });
    } else {
      // mrkDebug.error('[Regular Product] buildItem returned null for properties position:', {
        // variantID: variantID,
        // qty: qty,
        // parentVariantId: ParentVariantId
      // });
    }
  });
  
    return allPositionsItem;
}

function updateContentInfo(image, color) {
    $('.mrk-popup-product-image').attr('src', image);
    $('.selected-color').text(color);
}

function UpdatePositionPrices() {
    const isEmbroidery = $('[name="application-type"]:checked').val() == 'Embroidery' ? true : false;
    var price;
    const positions = $('[name="logo-position"]');
    positions.each(function() {
        if (isEmbroidery) {
            price = Number($(this).data('embroideryprice'));
        } else {
            price = Number($(this).data('printprice'));
        }
        var formatted_price = formatMoney(price);
        $(this).next('.mrk-abs-price-position').html(`+${formatted_price}`)
    })
}

function checkItemInCart(variantId) {
    return new Promise((resolve, reject) => {
        $.get('/cart.js', function(response) {
            var cart = JSON.parse(response);
            for (let item of cart.items) {
                if (item.variant_id == variantId) {
                    resolve(true);
                    return;
                }
            }
            resolve(false);
        }).fail(function(error) {
            // mrkDebug.log("Error fetching cart:", error);
            reject(error);
        });
    });
}
/**
 * FIX: Logo Item Missing from Orders (Bugs #52426, #52358)
 * Date: 2026-08-20
 * Version: 7.0.0
 * 
 * PROBLEM #52426:
 * Logo/print charge line items were being prepared and sent to Cart API, but were
 * disappearing before order creation. Customer received customized products but JRS
 * only charged for blank products, resulting in revenue loss.
 * 
 * PROBLEM #52358:
 * Regular products with customization were NOT adding logo position variants as
 * separate line items. Debug logs showed cart_data_prepared with 2 items, but the
 * Cart API call steps were missing, suggesting the request wasn't being sent correctly.
 * 
 * ROOT CAUSES:
 * 1. Cart API call was sending data as form-encoded instead of JSON (jQuery.ajax default)
 * 2. Debug log saved BEFORE Cart API call, so response steps never persisted to order
 * 3. No debug logging BEFORE Cart API call, so failures were silent
 * 4. No verification that all items were added before allowing navigation
 * 5. No immediate recovery for missing items detected in Cart API response
 * 
 * SOLUTION:
 * 1. Fixed Cart API call to send JSON properly (contentType: 'application/json', JSON.stringify)
 * 2. Added debug logging BEFORE Cart API call (cart_add_request_sending, cart_add_request_sent)
 * 3. Persist updated debug log AFTER Cart API response (to cart attributes and item properties)
 * 4. Verify all requested items are present in Cart API response before navigation
 * 5. Add immediate recovery for missing items (retry adding individually)
 * 6. Block navigation if items are missing and recovery fails
 * 7. Enhanced logging for Cart API request/response payload
 * 
 * TESTING:
 * - Add regular product with logo customization
 * - Verify debug log includes cart_add_request_sent and cart_add_response_received steps
 * - Verify all logo items appear in cart as separate line items
 * - Complete checkout and verify order contains both main product and logo items
 * - Check order properties for complete debug log
 */
// Customization add-to-cart. Reads .mrk-qty-item and data-variant-id from the form (same contract
// as initSingleAdd; pdp-multistep-form-v2 populates these via _syncHiddenInputs before Step 3 / Finish).
async function addBulkItems() {
  window.__noopLog("[addBulkItems] ✅ Function called!");
  
  // CRITICAL FIX: Clear captured positions state IMMEDIATELY if flag is set
  // This prevents stale captured state from previous add-to-cart attempts
  if (window.userWantsNoCustomization === true) {
    var timeSinceFlag = window.userWantsNoCustomizationTimestamp 
      ? (Date.now() - window.userWantsNoCustomizationTimestamp) 
      : Infinity;
    
    if (timeSinceFlag < 5000) {
      if (window.capturedPositionsForAddToCart) {
        window.capturedPositionsForAddToCart = [];
        mrkDebug.log('[Regular Product] 🧹 IMMEDIATE CLEAR: Cleared captured positions state at start (flag is set)', {
          timestamp: window.userWantsNoCustomizationTimestamp,
          timeSinceClick: timeSinceFlag
        });
      }
    }
  }
  
  // Initialize debug log for regular products
  window.regularProductDebugLog = {
    timestamp: new Date().toISOString(),
    theme: typeof JRS_THEME_NAME !== 'undefined' ? JRS_THEME_NAME : 'base',
    themeVersion: _themeVersion,
    version: '7.0.0',
    buildDate: '2026-08-20',
    steps: [],
    warnings: [],
    errors: [],
    data: {}
  };
  var debugLog = window.regularProductDebugLog;
  
  function addDebugStep(step, status, details) {
    if (debugLog && debugLog.steps) {
      debugLog.steps.push({
        step: step,
        status: status,
        details: details || {},
        time: new Date().toISOString()
      });
    }
  }
  
  function addDebugWarning(message, details) {
    if (debugLog && debugLog.warnings) {
      debugLog.warnings.push({
        message: message,
        details: details || {},
        time: new Date().toISOString()
      });
    }
  }
  
  function addDebugError(message, details) {
    if (debugLog && debugLog.errors) {
      debugLog.errors.push({
        message: message,
        details: details || {},
        time: new Date().toISOString()
      });
    }
  }
  
  addDebugStep('addBulkItems_started', 'success', {
    timestamp: new Date().toISOString()
  });
  var stepEl = document.querySelector('.mrk-multistep');
  var currentStep = stepEl ? stepEl.getAttribute('data-step-number') : '';
  if (typeof trackCustomizerUserAction === 'function') trackCustomizerUserAction('add_to_cart_clicked', { step: currentStep });
  
  try {
    window.__noopLog("[addBulkItems] Starting try block...");
    
    // CRITICAL FIX (Order #67156086817141): Prevent duplicate addBulkItems calls
    if (!window.lastAddBulkItemsTimestamp) {
      window.lastAddBulkItemsTimestamp = 0;
    }
    
    var timeSinceLastAdd = Date.now() - window.lastAddBulkItemsTimestamp;
    
    window.__noopLog("[addBulkItems] Duplicate check:", {
      timeSinceLastAdd: timeSinceLastAdd,
      willBlock: timeSinceLastAdd < 10000 && timeSinceLastAdd > 0
    });
    
    if (timeSinceLastAdd < 10000 && timeSinceLastAdd > 0) {
      window.__noopLog('[addBulkItems] 🚫 BLOCKED duplicate call within 10s');
      mrkDebug.warn('[Cart] 🚫 BLOCKED duplicate addBulkItems call within 10s', {
        timeSinceLastAdd: timeSinceLastAdd,
        lastTimestamp: window.lastAddBulkItemsTimestamp,
        currentTimestamp: Date.now()
      });
      
      addDebugStep('duplicate_add_blocked', 'success', {
        reason: 'Blocked duplicate addBulkItems call within 10 seconds',
        timeSinceLastAdd: timeSinceLastAdd
      });
      
      return;
    }
    
    window.lastAddBulkItemsTimestamp = Date.now();
    window.__noopLog("[addBulkItems] ✅ Duplicate check passed");
    
    // CRITICAL FIX (Order #67156086817141): Check for bfcache restoration
    if (window.bfcacheRestored === true) {
      var timeSinceBfcache = Date.now() - (window.bfcacheRestoredTimestamp || 0);
      
      window.__noopLog("[addBulkItems] bfcache check:", {
        bfcacheRestored: window.bfcacheRestored,
        timeSinceBfcache: timeSinceBfcache,
        willBlock: timeSinceBfcache < 30000
      });
      
      if (timeSinceBfcache < 30000) {
        window.__noopLog('[addBulkItems] 🚫 BLOCKED due to bfcache restoration');
        mrkDebug.warn('[Cart] 🚫 BLOCKED add-to-cart after bfcache restoration', {
          timeSinceBfcache: timeSinceBfcache
        });
        
        addDebugStep('bfcache_add_blocked', 'success', {
          reason: 'Blocked add-to-cart shortly after Safari bfcache restoration',
          timeSinceBfcache: timeSinceBfcache
        });
        
        return;
      }
    }
    
    // CRITICAL FIX (Order #67156086817141): Block naked adds for customizable products
    var checkedPositions = $('.logo-position-checkbox:checked').length;
    var hiddenFieldsCount = $('.mrk-hidden-field-item').length;
    var hasCustomizationEnabled = window.customizationEnabled === true;
    
    // Check if this is a phantom/stale submission
    if (hasCustomizationEnabled && checkedPositions === 0 && hiddenFieldsCount === 0) {
      // Additional check: If this submission happens >30 seconds after page load, it's likely stale
      var timeSincePageLoad = Date.now() - (window.pageLoadTimestamp || Date.now());
      
      if (timeSincePageLoad > 30000) {
        mrkDebug.warn('[Cart] 🚫 BLOCKED phantom add-to-cart: customizable product with no data after 30s', {
          timeSincePageLoad: timeSincePageLoad,
          checkedPositions: checkedPositions,
          hiddenFieldsCount: hiddenFieldsCount,
          hasCustomizationEnabled: hasCustomizationEnabled
        });
        
        addDebugStep('phantom_add_blocked', 'success', {
          reason: 'Blocked stale add-to-cart for customizable product with no customization data',
          timeSincePageLoad: timeSincePageLoad,
          checkedPositions: checkedPositions,
          hiddenFieldsCount: hiddenFieldsCount
        });
        
        return; // Block the add
      }
    }
    
    // CRITICAL FIX: Debug logging to trace flag state
    mrkDebug.log('[Regular Product] 🔍 FLAG CHECK AT START:', {
      flagExists: typeof window.userWantsNoCustomization !== 'undefined',
      flagValue: window.userWantsNoCustomization,
      timestampExists: typeof window.userWantsNoCustomizationTimestamp !== 'undefined',
      timestamp: window.userWantsNoCustomizationTimestamp,
      currentTime: Date.now(),
      timeSinceClick: window.userWantsNoCustomizationTimestamp 
        ? (Date.now() - window.userWantsNoCustomizationTimestamp) 
        : 'N/A'
    });
    
    // CRITICAL FIX: Check if user clicked "No, buy plain" - if so, skip ALL position logic
    var userWantsNoCustomization = window.userWantsNoCustomization === true;
    var timeSinceNoCustomizationClick = window.userWantsNoCustomizationTimestamp 
      ? (Date.now() - window.userWantsNoCustomizationTimestamp) 
      : Infinity;
    
    mrkDebug.log('[Regular Product] 🔍 FLAG EVALUATION:', {
      userWantsNoCustomization: userWantsNoCustomization,
      timeSinceClick: timeSinceNoCustomizationClick,
      willSkip: userWantsNoCustomization && timeSinceNoCustomizationClick < 5000
    });
    
    // Flag expires after 5 seconds to prevent stale state
    if (userWantsNoCustomization && timeSinceNoCustomizationClick < 5000) {
      mrkDebug.log('[Regular Product] 🚫 USER CLICKED "NO, BUY PLAIN" - Skipping ALL position logic', {
        timestamp: window.userWantsNoCustomizationTimestamp,
        timeSinceClick: timeSinceNoCustomizationClick
      });
      
      addDebugStep('no_customization_selected', 'success', {
        reason: 'User clicked "No, buy plain" - skipping all position logic',
        timestamp: window.userWantsNoCustomizationTimestamp
      });
      
      // CRITICAL FIX: Clear captured positions state to prevent stale data
      if (window.capturedPositionsForAddToCart) {
        window.capturedPositionsForAddToCart = [];
        mrkDebug.log('[Regular Product] 🧹 CLEARED captured positions state (flag detected at start)');
      }
      
      // DON'T clear the flag immediately - clear it at the end of this path to prevent race conditions
      // This ensures if addBulkItems() is called multiple times, the flag persists
      
      // Skip ALL checkbox capture and position logic
      // Go directly to adding main variants only
      var sizes = $('.mrk-qty-item');
      if (!sizes || sizes.length === 0) {
        addDebugError('No size/quantity items found', {});
        return;
      }
      
      var ids = [];
      var hasValidItems = false;
      
      sizes.each(function() {
        var qty = Number($(this).val());
        var ParentVariantId = Number($(this).data('variant-id'));
        
        if (isNaN(qty) || qty <= 0) {
          return;
        }
        
        if (!ParentVariantId || isNaN(ParentVariantId) || ParentVariantId === 0) {
          return;
        }
        
        // Add main variant ONLY - no position variants
        try {
          const mainVariant = buildMainVariant(ParentVariantId, qty, false);
          if (mainVariant && mainVariant.id) {
            ids.push(mainVariant);
            hasValidItems = true;
            addDebugStep('main_variant_added_no_customization', 'success', {
              variantId: ParentVariantId,
              quantity: qty,
              reason: 'User selected "No, buy plain" - main variant only'
            });
          }
        } catch (e) {
          mrkDebug.error('[Regular Product] Error building main variant (no customization):', e);
          addDebugError('Error building main variant (no customization)', {
            error: e.message,
            parentVariantId: ParentVariantId
          });
        }
      });
      
      if (!hasValidItems || ids.length === 0) {
        addDebugError('No valid items to add (no customization path)', {
          sizesFound: sizes.length
        });
        return;
      }
      
      var data = { items: ids };
      
      // Continue with normal add-to-cart flow (skip all position validation)
      if (window.updates != undefined && Object.keys(window.updates).length > 0) {
        $('.mrk-loader-main').css('display', 'flex');
        jQuery.post(window.Shopify.routes.root + 'cart/update.js', {
          updates: window.updates
        }, function(response) {
          if (!response || response.status) {
            $('.mrk-loader-main').css('display', 'none');
            // Clear flag before returning
            window.userWantsNoCustomization = false;
            delete window.userWantsNoCustomizationTimestamp;
            mrkDebug.log('[Regular Product] 🧹 CLEARED flag (cart update failed)');
            return;
          }
          var refreshCart = true;
          // Clear flag before calling addItemToCart
          window.userWantsNoCustomization = false;
          delete window.userWantsNoCustomizationTimestamp;
          mrkDebug.log('[Regular Product] 🧹 CLEARED flag (before addItemToCart - path 1)');
          addItemToCart(data, refreshCart);
        }).fail(function(jqXHR, textStatus, errorThrown) {
          $('.mrk-loader-main').css('display', 'none');
          // Clear flag on error
          window.userWantsNoCustomization = false;
          delete window.userWantsNoCustomizationTimestamp;
          mrkDebug.log('[Regular Product] 🧹 CLEARED flag (cart update error)');
          trackRegularProductError('Cart update failed (no customization path)', {
            status: jqXHR.status,
            statusText: textStatus,
            errorThrown: errorThrown
          });
        });
      } else {
        var refreshCart = false;
        // Clear flag before calling addItemToCart
        window.userWantsNoCustomization = false;
        delete window.userWantsNoCustomizationTimestamp;
        mrkDebug.log('[Regular Product] 🧹 CLEARED flag (before addItemToCart - path 2)');
        addItemToCart(data, refreshCart);
      }
      
      return; // Exit early - don't run any position logic
    }
    
    window.__noopLog("[addBulkItems] ✅ Normal flow - user wants customization");
    
    // Normal flow continues here (user wants customization or flag not set)
    // CRITICAL FIX: Double-check flag hasn't been set between initial check and here
    // This prevents race conditions where flag is set after initial check but before position capture
    var flagCheckBeforeCapture = window.userWantsNoCustomization === true;
    var timeSinceFlagBeforeCapture = window.userWantsNoCustomizationTimestamp 
      ? (Date.now() - window.userWantsNoCustomizationTimestamp) 
      : Infinity;
    
    mrkDebug.log('[Regular Product] 🔍 FLAG CHECK BEFORE POSITION CAPTURE:', {
      flagExists: typeof window.userWantsNoCustomization !== 'undefined',
      flagValue: window.userWantsNoCustomization,
      timestampExists: typeof window.userWantsNoCustomizationTimestamp !== 'undefined',
      timestamp: window.userWantsNoCustomizationTimestamp,
      currentTime: Date.now(),
      timeSinceClick: timeSinceFlagBeforeCapture,
      willSkipCapture: flagCheckBeforeCapture && timeSinceFlagBeforeCapture < 5000
    });
    
    window.__noopLog("[addBulkItems] Second flag check before capture:", {
      flagCheckBeforeCapture: flagCheckBeforeCapture,
      timeSinceFlagBeforeCapture: timeSinceFlagBeforeCapture,
      willSkip: flagCheckBeforeCapture && timeSinceFlagBeforeCapture < 5000
    });
    
    if (flagCheckBeforeCapture && timeSinceFlagBeforeCapture < 5000) {
      window.__noopLog('[addBulkItems] 🚫 FLAG DETECTED - Skipping to no-customization path');
      mrkDebug.log('[Regular Product] 🚫 FLAG DETECTED BEFORE POSITION CAPTURE - Skipping position capture', {
        timestamp: window.userWantsNoCustomizationTimestamp,
        timeSinceClick: timeSinceFlagBeforeCapture
      });
      
      // Clear any existing captured positions state
      if (window.capturedPositionsForAddToCart) {
        window.capturedPositionsForAddToCart = [];
      }
      
      // DON'T clear the flag immediately - clear it at the end of this path to prevent race conditions
      // This ensures if addBulkItems() is called multiple times, the flag persists
      
      // Skip to no-customization path (same as early return above)
      var sizes = $('.mrk-qty-item');
      if (!sizes || sizes.length === 0) {
        addDebugError('No size/quantity items found', {});
        return;
      }
      
      var ids = [];
      var hasValidItems = false;
      
      sizes.each(function() {
        var qty = Number($(this).val());
        var ParentVariantId = Number($(this).data('variant-id'));
        
        if (isNaN(qty) || qty <= 0) {
          return;
        }
        
        if (!ParentVariantId || isNaN(ParentVariantId) || ParentVariantId === 0) {
          return;
        }
        
        try {
          const mainVariant = buildMainVariant(ParentVariantId, qty, false);
          if (mainVariant && mainVariant.id) {
            ids.push(mainVariant);
            hasValidItems = true;
            addDebugStep('main_variant_added_no_customization', 'success', {
              variantId: ParentVariantId,
              quantity: qty,
              reason: 'Flag detected before position capture - main variant only'
            });
          }
        } catch (e) {
          mrkDebug.error('[Regular Product] Error building main variant (no customization):', e);
          addDebugError('Error building main variant (no customization)', {
            error: e.message,
            parentVariantId: ParentVariantId
          });
        }
      });
      
      if (!hasValidItems || ids.length === 0) {
        addDebugError('No valid items to add (no customization path)', {
          sizesFound: sizes.length
        });
        return;
      }
      
      var data = { items: ids };
      
      if (window.updates != undefined && Object.keys(window.updates).length > 0) {
        $('.mrk-loader-main').css('display', 'flex');
        jQuery.post(window.Shopify.routes.root + 'cart/update.js', {
          updates: window.updates
        }, function(response) {
          if (!response || response.status) {
            $('.mrk-loader-main').css('display', 'none');
            // Clear flag before returning
            window.userWantsNoCustomization = false;
            delete window.userWantsNoCustomizationTimestamp;
            mrkDebug.log('[Regular Product] 🧹 CLEARED flag (cart update failed - path 2)');
            return;
          }
          var refreshCart = true;
          // Clear flag before calling addItemToCart
          window.userWantsNoCustomization = false;
          delete window.userWantsNoCustomizationTimestamp;
          mrkDebug.log('[Regular Product] 🧹 CLEARED flag (before addItemToCart - path 3)');
          addItemToCart(data, refreshCart);
        }).fail(function(jqXHR, textStatus, errorThrown) {
          $('.mrk-loader-main').css('display', 'none');
          // Clear flag on error
          window.userWantsNoCustomization = false;
          delete window.userWantsNoCustomizationTimestamp;
          mrkDebug.log('[Regular Product] 🧹 CLEARED flag (cart update error - path 2)');
          trackRegularProductError('Cart update failed (no customization path)', {
            status: jqXHR.status,
            statusText: textStatus,
            errorThrown: errorThrown
          });
        });
      } else {
        var refreshCart = false;
        // Clear flag before calling addItemToCart
        window.userWantsNoCustomization = false;
        delete window.userWantsNoCustomizationTimestamp;
        mrkDebug.log('[Regular Product] 🧹 CLEARED flag (before addItemToCart - path 4)');
        addItemToCart(data, refreshCart);
      }
      
      return; // Exit early - don't run any position logic
    }
    
    window.__noopLog("[addBulkItems] ✅ Passed second flag check, continuing...");
    
    // CRITICAL FIX: Final flag check before position capture logic
    // This provides a final safeguard against stale checkbox state
    var finalFlagCheck = window.userWantsNoCustomization === true;
    var timeSinceFinalFlagCheck = window.userWantsNoCustomizationTimestamp 
      ? (Date.now() - window.userWantsNoCustomizationTimestamp) 
      : Infinity;
    
    window.__noopLog("[addBulkItems] Final flag check:", {
      finalFlagCheck: finalFlagCheck,
      timeSinceFinalFlagCheck: timeSinceFinalFlagCheck,
      willSkip: finalFlagCheck && timeSinceFinalFlagCheck < 5000
    });
    
    if (finalFlagCheck && timeSinceFinalFlagCheck < 5000) {
      window.__noopLog('[addBulkItems] 🚫 FINAL FLAG - Skipping to no-customization');
      mrkDebug.log('[Regular Product] 🚫 FINAL FLAG CHECK - Flag detected before position capture, skipping all position logic', {
        timestamp: window.userWantsNoCustomizationTimestamp,
        timeSinceClick: timeSinceFinalFlagCheck
      });
      
      // Clear captured positions state
      if (window.capturedPositionsForAddToCart) {
        window.capturedPositionsForAddToCart = [];
      }
      
      // Skip to no-customization path
      var sizes = $('.mrk-qty-item');
      if (!sizes || sizes.length === 0) {
        addDebugError('No size/quantity items found', {});
        window.userWantsNoCustomization = false;
        delete window.userWantsNoCustomizationTimestamp;
        return;
      }
      
      var ids = [];
      var hasValidItems = false;
      
      sizes.each(function() {
        var qty = Number($(this).val());
        var ParentVariantId = Number($(this).data('variant-id'));
        
        if (isNaN(qty) || qty <= 0) {
          return;
        }
        
        if (!ParentVariantId || isNaN(ParentVariantId) || ParentVariantId === 0) {
          return;
        }
        
        try {
          const mainVariant = buildMainVariant(ParentVariantId, qty, false);
          if (mainVariant && mainVariant.id) {
            ids.push(mainVariant);
            hasValidItems = true;
          }
        } catch (e) {
          mrkDebug.error('[Regular Product] Error building main variant (final flag check):', e);
        }
      });
      
      if (!hasValidItems || ids.length === 0) {
        addDebugError('No valid items to add (final flag check)', {
          sizesFound: sizes.length
        });
        window.userWantsNoCustomization = false;
        delete window.userWantsNoCustomizationTimestamp;
        return;
      }
      
      var data = { items: ids };
      
      // Clear flag before proceeding
      window.userWantsNoCustomization = false;
      delete window.userWantsNoCustomizationTimestamp;
      mrkDebug.log('[Regular Product] 🧹 CLEARED flag (final flag check path)');
      
      if (window.updates != undefined && Object.keys(window.updates).length > 0) {
        $('.mrk-loader-main').css('display', 'flex');
        jQuery.post(window.Shopify.routes.root + 'cart/update.js', {
          updates: window.updates
        }, function(response) {
          if (!response || response.status) {
            $('.mrk-loader-main').css('display', 'none');
            return;
          }
          var refreshCart = true;
          addItemToCart(data, refreshCart);
        }).fail(function(jqXHR, textStatus, errorThrown) {
          $('.mrk-loader-main').css('display', 'none');
          trackRegularProductError('Cart update failed (final flag check)', {
            status: jqXHR.status,
            statusText: textStatus,
            errorThrown: errorThrown
          });
        });
      } else {
        var refreshCart = false;
        addItemToCart(data, refreshCart);
      }
      
      return; // Exit early - don't run any position logic
    }
    
    // BUG FIX (Order #53563 - BUG 1): Defensive hidden field data preservation
    // Even though WARN-2 fix preserves DOM hidden fields, we also preserve data in memory
    // as a failsafe in case any code path clears them unexpectedly
    var preservedHiddenFieldData = [];
    var logoUrlsFromHiddenFields = {}; // CRITICAL FIX (LOGO-URL-001)
    
    $('.mrk-hidden-field-item').each(function() {
      try {
        var htmlContent = $(this).html();
        if (htmlContent && htmlContent.trim() !== '') {
          var data = JSON.parse(htmlContent);
          // Bug #2: Deep clone so no shared reference can be mutated
          preservedHiddenFieldData.push(JSON.parse(JSON.stringify(data)));
        }
        
        // CRITICAL FIX (LOGO-URL-001): Also extract logo URL from data attribute
        var logoUrl = $(this).attr('data-logo-url');
        var positionIndex = $(this).attr('data-position-index');
        if (logoUrl && positionIndex) {
          logoUrlsFromHiddenFields[positionIndex] = logoUrl;
        }
      } catch(e) {
        addDebugWarning('Failed to preserve hidden field in memory', { 
          error: e.message,
          htmlLength: $(this).html().length 
        });
      }
    });
    
    // Bug #2: One frozen snapshot for entire addBulkItems run (used in every size iteration)
    window._frozenAddToCartData = JSON.parse(JSON.stringify(preservedHiddenFieldData));
    // Store globally for getAllPositionsVariants to use as Priority 1 source
    window._preservedPositionData = preservedHiddenFieldData;
    window._preservedLogoUrls = logoUrlsFromHiddenFields; // CRITICAL FIX (LOGO-URL-001)
    
    if (preservedHiddenFieldData.length > 0) {
      addDebugStep('hidden_field_data_preserved_in_memory', 'success', {
        preservedCount: preservedHiddenFieldData.length,
        reason: 'Defensive preservation - data stored in memory before any potential clearing'
      });
    }
    
    // FIXED (WARN-2): Don't clear hidden fields at start - they were just created by updateMeta()
    // and contain fresh data. Clearing them here causes getAllPositionsVariants to fall back to
    // DOM parsing, which generates random logo IDs. Hidden fields should persist across add-to-cart
    // attempts since updateMeta() clears and recreates them each time.
    var hiddenFieldsBeforeClear = $('.mrk-hidden-field-item').length;
    
    // Log hidden fields state without clearing them
    if (hiddenFieldsBeforeClear > 0) {
      addDebugStep('hidden_fields_preserved', 'success', {
        count: hiddenFieldsBeforeClear,
        reason: 'Hidden fields created by updateMeta - will be read by getAllPositionsVariants'
      });
    }
    
    // CRITICAL FIX: Check flag BEFORE capturing checkboxes to prevent reading stale state
    // Only query for checkboxes if flag is NOT set - this prevents any stale checkbox state
    // from being read if flag is set
    var checkedCheckboxesBeforeClear = null;
    var capturedPositionsState = [];
    
    // Only query for checkboxes if flag is NOT set
    if (!flagCheckBeforeCapture || timeSinceFlagBeforeCapture >= 5000) {
      // Flag is NOT set or expired - safe to capture checkbox state
      // CRITICAL FIX: Scope checkbox query to popup (where checkboxes actually are)
      // Checkboxes are inside .mrk-customizer-popup-form, not inside product-form-mrk
      var $popup = $('.mrk-customizer-popup-form').first();
      if ($popup.length === 0) {
        // Fallback: try product form if popup not found
        var $productForm = $('product-form-mrk').first();
        if ($productForm.length > 0) {
          checkedCheckboxesBeforeClear = $productForm.find('.logo-position-checkbox:checked');
          mrkDebug.log('[Regular Product] ⚠️ No popup found - using product form fallback', {
            formFound: true,
            checkedCount: checkedCheckboxesBeforeClear.length
          });
        } else {
          // Final fallback: global query
          checkedCheckboxesBeforeClear = $('.logo-position-checkbox:checked');
          mrkDebug.log('[Regular Product] ⚠️ No popup or form found - using global checkbox query');
        }
      } else {
        // Scope to checkboxes within the popup (where they actually are)
        checkedCheckboxesBeforeClear = $popup.find('.logo-position-checkbox:checked');
        mrkDebug.log('[Regular Product] ✅ Scoped checkbox query to popup', {
          popupFound: true,
          checkedCount: checkedCheckboxesBeforeClear.length
        });
      }
      capturedPositionsState = checkedCheckboxesBeforeClear.map(function() {
        return {
          element: this,
          positionName: $(this).attr('data-position-name') || $(this).val(),
          checked: true
        };
      }).get();
    } else {
      // Flag is set - skip checkbox query entirely to prevent reading stale state
      checkedCheckboxesBeforeClear = $(); // Empty jQuery object
      mrkDebug.log('[Regular Product] 🚫 SKIPPING checkbox query - flag detected before capture', {
        flagCheck: flagCheckBeforeCapture,
        timeSinceClick: timeSinceFlagBeforeCapture,
        note: 'Checkboxes not queried to prevent stale state capture'
      });
    }

    // Log capture status - show whether positions were actually captured or skipped
    if (checkedCheckboxesBeforeClear && checkedCheckboxesBeforeClear.length > 0) {
      mrkDebug.log('[Regular Product] 🧹 CAPTURED POSITION CHECKBOXES BEFORE CLEAR:', {
        checkedCount: checkedCheckboxesBeforeClear.length,
        positions: capturedPositionsState.map(function(p) { return p.positionName; }),
        capturedCount: capturedPositionsState.length,
        reason: 'Preserving current selection while clearing stale state',
        flagWasSet: flagCheckBeforeCapture && timeSinceFlagBeforeCapture < 5000
      });
      
      // Clear checkboxes (for next add-to-cart)
      $('.logo-position-checkbox:checked').prop('checked', false);
      
      // Also remove visual indicators (but keep logo-position-checked class for DOM lookups)
      $('.selected-position').removeClass('active');
      // NOTE: We keep .logo-position-checked class because getAllPositionsVariants needs it for DOM fallback
      
      addDebugStep('checkboxes_captured_and_cleared', 'success', {
        capturedCount: checkedCheckboxesBeforeClear.length,
        positionsCaptured: capturedPositionsState.length,
        reason: 'Preserved current selection, cleared for next add-to-cart'
      });
    } else if (flagCheckBeforeCapture && timeSinceFlagBeforeCapture < 5000) {
      // Flag was set - log that capture was skipped
      mrkDebug.log('[Regular Product] 🚫 CHECKBOX CAPTURE SKIPPED - Flag detected:', {
        flagCheck: flagCheckBeforeCapture,
        timeSinceClick: timeSinceFlagBeforeCapture,
        capturedPositionsStateLength: capturedPositionsState.length,
        note: 'No checkboxes queried or captured due to flag'
      });
    }

    // CRITICAL FIX: Final check before storing captured state - ensure it's empty if flag is set
    // This provides a final safeguard against stale captured state
    var finalFlagCheckBeforeStore = window.userWantsNoCustomization === true;
    var timeSinceFinalFlagCheckBeforeStore = window.userWantsNoCustomizationTimestamp 
      ? (Date.now() - window.userWantsNoCustomizationTimestamp) 
      : Infinity;
    
    if (finalFlagCheckBeforeStore && timeSinceFinalFlagCheckBeforeStore < 5000) {
      // Force empty array if flag is set
      capturedPositionsState = [];
      mrkDebug.log('[Regular Product] 🚫 FORCING EMPTY captured state before store - flag detected', {
        timestamp: window.userWantsNoCustomizationTimestamp,
        timeSinceClick: timeSinceFinalFlagCheckBeforeStore,
        previousCapturedCount: window.capturedPositionsForAddToCart ? window.capturedPositionsForAddToCart.length : 0
      });
    }
    
    // Store captured state for use in the loop
    window.capturedPositionsForAddToCart = capturedPositionsState;
    
    var sizes = $('.mrk-qty-item');
    if (!sizes || sizes.length === 0) {
      // mrkDebug.error('[Regular Product] No size/quantity items found');
      addDebugError('No size/quantity items found', {});
      return;
    }
    
    // Pre-add cleanup: zero out existing child items for parent variants we're about to add
    // (stops batch accumulation when customer re-enters customizer multiple times — Order #55314)
    var parentIdsToClean = [];
    sizes.each(function() {
      var qty = Number($(this).val());
      var pv = Number($(this).data('variant-id'));
      if (!isNaN(qty) && qty > 0 && pv && !isNaN(pv)) parentIdsToClean.push(pv);
    });
    if (parentIdsToClean.length > 0) {
      try {
        var cartRes = await fetch('/cart.js').then(function(r) { return r.json(); });
        var toZero = [];
        var hasMultipleParents = false;
        parentIdsToClean.forEach(function(pvId) {
          var parentsForVariant = (cartRes.items || []).filter(function(item) {
            return item.variant_id === pvId &&
              item.properties &&
              !item.properties._ParentVariant &&
              (item.properties._has_customization === 'true' || item.properties._customization_data);
          });
          if (parentsForVariant.length <= 1) {
            // Single parent (reconfiguration): remove parent + all its children
            parentsForVariant.forEach(function(p) { toZero.push(p); });
            (cartRes.items || []).filter(function(item) {
              return item.properties && parseInt(item.properties._ParentVariant, 10) === pvId;
            }).forEach(function(c) { toZero.push(c); });
          } else {
            // P0.7 (Bug P) — Multiple stale parent instances of the same variant. The previous
            // implementation removed only the OLDEST parent + its _ParentKey-matched children, leaving
            // 2nd, 3rd, ... stale instances alive (Order #58818). Now remove EVERY stale parent and
            // every child whose _ParentKey matches any of them. Children with no _ParentKey (residual
            // pre-fix data) are still removed by _ParentVariant match — they cannot survive the new add
            // intact anyway and would otherwise become Bug F merge fodder.
            hasMultipleParents = true;
            var staleParentKeys = {};
            parentsForVariant.forEach(function(p) {
              toZero.push(p);
              if (p.key) staleParentKeys[p.key] = true;
            });
            (cartRes.items || []).filter(function(item) {
              if (!item.properties || parseInt(item.properties._ParentVariant, 10) !== pvId) return false;
              if (item.properties._ParentKey) {
                return !!staleParentKeys[item.properties._ParentKey];
              }
              // No _ParentKey present — treat as orphan from a pre-fix add and remove.
              return true;
            }).forEach(function(c) { toZero.push(c); });
          }
        });
        var seen = {};
        toZero = toZero.filter(function(item) {
          if (seen[item.key]) return false;
          seen[item.key] = true;
          return true;
        });
        var cleanupSurvivors = 0;
        if (toZero.length > 0) {
          var cleanupUpdates = {};
          for (var i = 0; i < toZero.length; i++) {
            cleanupUpdates[toZero[i].key] = 0;
          }
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ updates: cleanupUpdates })
          }).then(function(r) { return r.json(); });

          // P0.7 (Bug P) — Verify removal succeeded; retry once if survivors persist.
          try {
            var cartAfter = await fetch('/cart.js').then(function(r) { return r.json(); });
            var removedKeySet = {};
            toZero.forEach(function(it) { if (it.key) removedKeySet[it.key] = true; });
            var survivors = (cartAfter.items || []).filter(function(it) { return removedKeySet[it.key]; });
            if (survivors.length > 0) {
              var retryUpdates = {};
              survivors.forEach(function(s) { retryUpdates[s.key] = 0; });
              await fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ updates: retryUpdates })
              }).then(function(r) { return r.json(); });
              var cartFinal = await fetch('/cart.js').then(function(r) { return r.json(); });
              cleanupSurvivors = (cartFinal.items || []).filter(function(it) { return removedKeySet[it.key]; }).length;
              if (cleanupSurvivors > 0) {
                addDebugStep('pre_add_cleanup_incomplete', 'error', {
                  initialRemovalCount: toZero.length,
                  retried: survivors.length,
                  finalSurvivors: cleanupSurvivors
                });
              }
            }
          } catch (verifyErr) {
            addDebugWarning('Pre-add cleanup verification failed', { error: verifyErr && verifyErr.message });
          }
        }
        var removedChildren = toZero.filter(function(i) { return i.properties && i.properties._ParentVariant; }).length;
        var removedParents = toZero.length - removedChildren;
        addDebugStep('pre_add_cleanup', cleanupSurvivors === 0 ? 'success' : 'error', {
          cleanupRan: true,
          cleanupSource: 'live_cart',
          removedChildCount: removedChildren,
          removedParentCount: removedParents,
          survivorsAfterRetry: cleanupSurvivors,
          parentVariantIds: parentIdsToClean,
          multiParentDetected: hasMultipleParents,
          removedItems: toZero.map(function(item) {
            return {
              key: (item.key || '').substring(0, 16),
              variantId: item.variant_id,
              logoId: (item.properties && item.properties['Logo Id']) || '',
              parentKey: (item.properties && item.properties._ParentKey) || '',
              position: (item.properties && item.properties.Position) || '',
              isParent: !item.properties || !item.properties._ParentVariant
            };
          })
        });
      } catch (cleanupErr) {
        addDebugWarning('Pre-add cleanup failed (continuing with add)', { error: cleanupErr && cleanupErr.message });
      }
    }
    
    // CRITICAL FIX: Evaluate positions count ONCE before the loop
    // This count is used for validation after the loop ends
    // Note: We still re-evaluate positions INSIDE the loop for each variant to ensure accuracy
    // CRITICAL FIX (BUG 2): Count distinct checked positions
    // We need to count from the sizes loop where positions are actually evaluated, not from DOM
    // The positions jQuery object contains the checked checkboxes at the time of capture
    var checkedPositionsCount = 0; // Will be set after first size processes
    
    var ids = []; 
    var hasValidItems = false;
    // Order #56166: When hidden fields are insufficient, second parent must use first parent's logo data
    var hiddenFieldCountForSizes = $('.mrk-hidden-field-item').length;
    var firstParentPositionVariants = null;
    var sizeLoopIndex = 0;
    
    addDebugStep('initial_state', 'success', {
      sizesCount: sizes.length,
      hiddenFieldsCountBeforeClear: hiddenFieldsBeforeClear,
      hiddenFieldsCountAfterClear: $('.mrk-hidden-field-item').length,
      checkedPositionsCount: checkedPositionsCount,
      note: 'Positions will be re-evaluated for each variant inside the loop'
    });

    window.__noopLog("[addBulkItems] Starting size loop - found", sizes.length, "sizes");

    sizes.each(function() {
        var currentSizeIndex = sizeLoopIndex++;
        // Bug #2: Restore preserved data from frozen snapshot so every size uses same data
        if (window._frozenAddToCartData && window._frozenAddToCartData.length > 0) {
          window._preservedPositionData = window._frozenAddToCartData;
        } else {
          window._preservedPositionData = null;
        }
        window._preservedLogoUrls = logoUrlsFromHiddenFields || null;
        
        // Also clear debug log to prevent cross-contamination between sizes
        if (window.regularProductDebugLog) {
          window.regularProductDebugLog = null;
        }
        
        if (window.MRK_DEBUG) {
          window.__noopLog('[addBulkItems] Global state cleared at start of size iteration');
        }
        
        window.__noopLog("[addBulkItems] Processing size variant...");
        var qty = Number($(this).val());
        var ParentVariantId = Number($(this).data('variant-id'));
        
        // DEBUG (BUG-3 Investigation): Log raw quantity value immediately after reading
        mrkDebug.log('[Regular Product] 🔍 RAW QTY READ (BUG-3 investigation):', {
          qty: qty,
          rawValue: $(this).val(),
          type: typeof $(this).val(),
          selector: '.mrk-qty-item',
          variantId: ParentVariantId,
          elementHTML: this.outerHTML ? this.outerHTML.substring(0, 150) : 'N/A',
          checkedPositionsCount: checkedPositionsCount,
          note: 'Qty should come from size selector, NOT from checkedPositionsCount'
        });
        
        // Validate quantity
        if (isNaN(qty) || qty <= 0) {
          // mrkDebug.warn('[Regular Product] Invalid quantity:', qty, 'for variant:', ParentVariantId);
          return; // Skip invalid quantities
        }
        
        // Validate ParentVariantId
        if (!ParentVariantId || isNaN(ParentVariantId) || ParentVariantId === 0) {
          // mrkDebug.error('[Regular Product] Invalid ParentVariantId:', ParentVariantId);
          return;
        }
        
        // CRITICAL FIX: Check flag BEFORE evaluating positions
        // This ensures that even if positions were captured before flag was set, we skip processing them
        var flagCheckInLoop = window.userWantsNoCustomization === true;
        var timeSinceFlagInLoop = window.userWantsNoCustomizationTimestamp 
          ? (Date.now() - window.userWantsNoCustomizationTimestamp) 
          : Infinity;
        
        if (flagCheckInLoop && timeSinceFlagInLoop < 5000) {
          // Flag is set - skip ALL position processing, add main variant only
          mrkDebug.log('[Regular Product] 🚫 FLAG DETECTED IN LOOP - Skipping position processing', {
            parentVariantId: ParentVariantId,
            timestamp: window.userWantsNoCustomizationTimestamp,
            timeSinceClick: timeSinceFlagInLoop,
            note: 'User clicked "No, buy plain" - adding main variant only, no position variants'
          });
          
          try {
            const mainVariant = buildMainVariant(ParentVariantId, qty, false);
            if (mainVariant && mainVariant.id) {
              ids.push(mainVariant);
              hasValidItems = true;
              addDebugStep('main_variant_added_flag_in_loop', 'success', {
                variantId: ParentVariantId,
                quantity: qty,
                reason: 'Flag detected in loop - main variant only, no position variants'
              });
            }
          } catch (e) {
            mrkDebug.error('[Regular Product] Error building main variant (flag in loop):', e);
            addDebugError('Error building main variant (flag in loop)', {
              error: e.message,
              parentVariantId: ParentVariantId
            });
          }
          
          return; // Skip to next variant - don't process any positions
        }
        
        // CRITICAL FIX: Use captured checkbox state instead of reading from DOM
        // This ensures we use the state BEFORE clearing, preserving user's selection
        var positions;
        if (window.capturedPositionsForAddToCart && window.capturedPositionsForAddToCart.length > 0) {
          // Use captured state (jQuery collection from captured elements)
          positions = $(window.capturedPositionsForAddToCart.map(function(p) { return p.element; }));
        } else {
          // Fallback: scope to popup (where checkboxes actually are)
          // CRITICAL FIX: Scope checkbox query to popup to prevent stale checkboxes
          var $popupFallback = $('.mrk-customizer-popup-form').first();
          if ($popupFallback.length > 0) {
            positions = $popupFallback.find('.logo-position-checkbox:checked');
          } else {
            // Fallback to product form or global query
            var $productFormFallback = $('product-form-mrk').first();
            if ($productFormFallback.length > 0) {
              positions = $productFormFallback.find('.logo-position-checkbox:checked');
            } else {
              positions = $('.logo-position-checkbox:checked');
            }
          }
        }
        
        // Console log positions evaluation for each variant
        mrkDebug.log('[Regular Product] 🔍 POSITIONS RE-EVALUATED for variant:', {
          parentVariantId: ParentVariantId,
          positionsLength: positions.length,
          checkedPositions: positions.map(function() { return $(this).attr('data-position-name') || $(this).val(); }).get(),
          hiddenFieldsCount: $('.mrk-hidden-field-item').length,
          usingCapturedState: window.capturedPositionsForAddToCart && window.capturedPositionsForAddToCart.length > 0,
          flagWasSet: flagCheckInLoop && timeSinceFlagInLoop < 5000
        });
        
        // CRITICAL FIX (BUG 2): Set checkedPositionsCount on first iteration
        // This represents the number of DISTINCT positions checked, not position variants
        if (checkedPositionsCount === 0 && positions.length > 0) {
          checkedPositionsCount = positions.length;
        }
        
        // CRITICAL FIX: If no positions checked, skip ALL position-related logic
        // This prevents any position variants from being added when user intentionally adds product without customization
        if (positions.length === 0) {
          // Only add main variant, no position variants
          mrkDebug.log('[Regular Product] 🛡️ EARLY EXIT: No positions checked - adding main variant only (no position variants)', {
            parentVariantId: ParentVariantId,
            qty: qty
          });
          
          try {
            const mainVariant = buildMainVariant(ParentVariantId, qty, false);
            if (mainVariant && mainVariant.id) {
              ids.push(mainVariant);
              hasValidItems = true;
              addDebugStep('main_variant_added_no_customization', 'success', {
                variantId: ParentVariantId,
                quantity: qty,
                reason: 'No positions checked - main variant only, no position variants'
              });
            }
          } catch (e) {
            mrkDebug.error('[Regular Product] Error building main variant (no customization):', e);
            addDebugError('Error building main variant (no customization)', {
              error: e.message,
              parentVariantId: ParentVariantId
            });
          }
          return; // Skip to next size - don't process any position logic
        }
        
        // Positions ARE checked - proceed with full customization logic
        var currentIds = [];
        
        try {
          // CRITICAL FIX: Pass positions.length > 0 to buildMainVariant to prevent reading stale hidden fields
          // when no positions are checked
          const hasPositionsChecked = positions.length > 0;
          const mainVariant = buildMainVariant(ParentVariantId, qty, hasPositionsChecked);
          if (!mainVariant || !mainVariant.id) {
            // mrkDebug.error('[Regular Product] buildMainVariant returned invalid variant:', mainVariant);
            return;
          }
          
          // Debug logging: Track when properties are skipped due to no positions checked
          if (!hasPositionsChecked && Object.keys(mainVariant.properties || {}).length > 0) {
            addDebugWarning('Properties found but positions not checked - properties should be empty', {
              propertiesCount: Object.keys(mainVariant.properties || {}).length,
              propertiesKeys: Object.keys(mainVariant.properties || {})
            });
          } else if (!hasPositionsChecked) {
            addDebugStep('hidden_fields_skipped_no_positions', 'success', {
              variantId: ParentVariantId,
              reason: 'No positions checked - skipping hidden fields read to prevent stale data'
            });
          }
          
          // CRITICAL VALIDATION: Check if main variant has logo properties
          // IMPORTANT: Only detect logo properties if positions are actually checked
          // If no positions are checked, any logo properties in hidden fields are stale and should be ignored
          var hasLogoProperties = false;
          var logoPropertiesFound = [];
          if (positions.length > 0 && mainVariant.properties) {
            // Check for logo-related properties
            var logoPropertyKeys = ['Application Method', 'Position', 'Logo Type', 'Logo', 'Logo Text', '_logoVariant'];
            logoPropertyKeys.forEach(function(key) {
              // Check for properties like "Application Method 1", "Position 1", etc.
              for (var prop in mainVariant.properties) {
                if (prop.indexOf(key) === 0) {
                  hasLogoProperties = true;
                  logoPropertiesFound.push(prop);
                }
              }
            });
          }
          
          // CRITICAL: Console log before getAllPositionsVariants call
          window.__noopLog('[addBulkItems] 🔍 BEFORE getAllPositionsVariants:', {
            positionsLength: positions.length,
            parentVariantId: ParentVariantId,
            qty: qty,
            hasPositionsChecked: positions.length > 0
          });
          mrkDebug.log('[Regular Product] 🔍 BEFORE getAllPositionsVariants:', {
            positionsLength: positions.length,
            parentVariantId: ParentVariantId,
            qty: qty,
            hasPositionsChecked: positions.length > 0
          });
          
          // CRITICAL FIX: Declare positionsVariants before try-catch so it's accessible throughout the loop
          var positionsVariants = [];
          
          try {
            window.__noopLog('[addBulkItems] Calling getAllPositionsVariants...');
            positionsVariants = getAllPositionsVariants(positions, qty, ParentVariantId);
            window.__noopLog('[addBulkItems] ✅ getAllPositionsVariants returned:', positionsVariants.length, 'variants');
          
            // CRITICAL: Console log after getAllPositionsVariants call
            window.__noopLog('[addBulkItems] 🔍 AFTER getAllPositionsVariants:', {
              positionsLength: positions.length,
              positionsVariantsLength: positionsVariants.length,
              parentVariantId: ParentVariantId
            });
            mrkDebug.log('[Regular Product] 🔍 AFTER getAllPositionsVariants:', {
              positionsLength: positions.length,
              positionsVariantsLength: positionsVariants.length,
              parentVariantId: ParentVariantId,
              earlyReturnExpected: positions.length === 0,
              earlyReturnWorked: positions.length === 0 && positionsVariants.length === 0
            });
          } catch (error) {
            console.error('[addBulkItems] ❌ ERROR in getAllPositionsVariants:', error.message, error.stack);
            throw error; // Re-throw to trigger outer catch
          }
          
          // Order #56166: When hidden fields are insufficient, use first parent's logo data for second+ parents
          if (currentSizeIndex === 0 && positionsVariants.length > 0) {
            firstParentPositionVariants = positionsVariants.slice();
          } else if (currentSizeIndex > 0 && firstParentPositionVariants && firstParentPositionVariants.length > 0 && hiddenFieldCountForSizes < positions.length) {
            var normalizePos = function(name) { return (name || '').toString().trim().toLowerCase().replace(/\s+/g, '-'); };
            positionsVariants.forEach(function(item) {
              if (!item.properties) return;
              var posName = item.properties.Position;
              var firstMatch = firstParentPositionVariants.find(function(p) {
                return p.properties && normalizePos(p.properties.Position) === normalizePos(posName);
              });
              if (firstMatch && firstMatch.properties) {
                item.properties['Logo Id'] = firstMatch.properties['Logo Id'];
                Object.keys(firstMatch.properties).forEach(function(k) {
                  if (k.indexOf('Logo') === 0 && k !== 'Logo Id') {
                    item.properties[k] = firstMatch.properties[k];
                  }
                });
                mrkDebug.log('[addBulkItems] Order #56166: applied first parent logo data for position', posName, 'on size index', currentSizeIndex);
              }
            });
          }
          
          // CRITICAL FALLBACK: If no position variants collected but main variant has logo properties, extract from properties
          // IMPORTANT: Only run fallback extraction if positions are actually checked
          // This prevents stale hidden field data from auto-adding logos when user intentionally adds product without customization
          if (positions.length > 0 && positionsVariants.length === 0 && hasLogoProperties && mainVariant.properties) {
            // mrkDebug.warn('[Regular Product] ⚠️ No position variants collected from hidden fields, attempting to extract from main variant properties...');
            
            try {
              // Extract position data from main variant properties
              var extractedVariants = extractPositionVariantsFromProperties(mainVariant.properties, positions, qty, ParentVariantId);
              
              if (extractedVariants && extractedVariants.length > 0) {
                // mrkDebug.log('[Regular Product] ✅ Successfully extracted', extractedVariants.length, 'position variants from main variant properties');
                
                // Add extracted variants to positionsVariants array
                extractedVariants.forEach(function(variant) {
                  positionsVariants.push(variant);
                });
                
                addDebugStep('positionVariants_extracted_from_properties', 'success', {
                  count: extractedVariants.length,
                  totalNow: positionsVariants.length
                });
              } else {
                // mrkDebug.warn('[Regular Product] Could not extract position variants from main variant properties');
                addDebugWarning('Could not extract position variants from main variant properties', {
                  logoProperties: logoPropertiesFound,
                  propertiesKeys: Object.keys(mainVariant.properties || {})
                });
              }
            } catch(e) {
              // mrkDebug.error('[Regular Product] Error extracting from main variant properties:', e);
              addDebugError('Error extracting from main variant properties', {
                error: e.message,
                stack: e.stack
              });
            }
          }
          
          // CRITICAL VALIDATION: If main variant has logo properties but no position variants, this is an error!
          // IMPORTANT: Only validate if positions are actually checked
          // If no positions are checked, logo properties are stale and should be ignored (not treated as an error)
          if (positions.length > 0 && hasLogoProperties && positionsVariants.length === 0) {
            // mrkDebug.error('[Regular Product] ❌ CRITICAL ERROR: Main variant has logo properties but NO position variants collected!', {
              // logoProperties: logoPropertiesFound,
              // positionsChecked: positions.length,
              // positionVariantsCollected: positionsVariants.length,
              // mainVariantProperties: Object.keys(mainVariant.properties || {})
            // });
            
            addDebugError('Logo properties exist but position variants missing', {
              logoProperties: logoPropertiesFound,
              positionsChecked: positions.length,
              positionVariantsCollected: positionsVariants.length,
              mainVariantProperties: Object.keys(mainVariant.properties || {}),
              hiddenFieldsCount: $('.mrk-hidden-field-item').length,
              checkedPositions: positions.map(function() { return $(this).val(); }).get()
            });
            
            // Still log the error but prevent adding to cart
            trackRegularProductError('Logo properties exist but position variants missing - preventing cart add', {
              logoProperties: logoPropertiesFound,
              positionsChecked: positions.length
            });
            
            return; // Prevent adding to cart
          }
          
          // Also check if positions are checked but no variants collected
          if (positions.length > 0 && positionsVariants.length === 0) {
            // mrkDebug.error('[Regular Product] ❌ CRITICAL ERROR: Positions are checked but NO position variants collected!', {
              // positionsChecked: positions.length,
              // checkedPositions: positions.map(function() { return $(this).val(); }).get(),
              // positionVariantsCollected: positionsVariants.length,
              // hiddenFieldsCount: $('.mrk-hidden-field-item').length
            // });
            
            addDebugError('Positions checked but no variants collected', {
              positionsChecked: positions.length,
              checkedPositions: positions.map(function() { return $(this).val(); }).get(),
              positionVariantsCollected: positionsVariants.length,
              hiddenFieldsCount: $('.mrk-hidden-field-item').length
            });
            
            trackRegularProductError('Positions checked but no variants collected - preventing cart add', {
              positionsChecked: positions.length
            });
            
            return; // Prevent adding to cart
          }
          
          // ====================================================================
          // CRITICAL FIX: Quantity Validation Per Size (Order #51231)
          // ====================================================================
          // PROBLEM: The validation was comparing all position variants against
          // a single qty value. This is correct INSIDE the loop (where qty is
          // the current size's quantity), but we need to ensure we're validating
          // against the correct quantity for THIS specific parent variant.
          //
          // SOLUTION: Validate that each position variant's quantity matches
          // the qty parameter (which is the current size's quantity). This
          // validation runs per-size, so it's correct.
          // ====================================================================
          
          // CRITICAL: Validate quantities match main product quantity
          // Each position should have the SAME quantity as the main product
          // qty here is the current size's quantity (correct for this iteration)
          var quantityIssues = [];
          positionsVariants.forEach(function(item, index) {
            // Validate against qty (current size's quantity) - this is correct
            if (item.quantity !== qty) {
              quantityIssues.push({
                index: index,
                expectedQty: qty,
                actualQty: item.quantity,
                variantId: item.id,
                parentVariantId: item.properties && item.properties._ParentVariant || 'missing',
                position: item.properties && item.properties.Position ? item.properties.Position : 'Unknown'
              });
            }
          });
          
          if (quantityIssues.length > 0) {
            addDebugError('Position variant quantity mismatches', {
              mainProductQty: qty,
              parentVariantId: ParentVariantId,
              issues: quantityIssues,
              totalPositions: positionsVariants.length
            });
            // mrkDebug.error('[Regular Product] ❌ CRITICAL: Position variant quantity mismatches detected!', {
              // mainProductQty: qty,
              // parentVariantId: ParentVariantId,
              // issues: quantityIssues
            // });
            
            // Fix quantities to match the current size's quantity (qty)
            // This is correct because we're inside the loop for THIS specific size
            positionsVariants.forEach(function(item) {
              if (item.quantity !== qty) {
                // mrkDebug.warn('[Regular Product] 🔧 Fixing position variant quantity from', item.quantity, 'to', qty, 'for parent variant:', ParentVariantId);
                item.quantity = qty;
                if (item.properties && item.properties._qty) {
                  item.properties._qty = qty;
                }
              }
            });
          }
          
          // Track all position variants with detailed info
          var positionVariantsDetails = [];
          positionsVariants.forEach(function(variant) {
            if (variant && variant.id && variant.properties) {
              positionVariantsDetails.push({
                variantId: variant.id,
                quantity: variant.quantity || 1,
                logoId: variant.properties['Logo Id'] || 'missing',
                position: variant.properties.Position || 'unknown',
                applicationMethod: variant.properties['Application Method'] || 'unknown',
                parentVariantId: variant.properties._ParentVariant || 'missing',
                hasLogoId: !!(variant.properties['Logo Id']),
                hasPosition: !!(variant.properties.Position),
                hasApplicationMethod: !!(variant.properties['Application Method'])
              });
            }
          });
          
          addDebugStep('positionVariants_collected', positionsVariants.length > 0 ? 'success' : 'warning', {
            expected: positions.length,
            collected: positionsVariants.length,
            qty: qty,
            parentVariantId: ParentVariantId,
            quantityIssues: quantityIssues.length,
            allQuantitiesMatch: quantityIssues.length === 0,
            variants: positionVariantsDetails,
            allHaveLogoIds: positionVariantsDetails.every(function(v) { return v.hasLogoId; }),
            allHavePositions: positionVariantsDetails.every(function(v) { return v.hasPosition; }),
            allHaveApplicationMethods: positionVariantsDetails.every(function(v) { return v.hasApplicationMethod; })
          });
          
          // Store in debug log data for analysis
          if (debugLog && debugLog.data) {
            if (!debugLog.data.positionVariants) {
              debugLog.data.positionVariants = {};
            }
            debugLog.data.positionVariants[ParentVariantId] = {
              count: positionsVariants.length,
              variants: positionVariantsDetails
            };
          }
          
          if (positionsVariants.length < positions.length) {
            addDebugWarning('Missing position variants', {
              expected: positions.length,
              collected: positionsVariants.length,
              missing: positions.length - positionsVariants.length
            });
          }
          
          // Validate total expected quantity
          var expectedTotalQty = qty * positions.length;
          var actualTotalQty = positionsVariants.reduce(function(sum, item) {
            return sum + (item.quantity || 0);
          }, 0);
          
          if (actualTotalQty !== expectedTotalQty) {
            addDebugError('Total position variant quantity mismatch', {
              mainProductQty: qty,
              positionsCount: positions.length,
              expectedTotal: expectedTotalQty,
              actualTotal: actualTotalQty,
              difference: expectedTotalQty - actualTotalQty
            });
            // mrkDebug.error('[Regular Product] ❌ CRITICAL: Total quantity mismatch!', {
              // expected: expectedTotalQty,
              // actual: actualTotalQty,
              // difference: expectedTotalQty - actualTotalQty
            // });
          }
          
          // Filter out null/invalid items
          var validPositionsVariants = positionsVariants.filter(function(item) {
            return item && item.id && !isNaN(item.id);
          });
          
          if (validPositionsVariants.length !== positionsVariants.length) {
            // mrkDebug.warn('[Regular Product] Some position variants were invalid:', {
              // total: positionsVariants.length,
              // valid: validPositionsVariants.length
            // });
            addDebugWarning('Invalid position variants filtered out', {
              total: positionsVariants.length,
              valid: validPositionsVariants.length
            });
          }
          
          // CRITICAL FIX (Order #Multi-Size Bug): Verify properties are attached to this parent variant
          var hasLogoProperties = false;
          if (mainVariant.properties) {
            var logoPropertyKeys = ['Application Method', 'Position', 'Logo Type', 'Logo', 'Logo Text', '_logoVariant'];
            logoPropertyKeys.forEach(function(key) {
              for (var prop in mainVariant.properties) {
                if (prop.indexOf(key) === 0) {
                  hasLogoProperties = true;
                }
              }
            });
          }
          
          // CRITICAL FIX (Order #Multi-Size Bug): Add customization properties to parent variant
          // This ensures cart validation can properly identify and validate parent items
          // BUG FIX (multi-size properties): Create a NEW properties object for EACH parent variant
          // so properties are not shared by reference between sizes (only last size would retain props).
          // CRITICAL SAFEGUARD: Only attach properties when positions are actually checked
          // This prevents stale position variants from attaching properties when user adds product without customization
          if (positions.length > 0 && validPositionsVariants.length > 0) {
            var existingProps = mainVariant.properties || {};
            mainVariant.properties = {};
            for (var k in existingProps) {
              if (existingProps.hasOwnProperty(k)) {
                mainVariant.properties[k] = existingProps[k];
              }
            }
            
            // Extract logo IDs from position variants (may have multiple logos)
            var logoIds = [];
            var customizationPositions = [];
            
            validPositionsVariants.forEach(function(pv) {
              if (!pv.properties || !pv.properties.Position) return;
              var logoId = pv.properties['Logo Id'];
              var logoIdNum = logoId ? parseInt(logoId, 10) : null;
              if (logoIdNum && !isNaN(logoIdNum) && logoIds.indexOf(logoIdNum) === -1) {
                logoIds.push(logoIdNum);
              }
              customizationPositions.push({
                position: pv.properties.Position,
                applicationMethod: pv.properties['Application Method'] || 'Unknown',
                logoId: logoId || null,
                variantId: pv.id || null
              });
            });
            
            // BUG 1 FIX: Use _customization_data for standard products (NOT _bundle_raw)
            // _bundle_raw is bundle-specific; cart validator expects _customization_data for standard product path
            try {
              var customizationData = {
                type: 'standard_product',
                positions: customizationPositions,
                logoIds: logoIds,
                parentVariantId: ParentVariantId,
                customizationCount: customizationPositions.length,
                timestamp: Date.now()
              };
              mainVariant.properties._customization_data = JSON.stringify(customizationData);
            } catch(e) {
              addDebugError('Failed to create _customization_data', {
                error: e.message,
                parentVariantId: ParentVariantId
              });
            }
            
            // Add Logo Id property (primary logo ID for validation)
            if (logoIds.length > 0) {
              mainVariant.properties['Logo Id'] = logoIds[0]; // Use first logo ID as primary
              if (logoIds.length > 1) {
                // Store all logo IDs if multiple logos
                mainVariant.properties['_all_logo_ids'] = logoIds.join(',');
              }
            }
            
            // Add customization flags
            mainVariant.properties._has_customization = 'true';
            mainVariant.properties._customization_count = validPositionsVariants.length;
            
            // DEBUG LOG: Track when properties are being added on PDP
            mrkDebug.log('[PDP] 🎯 ADDING PROPERTIES TO PARENT:', {
              variantId: ParentVariantId,
              mainVariantId: mainVariant.id,
              productTitle: mainVariant.title || 'Unknown',
              propertiesCount: Object.keys(mainVariant.properties).length,
              hasCustomizationData: !!mainVariant.properties._customization_data,
              logoIds: logoIds,
              logoIdsCount: logoIds.length,
              positionCount: customizationPositions.length,
              positions: customizationPositions.map(function(p) { return p.position; }),
              location: 'PDP',
              method: 'addBulkItems',
              note: 'Properties being attached before adding to cart'
            });
            
            // Helper function to extract actual position index from position variant
            // This ensures we use the correct position number instead of array index
            function extractPositionIndex(pv) {
              // Priority 1: Use _logoposition if available (most reliable)
              if (pv.properties && pv.properties._logoposition) {
                var logoPos = parseInt(pv.properties._logoposition, 10);
                if (!isNaN(logoPos) && logoPos > 0) {
                  if (window.MRK_DEBUG) {
                    window.__noopLog('[extractPositionIndex] Using _logoposition:', logoPos, 'for', pv.properties.Position);
                  }
                  return logoPos;
                }
              }
              
              // Priority 2: Parse from Position property string (e.g., "Left Breast" -> check data-position-index)
              // or extract number if Position property contains it
              if (pv.properties && pv.properties.Position) {
                var positionName = pv.properties.Position;
                
                // Try to find matching checkbox to get its index
                var $matchingCheckbox = $('.logo-position-checkbox').filter(function() {
                  return $(this).val() === positionName || $(this).attr('data-position-name') === positionName;
                });
                
                if ($matchingCheckbox.length > 0) {
                  var dataIndex = $matchingCheckbox.attr('data-position-index') || $matchingCheckbox.attr('data-index');
                  if (dataIndex) {
                    var parsed = parseInt(dataIndex, 10);
                    if (!isNaN(parsed) && parsed > 0) {
                      if (window.MRK_DEBUG) {
                        window.__noopLog('[extractPositionIndex] Using data-position-index:', parsed, 'for', positionName);
                      }
                      return parsed;
                    }
                  }
                }
              }
              
              // Priority 3: Fallback - try to extract number from position variant's hidden field index
              if (pv.hiddenFieldIndex) {
                var hiddenIndex = parseInt(pv.hiddenFieldIndex, 10);
                if (!isNaN(hiddenIndex) && hiddenIndex > 0) {
                  if (window.MRK_DEBUG) {
                    window.__noopLog('[extractPositionIndex] Using hiddenFieldIndex:', hiddenIndex, 'for', pv.properties.Position);
                  }
                  return hiddenIndex;
                }
              }
              
              // Priority 4: Absolute fallback - return null to indicate we couldn't determine the index
              // The caller should handle this case
              if (window.MRK_DEBUG) {
                console.warn('[extractPositionIndex] Could not determine position index for:', pv.properties ? pv.properties.Position : 'unknown');
              }
              return null;
            }
            
            // Copy individual position properties for display (if not already present)
            // This ensures checkout page shows logo details
            // CRITICAL FIX: Use actual position index instead of array index
            validPositionsVariants.forEach(function(pv, index) {
              // Extract actual position index from pv properties
              var posIndex = extractPositionIndex(pv);
              
              // Fallback to array index + 1 if extraction failed (with warning)
              if (posIndex === null) {
                posIndex = index + 1;
                if (window.MRK_DEBUG) {
                  addDebugWarning('Using array index fallback for position property assignment', {
                    arrayIndex: index,
                    fallbackPosIndex: posIndex,
                    position: pv.properties ? pv.properties.Position : 'unknown',
                    note: 'Could not extract actual position index - using array position as fallback'
                  });
                }
              }
              if (pv.properties) {
                if (pv.properties.Position && !mainVariant.properties['Position ' + posIndex]) {
                  mainVariant.properties['Position ' + posIndex] = pv.properties.Position;
                }
                if (pv.properties['Application Method'] && !mainVariant.properties['Application Method ' + posIndex]) {
                  mainVariant.properties['Application Method ' + posIndex] = pv.properties['Application Method'];
                }
                if (pv.properties['Logo Id'] && !mainVariant.properties['Logo Id ' + posIndex]) {
                  mainVariant.properties['Logo Id ' + posIndex] = pv.properties['Logo Id'];
                }
                if (pv.properties['Logo Type'] && !mainVariant.properties['Logo Type ' + posIndex]) {
                  mainVariant.properties['Logo Type ' + posIndex] = pv.properties['Logo Type'];
                }
                // CRITICAL FIX: Copy Logo property if it exists and is not empty
                // Use explicit checks to ensure Logo URLs are reliably copied from position variants to parent
                // This ensures uploaded logos are properly displayed in the cart
                // Try both 'Logo' and 'Logo X' formats (position variants might store it either way)
                var logoUrl = pv.properties && (pv.properties['Logo'] || pv.properties['Logo ' + posIndex]);
                if (logoUrl && logoUrl !== '' && logoUrl !== null && logoUrl !== undefined) {
                  if (!mainVariant.properties['Logo ' + posIndex]) {
                    mainVariant.properties['Logo ' + posIndex] = logoUrl;
                    mrkDebug.log('[Regular Product] Logo URL copied to main variant:', {
                      posIndex: posIndex,
                      logoUrl: logoUrl.substring(0, 60) + '...',
                      mainVariantId: mainVariant.id,
                      sourceProperty: pv.properties['Logo'] ? 'Logo' : 'Logo ' + posIndex
                    });
                  }
                } else {
                  mrkDebug.warn('[Regular Product] Logo property missing in position variant:', {
                    posIndex: posIndex,
                    hasProperties: !!pv.properties,
                    logoValue: pv.properties ? (pv.properties['Logo'] || pv.properties['Logo ' + posIndex] || 'neither format found') : 'no properties object',
                    allPropertyKeys: pv.properties ? Object.keys(pv.properties).filter(k => k.includes('Logo')) : []
                  });
                }
                if (pv.properties['_logoVariant'] && !mainVariant.properties['_logoVariant' + posIndex]) {
                  mainVariant.properties['_logoVariant' + posIndex] = pv.properties['_logoVariant'];
                }
                
                // CRITICAL FIX: Copy text logo properties for Text Logo types
                var pvLogoType = pv.properties['Logo Type'] || '';
                if (pvLogoType === 'Text Logo') {
                  // Copy all text logo properties if they exist
                  if (pv.properties['Logo Text'] && !mainVariant.properties['Logo Text ' + posIndex]) {
                    mainVariant.properties['Logo Text ' + posIndex] = pv.properties['Logo Text'];
                  }
                  if (pv.properties['Logo Text 2'] && !mainVariant.properties['Logo Text 2 ' + posIndex]) {
                    mainVariant.properties['Logo Text 2 ' + posIndex] = pv.properties['Logo Text 2'];
                  }
                  if (pv.properties['Logo Text 3'] && !mainVariant.properties['Logo Text 3 ' + posIndex]) {
                    mainVariant.properties['Logo Text 3 ' + posIndex] = pv.properties['Logo Text 3'];
                  }
                  if (pv.properties['Logo Text 4'] && !mainVariant.properties['Logo Text 4 ' + posIndex]) {
                    mainVariant.properties['Logo Text 4 ' + posIndex] = pv.properties['Logo Text 4'];
                  }
                  if (pv.properties['Logo Color'] && !mainVariant.properties['Logo Color ' + posIndex]) {
                    mainVariant.properties['Logo Color ' + posIndex] = pv.properties['Logo Color'];
                  }
                  if (pv.properties['Logo Font'] && !mainVariant.properties['Logo Font ' + posIndex]) {
                    mainVariant.properties['Logo Font ' + posIndex] = pv.properties['Logo Font'];
                  }
                }
                // Copy Note property for all logo types
                if (pv.properties['Note'] && !mainVariant.properties['Note ' + posIndex]) {
                  mainVariant.properties['Note ' + posIndex] = pv.properties['Note'];
                }
              }
            });
            
            // CRITICAL VALIDATION: Check position index alignment
            // This helps catch misalignments between array order and actual position indices
            if (window.MRK_DEBUG) {
              for (var i = 0; i < validPositionsVariants.length; i++) {
                var pv = validPositionsVariants[i];
                var expectedIndex = i + 1; // Array index + 1
                var actualIndex = extractPositionIndex(pv);
                
                if (actualIndex !== null && expectedIndex !== actualIndex) {
                  addDebugWarning('Position index mismatch detected', {
                    arrayIndex: i,
                    expectedIndex: expectedIndex,
                    actualIndex: actualIndex,
                    position: pv.properties ? pv.properties.Position : 'unknown',
                    note: 'Array order does not match position index - properties assigned using actualIndex'
                  });
                }
              }
            }
            
            addDebugStep('parent_variant_properties_attached', 'success', {
              parentVariantId: ParentVariantId,
              hasCustomizationData: !!mainVariant.properties._customization_data,
              hasLogoId: !!mainVariant.properties['Logo Id'],
              customizationCount: validPositionsVariants.length,
              logoIds: logoIds,
              propertiesAdded: Object.keys(mainVariant.properties).filter(function(k) {
                return /^(Position|Application Method|Logo Id|Logo|Logo Text|Logo Color|Logo Font|Note) ?\d/.test(k) ||
                       k === '_customization_data' ||
                       k === 'Logo Id' ||
                       k === '_has_customization' ||
                       k === '_customization_count';
              })
            });
          } else if (validPositionsVariants.length > 0 && positions.length === 0) {
            // CRITICAL SAFEGUARD: Position variants found but no positions checked - this is stale data
            // Skip property attachment to prevent stale customization data from being attached
            addDebugWarning('Position variants found but no positions checked - skipping property attachment to prevent stale data', {
              positionsChecked: positions.length,
              positionVariantsFound: validPositionsVariants.length,
              parentVariantId: ParentVariantId,
              reason: 'Stale hidden fields detected - user intentionally added product without customization'
            });
          } else if (!hasLogoProperties && positions.length > 0) {
            addDebugWarning('Parent variant missing logo properties', {
              parentVariantId: ParentVariantId,
              positionsCount: positions.length,
              positionVariantsCount: validPositionsVariants.length,
              propertiesKeys: Object.keys(mainVariant.properties || {}),
              recommendation: 'Properties should be attached to parent variant for display on checkout'
            });
          }
          
          // CRITICAL SAFEGUARD: Only add position variants if positions are actually checked
          // This is the final line of defense - even if stale data somehow made it through earlier checks,
          // we prevent it from being added to the cart here
          mrkDebug.log('[Regular Product] 🛡️ FINAL SAFEGUARD CHECK:', {
            positionsLength: positions.length,
            validPositionsVariantsLength: validPositionsVariants.length,
            parentVariantId: ParentVariantId,
            willSkip: positions.length === 0 && validPositionsVariants.length > 0,
            willAdd: positions.length > 0
          });
          
          if (positions.length === 0 && validPositionsVariants.length > 0) {
            // CRITICAL: Console log when safeguard prevents adding stale variants
            mrkDebug.warn('[Regular Product] 🛡️ SAFEGUARD TRIGGERED: Position variants found but no positions checked - SKIPPING to prevent stale data', {
              positionsChecked: positions.length,
              positionVariantsFound: validPositionsVariants.length,
              parentVariantId: ParentVariantId,
              reason: 'Final safeguard - preventing stale position variants from being added to cart',
              action: 'Skipping position variants - user intentionally added product without customization'
            });
            addDebugWarning('Position variants found but no positions checked - skipping to prevent stale data', {
              positionsChecked: positions.length,
              positionVariantsFound: validPositionsVariants.length,
              parentVariantId: ParentVariantId,
              reason: 'Final safeguard - preventing stale position variants from being added to cart',
              action: 'Skipping position variants - user intentionally added product without customization'
            });
            // Don't add position variants if no positions are checked
          } else if (positions.length > 0) {
            // Positions are checked - safe to add position variants
            // CRITICAL FIX: Ensure each position variant has a unique _lineItemKey that includes parent variant ID
            // This prevents Shopify from merging items incorrectly when same variant is added with/without customization
            validPositionsVariants.forEach(function(pv) {
              if (!pv.properties) pv.properties = {};
              // Include parent variant ID in line item key to prevent merging
              var lineItemKeyParts = [
                pv.id,
                ParentVariantId, // Include parent variant ID to ensure uniqueness
                pv.properties['Logo Id'] || '',
                (pv.properties.Position || '').replace(/\s+/g, '_')
              ].filter(function(part) { return part && part !== ''; });
              pv.properties._lineItemKey = lineItemKeyParts.join('_');
              // P0.5 (Bug F) — inject a unique property visible at /cart/add.js merge time so Shopify's
              // property-hash dedup never collapses two children that share variant_id but differ by
              // parent / logo / position. Using _lineItemKey itself guarantees distinctness.
              pv.properties._unique_key = pv.properties._lineItemKey;
            });
            
            mrkDebug.log('[Regular Product] ✅ SAFEGUARD PASSED: Adding position variants (positions checked)', {
              positionsLength: positions.length,
              validPositionsVariantsLength: validPositionsVariants.length,
              parentVariantId: ParentVariantId,
              variantsToAdd: validPositionsVariants.map(function(v) {
                return {
                  variantId: v.id,
                  quantity: v.quantity,
                  position: v.properties && v.properties.Position || 'unknown',
                  logoId: v.properties && v.properties['Logo Id'] || 'unknown',
                  lineItemKey: v.properties && v.properties._lineItemKey || 'missing'
                };
              })
            });
            currentIds = currentIds.concat(validPositionsVariants);
            mrkDebug.log('[Regular Product] ✅ POSITION VARIANTS ADDED TO CART:', {
              count: validPositionsVariants.length,
              parentVariantId: ParentVariantId,
              totalItemsInCurrentIds: currentIds.length
            });
          } else {
            // No positions checked and no variants found - this is the expected case
            mrkDebug.log('[Regular Product] ✅ SAFEGUARD PASSED: No positions checked and no variants found (expected)', {
              positionsLength: positions.length,
              validPositionsVariantsLength: validPositionsVariants.length,
              parentVariantId: ParentVariantId
            });
          }
          
          currentIds.push(mainVariant);
          mrkDebug.log('[Regular Product] 📦 FINAL ITEMS TO ADD:', {
            parentVariantId: ParentVariantId,
            mainVariantAdded: true,
            positionVariantsCount: validPositionsVariants.length,
            totalItemsInCurrentIds: currentIds.length,
            willAddToCart: currentIds.length
          });
          ids = ids.concat(currentIds);
          hasValidItems = true;
        } catch (e) {
          console.error('[addBulkItems] ❌ ERROR in size loop processing:', {
            error: e.message,
            stack: e.stack,
            ParentVariantId: ParentVariantId,
            qty: qty
          });
          // mrkDebug.error('[Regular Product] Error building variants for size:', e);
        }
    });

    window.__noopLog('[addBulkItems] Post-loop check:', {
      hasValidItems: hasValidItems,
      idsLength: ids.length,
      willReturn: !hasValidItems || ids.length === 0
    });

    if (!hasValidItems || ids.length === 0) {
      console.error('[addBulkItems] ❌ NO VALID ITEMS! Cannot proceed to cart add.', {
        hasValidItems: hasValidItems,
        idsLength: ids.length
      });
      // mrkDebug.error('[Regular Product] No valid items to add to cart');
      $('.mrk-loader-main').css('display', 'none');
      return;
    }

    var data = {
        items: ids
    };
    
    var mainProductsCount = ids.filter(function(item) { return !item.properties || !item.properties._ParentVariant; }).length;
    var logoProductsCount = ids.filter(function(item) { return item.properties && item.properties._ParentVariant; }).length;
    
    // CRITICAL VALIDATION: Check if main products have logo properties but no position variants
    var mainProductsWithLogoButNoVariants = [];
    ids.forEach(function(item) {
      if (!item.properties || !item.properties._ParentVariant) {
        // This is a main product
        var hasLogoProps = false;
        var logoProps = [];
        if (item.properties) {
          var logoPropertyKeys = ['Application Method', 'Position', 'Logo Type', 'Logo', 'Logo Text', '_logoVariant'];
          logoPropertyKeys.forEach(function(key) {
            for (var prop in item.properties) {
              if (prop.indexOf(key) === 0) {
                hasLogoProps = true;
                logoProps.push(prop);
              }
            }
          });
        }
        
        if (hasLogoProps) {
          // Check if there are corresponding position variants
          var hasPositionVariants = ids.some(function(otherItem) {
            return otherItem.properties && 
                   otherItem.properties._ParentVariant && 
                   otherItem.properties._ParentVariant == item.id;
          });
          
          if (!hasPositionVariants) {
            mainProductsWithLogoButNoVariants.push({
              variantId: item.id,
              logoProperties: logoProps,
              quantity: item.quantity
            });
          }
        }
      }
    });
    
    window.__noopLog('[addBulkItems] Validation: Main products with logo but no variants:', {
      count: mainProductsWithLogoButNoVariants.length,
      issues: mainProductsWithLogoButNoVariants,
      willReturn: mainProductsWithLogoButNoVariants.length > 0
    });
    
    if (mainProductsWithLogoButNoVariants.length > 0) {
      console.error('[addBulkItems] ❌ VALIDATION FAILED: Main products have logo properties but NO position variants!', {
        issues: mainProductsWithLogoButNoVariants,
        totalItems: ids.length
      });
      // mrkDebug.error('[Regular Product] ❌ CRITICAL ERROR: Main products have logo properties but NO position variants in cart!', {
        // issues: mainProductsWithLogoButNoVariants,
        // totalItems: ids.length
      // });
      
      addDebugError('Main products have logo properties but no position variants', {
        issues: mainProductsWithLogoButNoVariants,
        totalItems: ids.length,
        allItems: ids.map(function(item) {
          return {
            id: item.id,
            quantity: item.quantity,
            isPositionVariant: !!(item.properties && item.properties._ParentVariant),
            properties: Object.keys(item.properties || {})
          };
        })
      });
      
      // Still log but prevent adding to cart
      trackRegularProductError('Main products have logo properties but no position variants - preventing cart add', {
        issues: mainProductsWithLogoButNoVariants
      });
      
      $('.mrk-loader-main').css('display', 'none');
      return; // Prevent adding to cart
    }
    
    window.__noopLog('[addBulkItems] ✅ Validation passed: All main products with logo properties have corresponding position variants');
    
    window.__noopLog('[addBulkItems] Continuing to quantity validation...');
    
    // ====================================================================
    // CRITICAL FIX: Quantity Mismatch Bug (Order #51261)
    // ====================================================================
    // PROBLEM: When multiple sizes with different quantities are added
    // (e.g., M=6, L=8, 4XL=2), the validation logic was comparing ALL
    // position variants to a SINGLE mainProductQty (the first size's qty).
    // This caused all position variants to be "fixed" to the first size's
    // quantity, overwriting the correct per-size quantities.
    //
    // EXAMPLE BUG:
    // - Size M (qty 6) → Position variant should have qty 6 ✓
    // - Size L (qty 8) → Position variant gets "fixed" to qty 6 ✗
    // - Size 4XL (qty 2) → Position variant gets "fixed" to qty 6 ✗
    //
    // SOLUTION: Match each position variant to its SPECIFIC parent variant's
    // quantity, not a single global mainProductQty. Use a map to look up
    // the correct quantity for each parent variant ID.
    // ====================================================================
    
    // Build a map of parent variant IDs to their quantities
    var parentVariantQuantities = {};
    ids.forEach(function(item) {
      if (!item.properties || !item.properties._ParentVariant) {
        // This is a main product - store its quantity
        parentVariantQuantities[item.id] = item.quantity || 0;
      }
    });
    
    window.__noopLog('[addBulkItems] Parent variant quantities built:', parentVariantQuantities);
    
    var quantityValidationResults = [];
    var mainProduct = ids.find(function(item) { return !item.properties || !item.properties._ParentVariant; });
    var mainProductQty = mainProduct ? (mainProduct.quantity || 0) : 0;
    
    window.__noopLog('[addBulkItems] Main product found, continuing to validation loop...');
    
    // DEBUG (BUG-3 Investigation): Log mainProductQty derivation
    mrkDebug.log('[Regular Product] 🔍 MAIN PRODUCT QTY DERIVED (BUG-3 investigation):', {
      mainProductQty: mainProductQty,
      mainProductFound: !!mainProduct,
      mainProductId: mainProduct ? mainProduct.id : 'N/A',
      mainProductQuantity: mainProduct ? mainProduct.quantity : 'N/A',
      totalItemsInIds: ids.length,
      note: 'mainProductQty should match qty from size selector, NOT checkedPositionsCount'
    });
    
    ids.forEach(function(item) {
      if (item.properties && item.properties._ParentVariant) {
        // This is a position variant
        var positionQty = item.quantity || 0;
        var parentVariantId = item.properties._ParentVariant;
        
        // CRITICAL FIX: Get the quantity from the SPECIFIC parent variant, not the first one
        var expectedQty = parentVariantQuantities[parentVariantId] || 0;
        
        if (positionQty !== expectedQty && expectedQty > 0) {
          quantityValidationResults.push({
            type: 'mismatch',
            parentVariantId: parentVariantId,
            expectedQty: expectedQty,
            positionQty: positionQty,
            variantId: item.id,
            position: item.properties.Position || 'Unknown',
            difference: expectedQty - positionQty
          });
          
          // Fix the quantity to match the SPECIFIC parent variant
          // mrkDebug.warn('[Regular Product] 🔧 Fixing cart item quantity from', positionQty, 'to', expectedQty, 'for position:', item.properties.Position || 'Unknown', 'parent variant:', parentVariantId);
          item.quantity = expectedQty;
          if (item.properties._qty) {
            item.properties._qty = expectedQty;
          }
        }
      }
    });
    
    if (quantityValidationResults.length > 0) {
      addDebugError('Quantity mismatches detected before cart', {
        issues: quantityValidationResults,
        totalItems: ids.length,
        mainProductQty: mainProductQty
      });
      // mrkDebug.error('[Regular Product] ❌ CRITICAL: Quantity mismatches detected before adding to cart!', {
        // mainProductQty: mainProductQty,
        // issues: quantityValidationResults
      // });
    }
    
    // Calculate expected vs actual totals
    // CRITICAL FIX: Calculate expected total correctly for multiple sizes
    // Sum up all main product quantities, then multiply by number of positions
    window.__noopLog('[addBulkItems] About to calculate expected totals, checkedPositionsCount:', checkedPositionsCount);
    var totalMainProductQty = Object.values(parentVariantQuantities).reduce(function(sum, qty) {
      return sum + (qty || 0);
    }, 0);
    // CRITICAL FIX: Use checkedPositionsCount instead of positions.length (which is scoped inside the loop)
    var expectedPositionItemsQty = totalMainProductQty * checkedPositionsCount;
    
    window.__noopLog('[addBulkItems] Expected calculations done:', {totalMainProductQty, checkedPositionsCount, expectedPositionItemsQty});
    
    var actualPositionItemsQty = ids.filter(function(item) {
      return item.properties && item.properties._ParentVariant;
    }).reduce(function(sum, item) {
      return sum + (item.quantity || 0);
    }, 0);
    
    addDebugStep('cart_data_prepared', quantityValidationResults.length === 0 ? 'success' : 'warning', {
      totalItems: ids.length,
      mainProducts: mainProductsCount,
      logoProducts: logoProductsCount,
      expectedPositions: checkedPositionsCount, // CRITICAL FIX: Use checkedPositionsCount instead of positions.length
      mainProductQty: mainProductQty, // Keep for backward compatibility
      totalMainProductQty: totalMainProductQty, // New: sum of all sizes
      expectedPositionItemsQty: expectedPositionItemsQty,
      actualPositionItemsQty: actualPositionItemsQty,
      quantityMismatches: quantityValidationResults.length,
      quantityMatches: actualPositionItemsQty === expectedPositionItemsQty,
      quantityIssues: quantityValidationResults,
      parentVariantQuantities: parentVariantQuantities // Debug: show per-size quantities
    });
    
    // ====================================================================
    // CRITICAL FIX: Validation Gate to Prevent Bad Orders (Order #51252)
    // ====================================================================
    // PROBLEM: System detected quantity mismatches and logged errors, but
    // allowed orders to proceed anyway. This caused revenue loss when
    // quantities were wrong (e.g., all embroidery set to qty 1 instead of
    // per-size quantities).
    //
    // SOLUTION: Add validation gate that BLOCKS cart submission when:
    // 1. Per-variant quantity mismatches detected (quantityValidationResults)
    // 2. Total quantity mismatch detected (actualPositionItemsQty !== expectedPositionItemsQty)
    //
    // This prevents orders with incorrect quantities from being submitted.
    // ====================================================================
    
    var hasQuantityMismatches = false;
    var validationErrors = [];
    
    // Check 1: Per-variant quantity mismatches
    if (quantityValidationResults.length > 0) {
      hasQuantityMismatches = true;
      validationErrors.push({
        type: 'per_variant_mismatch',
        count: quantityValidationResults.length,
        issues: quantityValidationResults
      });
    }
    
    // Check 2: Total quantity mismatch
    if (actualPositionItemsQty !== expectedPositionItemsQty) {
      hasQuantityMismatches = true;
      validationErrors.push({
        type: 'total_quantity_mismatch',
        expected: expectedPositionItemsQty,
        actual: actualPositionItemsQty,
        difference: expectedPositionItemsQty - actualPositionItemsQty,
        mainProductQty: mainProductQty, // First size qty (for backward compatibility)
        totalMainProductQty: totalMainProductQty, // Sum of all sizes
        positionsCount: checkedPositionsCount, // CRITICAL FIX: Use checkedPositionsCount instead of positions.length
        parentVariantQuantities: parentVariantQuantities // Debug: show per-size breakdown
      });
      
      addDebugError('Total position items quantity mismatch', {
        mainProductQty: mainProductQty, // First size qty (for backward compatibility)
        totalMainProductQty: totalMainProductQty, // Sum of all sizes
        positionsCount: checkedPositionsCount, // CRITICAL FIX: Use checkedPositionsCount instead of positions.length
        expectedTotal: expectedPositionItemsQty,
        actualTotal: actualPositionItemsQty,
        difference: expectedPositionItemsQty - actualPositionItemsQty,
        parentVariantQuantities: parentVariantQuantities // Debug: show per-size breakdown
      });
    }
    
    // VALIDATION GATE: Block cart submission if mismatches detected
    if (hasQuantityMismatches) {
      var errorMessage = 'ERROR: Embroidery quantities do not match product quantities. ';
      errorMessage += 'Please refresh the page and try again. ';
      errorMessage += 'If the issue persists, please contact support.';
      
      addDebugError('Cart submission blocked due to quantity mismatches', {
        validationErrors: validationErrors,
        totalItems: ids.length,
        mainProducts: mainProductsCount,
        logoProducts: logoProductsCount
      });
      
      trackRegularProductError('Cart submission blocked - quantity mismatches detected', {
        validationErrors: validationErrors,
        quantityValidationResults: quantityValidationResults,
        expectedPositionItemsQty: expectedPositionItemsQty,
        actualPositionItemsQty: actualPositionItemsQty
      });
      
      $('.mrk-loader-main').css('display', 'none');
      return; // CRITICAL: Prevent adding to cart
    }
    
    // mrkDebug.log('[Regular Product] Prepared cart data:', {
      // totalItems: ids.length,
      // mainProducts: mainProductsCount,
      // logoProducts: logoProductsCount,
      // mainProductQty: mainProductQty,
      // expectedPositionItemsQty: expectedPositionItemsQty,
      // actualPositionItemsQty: actualPositionItemsQty,
      // quantityMismatches: quantityValidationResults.length
    // });
    
    // Add user journey data to debug log
    if (debugLog && window.regularProductUserJourney) {
      if (!debugLog.data) debugLog.data = {};
      debugLog.data.userJourney = {
        startTime: window.regularProductUserJourney.startTime,
        pageLoad: window.regularProductUserJourney.pageLoad,
        totalInteractions: window.regularProductUserJourney.interactions.length,
        totalStateChanges: window.regularProductUserJourney.stateChanges.length,
        totalErrors: window.regularProductUserJourney.errors.length,
        interactions: window.regularProductUserJourney.interactions.slice(-50), // Last 50 interactions
        stateChanges: window.regularProductUserJourney.stateChanges.slice(-20), // Last 20 state changes
        errors: window.regularProductUserJourney.errors,
        timeOnPage: Date.now() - new Date(window.regularProductUserJourney.startTime).getTime()
      };
    }
    
    // Add cart debug tracker data if available
    if (debugLog && window.cartDebugTracker) {
      if (!debugLog.data) debugLog.data = {};
      debugLog.data.cartUpdates = {
        startTime: window.cartDebugTracker.startTime,
        totalUpdates: window.cartDebugTracker.updates.length,
        totalRemovals: window.cartDebugTracker.removals.length,
        totalErrors: window.cartDebugTracker.errors.length,
        updates: window.cartDebugTracker.updates.slice(-20), // Last 20 updates
        removals: window.cartDebugTracker.removals.slice(-10), // Last 10 removals
        errors: window.cartDebugTracker.errors
      };
    }
    
    // Add debug log to ALL main variant properties (not just the first)
    if (debugLog && !debugLog.version) {
      debugLog.version = '7.0.0';
    }
    if (!debugLog.theme) {
      debugLog.theme = 'base';
      debugLog.themeVersion = _themeVersion;
    }
    if (!debugLog.version) {
      debugLog.version = '7.0.0';
    }

    // P1.3 — Restore cart_state_before_add (removed in v6.0.1; mirrors bundle path).
    var positionVariantsInPayload = ids.filter(function(i) {
      return i && i.properties && i.properties._ParentVariant;
    }).length;
    addDebugStep('cart_state_before_add', 'success', {
      payloadItemCount: ids.length,
      mainProductsInPayload: ids.length - positionVariantsInPayload,
      positionVariantsInPayload: positionVariantsInPayload,
      note: 'Payload ready; current cart state not fetched to avoid extra request'
    });

    // P1.3 — Restore numbered_properties_verification (removed in v6.0.1).
    // Cross-checks each parent's numbered Position N / Logo Id N count against _customization_data.
    var nppvFailures = [];
    var nppvExpectedTotal = 0;
    ids.forEach(function(item) {
      if (!item || !item.properties || item.properties._ParentVariant) return;
      var custData = item.properties._customization_data;
      var parsed = null;
      if (typeof custData === 'string') {
        try { parsed = JSON.parse(custData); } catch (e) { parsed = null; }
      } else if (custData && typeof custData === 'object') {
        parsed = custData;
      }
      var expectedPositions = (parsed && parsed.positions && parsed.positions.length) || 0;
      nppvExpectedTotal += expectedPositions;
      var posKeys = Object.keys(item.properties).filter(function(k) { return /^Position \d+$/.test(k); });
      var logoIdKeys = Object.keys(item.properties).filter(function(k) { return /^Logo Id \d+$/.test(k); });
      if (posKeys.length !== expectedPositions || logoIdKeys.length !== expectedPositions) {
        nppvFailures.push({
          variantId: item.id,
          expectedPositions: expectedPositions,
          actualPositionN: posKeys.length,
          actualLogoIdN: logoIdKeys.length
        });
      }
    });
    addDebugStep('numbered_properties_verification', nppvFailures.length === 0 ? 'success' : 'error', {
      expectedTotalPositions: nppvExpectedTotal,
      allMatch: nppvFailures.length === 0,
      status: nppvFailures.length === 0 ? 'ALL_PROPERTIES_CORRECT' : 'MISMATCHES_FOUND',
      failures: nppvFailures,
      source: '_customization_data_cross_check_per_parent'
    });

    var debugLogJson = JSON.stringify(debugLog);
    if (JRS_DEBUG_PROPERTIES_IN_CART) {
      ids.forEach(function(item) {
        if (item && item.properties && (!item.properties._ParentVariant)) {
          item.properties['_regular_product_debug_log'] = debugLogJson;
        }
      });
    }
    addDebugStep('debug_log_added_to_properties', 'success', {
      logSize: debugLogJson.length,
      stepsCount: debugLog.steps.length,
      warningsCount: debugLog.warnings.length,
      errorsCount: debugLog.errors.length,
      hasUserJourney: !!(debugLog.data && debugLog.data.userJourney),
      hasCartUpdates: !!(debugLog.data && debugLog.data.cartUpdates),
      mainVariantsCount: ids.filter(function(i) { return i && i.properties && !i.properties._ParentVariant; }).length
    });

    window.__noopLog('[addBulkItems] 🔍 Checking if cart updates needed:', {
      hasUpdates: window.updates != undefined && Object.keys(window.updates).length > 0,
      updatesObject: window.updates,
      willUpdateFirst: window.updates != undefined && Object.keys(window.updates).length > 0
    });

    if (window.updates != undefined && Object.keys(window.updates).length > 0) {
        window.__noopLog('[addBulkItems] 📝 Sending cart/update.js first...', window.updates);
        $('.mrk-loader-main').css('display', 'flex');
        jQuery.post(window.Shopify.routes.root + 'cart/update.js', {
            updates: window.updates
        }, function(response) {
            window.__noopLog('[addBulkItems] ✅ Cart update succeeded, now calling addItemToCart');
            if (!response || response.status) {
              console.error('[addBulkItems] ❌ Cart update failed with response:', response);
              // mrkDebug.error('[Regular Product] Cart update failed:', response);
              $('.mrk-loader-main').css('display', 'none');
              return;
            }
            var refreshCart = true;
            window.__noopLog('[addBulkItems] 🚀 Calling addItemToCart (after cart update)...');
            addItemToCart(data, refreshCart);
        }).fail(function(jqXHR, textStatus, errorThrown) {
            console.error('[addBulkItems] ❌ Cart update AJAX failed:', {
              status: jqXHR.status,
              statusText: textStatus,
              error: errorThrown
            });
            $('.mrk-loader-main').css('display', 'none');
            // mrkDebug.error('[Regular Product] Cart update error:', {
              // status: jqXHR.status,
              // statusText: textStatus,
              // error: errorThrown,
              // response: jqXHR.responseJSON
            // });
            
            trackRegularProductError('Cart update failed', {
              status: jqXHR.status,
              statusText: textStatus,
              errorThrown: errorThrown,
              response: jqXHR.responseJSON
            });
            
            // Error logged but no alert shown
        });
    } else {
        window.__noopLog('[addBulkItems] 🚀 No cart updates needed, calling addItemToCart directly...');
        var refreshCart = false;
        addItemToCart(data, refreshCart);
    }
    
    // Clean up captured positions state after add-to-cart completes
    if (window.capturedPositionsForAddToCart) {
      delete window.capturedPositionsForAddToCart;
    }
    if (window._frozenAddToCartData) {
      delete window._frozenAddToCartData;
    }
  } catch (e) {
    // CRITICAL: Log error details for debugging - never show generic alerts to users
    mrkDebug.error('[Regular Product] ❌ UNEXPECTED ERROR in addBulkItems:', {
      error: e,
      message: e.message,
      name: e.name,
      stack: e.stack,
      timestamp: new Date().toISOString()
    });
    
    // Add to debug log if available
    if (debugLog) {
      addDebugError('Unexpected exception in addBulkItems', {
        message: e.message,
        name: e.name,
        stack: (e.stack || '').substring(0, 1000), // Limit stack trace length
        errorType: typeof e,
        errorString: String(e)
      });
    }
    
    // Track error for analytics
    trackRegularProductError('Unexpected exception in addBulkItems', {
      message: e.message,
      name: e.name,
      stack: (e.stack || '').substring(0, 500),
      errorType: typeof e
    });
    
    // Hide loader
    $('.mrk-loader-main').css('display', 'none');
    
    // Clean up captured positions state even on error
    if (window.capturedPositionsForAddToCart) {
      delete window.capturedPositionsForAddToCart;
    }
    if (window._frozenAddToCartData) {
      delete window._frozenAddToCartData;
    }

    // DO NOT show alert to users - errors should be handled gracefully
    // If critical, the error will be logged and can be investigated via console/debug logs
    // User-facing alerts should only be shown for specific, actionable errors (handled elsewhere)
  }
}

function addItemToCart(data, refreshCart) {
  window.__noopLog('[addItemToCart] ✅ Function called!', {
    itemCount: data.items ? data.items.length : 0,
    refreshCart: refreshCart,
    dataStructure: {
      hasItems: !!data.items,
      isArray: Array.isArray(data.items)
    }
  });
  
  // Log cart data before sending
  var expectedItemCount = data.items ? data.items.length : 0;
  // mrkDebug.log('[Regular Product] addItemToCart: Adding', expectedItemCount, 'items to cart:', data);
  
  // Capture the actual request payload (summary) in the debug log so we can
  // diagnose cases where checkout proceeds but child items are missing.
  try {
    if (window.regularProductDebugLog && window.regularProductDebugLog.steps && data && Array.isArray(data.items)) {
      var maxItemsToLog = 30;
      var payloadItems = data.items.slice(0, maxItemsToLog).map(function(item) {
        var isChild = !!(item && item.properties && item.properties._ParentVariant);
        return {
          id: item && item.id ? item.id : null,
          quantity: item && item.quantity ? item.quantity : 0,
          isChild: isChild,
          parentVariantId: isChild ? (item.properties._ParentVariant || null) : null,
          logoId: isChild ? (item.properties['Logo Id'] || null) : null,
          position: isChild ? (item.properties.Position || item.properties['Position'] || null) : null,
          applicationMethod: isChild ? (item.properties['Application Method'] || null) : null
        };
      });
      
      window.regularProductDebugLog.steps.push({
        step: 'cart_add_request_payload',
        status: 'success',
        details: {
          totalItems: data.items.length,
          loggedItems: payloadItems.length,
          truncated: data.items.length > maxItemsToLog,
          items: payloadItems
        },
        time: new Date().toISOString()
      });
    }
  } catch (e) {
    // Never block cart add due to logging
  }
  
  // CRITICAL FIX (Order #52358): Add debug step BEFORE Cart API call
  if (window.regularProductDebugLog && window.regularProductDebugLog.steps) {
    var positionVariantsInRequest = data.items ? data.items.filter(function(item) {
      return item.properties && item.properties._ParentVariant;
    }) : [];
    
    window.regularProductDebugLog.steps.push({
      step: 'cart_add_request_sending',
      status: 'started',
      details: {
        payloadItemCount: data.items ? data.items.length : 0,
        mainProductItems: data.items ? data.items.filter(function(item) {
          return !item.properties || !item.properties._ParentVariant;
        }).length : 0,
        positionVariantItems: positionVariantsInRequest.length,
        positionVariantsDetails: positionVariantsInRequest.map(function(item) {
          return {
            variantId: item.id,
            quantity: item.quantity,
            logoId: item.properties && item.properties['Logo Id'] || 'missing',
            position: item.properties && item.properties.Position || 'missing',
            parentVariant: item.properties && item.properties._ParentVariant || 'missing'
          };
        }),
        note: 'About to send request to /cart/add.js - if log ends here, check for JS error or navigation'
      },
      time: new Date().toISOString()
    });
    
    window.regularProductDebugLog.steps.push({
      step: 'cart_add_request_sent',
      status: 'started',
      details: {
        totalItems: data.items ? data.items.length : 0,
        requestPayload: {
          itemsCount: data.items ? data.items.length : 0,
          items: data.items ? data.items.map(function(item) {
            var isParent = !item.properties || !item.properties._ParentVariant;
            var logoPropertiesCount = 0;
            var logoPropertyKeysSet = new Set(); // CRITICAL FIX (LOGO-URL-003): Use Set to prevent duplicates
            if (item.properties) {
              var logoPropertyKeysToCheck = ['Application Method', 'Position', 'Logo Type', 'Logo', 'Logo Text', '_logoVariant'];
              logoPropertyKeysToCheck.forEach(function(key) {
                for (var prop in item.properties) {
                  if (prop.indexOf(key) === 0) {
                    logoPropertiesCount++;
                    logoPropertyKeysSet.add(prop); // Add to Set instead of array
                  }
                }
              });
            }
            var logoPropertyKeys = Array.from(logoPropertyKeysSet); // Convert Set to Array
            return {
              id: item.id,
              quantity: item.quantity,
              isPositionVariant: !!(item.properties && item.properties._ParentVariant),
              isParent: isParent,
              hasLogoProperties: logoPropertiesCount > 0,
              logoPropertiesCount: logoPropertiesCount,
              logoPropertyKeys: logoPropertyKeys.slice(0, 10), // Limit to first 10 for logging
              hasLogoId: !!(item.properties && item.properties['Logo Id']),
              hasPosition: !!(item.properties && item.properties.Position),
              hasParentVariant: !!(item.properties && item.properties._ParentVariant),
              logoId: item.properties && item.properties['Logo Id'] || null,
              position: item.properties && item.properties.Position || null,
              parentVariant: item.properties && item.properties._ParentVariant || null
            };
          }) : []
        },
        note: 'Full request payload being sent to /cart/add.js'
      },
      time: new Date().toISOString()
    });
  }
  
  // BUG 4 / Order #52837: Log before /cart/add.js (cart_api_call_started + cart_api_request_sent)
  if (window.regularProductDebugLog && window.regularProductDebugLog.steps && data && data.items) {
    var requestItemsForLog = data.items.map(function(item) {
      var isParent = !item.properties || !item.properties._ParentVariant;
      return {
        variantId: item.id,
        quantity: item.quantity || 1,
        type: isParent ? 'parent' : 'logo',
        position: (item.properties && item.properties.Position) || null
      };
    });
    window.regularProductDebugLog.steps.push({
      step: 'cart_api_call_started',
      status: 'success',
      details: {
        endpoint: '/cart/add.js',
        itemsCount: data.items.length,
        items: requestItemsForLog
      },
      time: new Date().toISOString()
    });
    window.regularProductDebugLog.steps.push({
      step: 'cart_api_request_sent',
      status: 'success',
      details: {
        endpoint: '/cart/add.js',
        method: 'POST',
        itemCount: data.items.length,
        items: requestItemsForLog
      },
      time: new Date().toISOString()
    });
  }

  // CRITICAL FIX (Order #52358): Ensure data is sent as JSON, not form-encoded
  // Shopify's /cart/add.js expects JSON when using items array format
  
  // CRITICAL DEBUG: Log parent item quantities before sending to cart
  if (data && data.items) {
    var parentItems = data.items.filter(function(item) {
      return !item.properties || !item.properties._ParentVariant;
    });
    if (parentItems.length > 0) {
      mrkDebug.log('[Regular Product] 🔍 PARENT QUANTITIES BEING SENT TO CART:', parentItems.map(function(item) {
        return {
          variantId: item.id,
          quantity: item.quantity,
          key: 'N/A (not yet in cart)'
        };
      }));
    }
  }
  
  window.__noopLog('[addItemToCart] 🚀 About to send AJAX request to /cart/add.js', {
    itemsCount: data.items ? data.items.length : 0,
    refreshCart: refreshCart
  });

  if (data.items && Array.isArray(data.items)) {
    data.items.forEach(function(item) {
      var p = item.properties || {};
      if (!p._debug_add_source) {
        p._debug_add_source = 'customizer';
        p._debug_add_timestamp = new Date().toISOString();
        p._debug_pdp_variant_selected = String(item.id);
        p._debug_pdp_qty_selected = String(item.quantity || 1);
        p._debug_pdp_url = (window.location && window.location.href ? String(window.location.href).substring(0, 200) : '');
        p._debug_device = (window.innerWidth < 768 ? 'mobile' : window.innerWidth < 1024 ? 'tablet' : 'desktop');
        p._debug_session_id = Date.now().toString(36) + Math.random().toString(36).substring(2, 9);
        item.properties = p;
      }
    });
  }

  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    contentType: 'application/json',
    data: JSON.stringify(data),
    dataType: 'json',
    timeout: 20000,
    beforeSend: function() {
      $('.mrk-loader-main').css('display', 'flex');
    },
    success: function(resp) {
      $('.mrk-loader-main').css('display', 'none');
      
      // CRITICAL DEBUG: Log parent item quantities in cart response and verify they match request
      if (resp && resp.items && data && data.items) {
        var parentItemsInRequest = data.items.filter(function(item) {
          return !item.properties || !item.properties._ParentVariant;
        });
        var parentItemsInResponse = resp.items.filter(function(item) {
          return !item.properties || !item.properties._ParentVariant;
        });
        
        if (parentItemsInRequest.length > 0 || parentItemsInResponse.length > 0) {
          mrkDebug.log('[Regular Product] 🔍 PARENT QUANTITIES IN CART RESPONSE:', parentItemsInResponse.map(function(item) {
            return {
              variantId: item.variant_id,
              quantity: item.quantity,
              key: item.key || 'N/A'
            };
          }));
          
          // CRITICAL: Verify quantities match
          parentItemsInRequest.forEach(function(requestItem) {
            var responseItem = parentItemsInResponse.find(function(item) {
              return item.variant_id === requestItem.id;
            });
            
            if (responseItem) {
              if (responseItem.quantity !== requestItem.quantity) {
                mrkDebug.error('[Regular Product] ❌ QUANTITY MISMATCH! Requested:', requestItem.quantity, 'but cart has:', responseItem.quantity, 'for variant:', requestItem.id);
                if (window.regularProductDebugLog && window.regularProductDebugLog.errors) {
                  window.regularProductDebugLog.errors.push({
                    message: 'Parent quantity mismatch in cart response',
                    details: {
                      variantId: requestItem.id,
                      requestedQuantity: requestItem.quantity,
                      actualQuantity: responseItem.quantity,
                      key: responseItem.key,
                      warning: 'Shopify may have consolidated items incorrectly or reduced quantity'
                    },
                    time: new Date().toISOString()
                  });
                }
              } else {
                mrkDebug.log('[Regular Product] ✅ Quantity matches for variant', requestItem.id, ':', requestItem.quantity);
              }
            } else {
              mrkDebug.warn('[Regular Product] ⚠️ Parent item not found in cart response for variant:', requestItem.id);
            }
          });
        }
      }
      
      // CRITICAL FIX: Log cart API response immediately (Order #51786 fix)
      if (window.regularProductDebugLog && window.regularProductDebugLog.steps) {
        var positionVariantsInResponse = resp && resp.items ? resp.items.filter(function(item) {
          return item.properties && item.properties._ParentVariant;
        }) : [];
        
        var positionVariantsInRequest = data.items ? data.items.filter(function(item) {
          return item.properties && item.properties._ParentVariant;
        }) : [];
        
        // BUG 4: cart_api_response_received with httpStatus, itemsInResponse, allItemsPresent
        var itemsExpected = data.items ? data.items.length : 0;
        var itemsInResponse = resp && resp.items ? resp.items.length : 0;
        var allItemsPresent = itemsInResponse >= itemsExpected;
        window.regularProductDebugLog.steps.push({
          step: 'cart_api_response_received',
          status: allItemsPresent ? 'success' : 'error',
          details: {
            httpStatus: 200,
            itemsInResponse: itemsInResponse,
            itemsExpected: itemsExpected,
            allItemsPresent: allItemsPresent,
            responseItemIds: resp && resp.items ? resp.items.map(function(i) { return i.variant_id; }) : []
          },
          time: new Date().toISOString()
        });

        // P1.4 — Spec-named cart_add_confirmed / cart_add_partial step (Bug #7 fix verification).
        // Persisted alongside the in-payload sealed log via persistDebugLogToCart at end of success flow.
        var itemsLost = Math.max(0, itemsExpected - itemsInResponse);
        var expectedChildKeys = data.items ? data.items
          .filter(function(it) { return it.properties && it.properties._ParentVariant && it.properties._lineItemKey; })
          .map(function(it) { return it.properties._lineItemKey; }) : [];
        var responseChildKeys = resp && resp.items ? resp.items
          .filter(function(it) { return it.properties && it.properties._ParentVariant && it.properties._lineItemKey; })
          .map(function(it) { return it.properties._lineItemKey; }) : [];
        var responseChildKeySet = {};
        responseChildKeys.forEach(function(k) { responseChildKeySet[k] = true; });
        var missingChildKeys = expectedChildKeys.filter(function(k) { return !responseChildKeySet[k]; });
        window.regularProductDebugLog.steps.push({
          step: itemsLost === 0 && missingChildKeys.length === 0 ? 'cart_add_confirmed' : 'cart_add_partial',
          status: itemsLost === 0 && missingChildKeys.length === 0 ? 'success' : 'partial',
          details: {
            httpStatus: 200,
            itemsRequested: itemsExpected,
            itemsAdded: itemsInResponse,
            itemsLost: itemsLost,
            addedKeys: resp && resp.items ? resp.items.map(function(i) { return i.key; }) : [],
            expectedChildKeys: expectedChildKeys,
            missingChildKeys: missingChildKeys
          },
          time: new Date().toISOString()
        });
        window.regularProductDebugLog.steps.push({
          step: 'cart_add_response_received',
          status: 'success',
          details: {
            responseItemCount: resp && resp.items ? resp.items.length : 0,
            responseHasItems: !!(resp && resp.items),
            positionVariantsInRequest: positionVariantsInRequest.length,
            positionVariantsInResponse: positionVariantsInResponse.length,
            positionVariantsMatch: positionVariantsInResponse.length === positionVariantsInRequest.length,
            responseItems: resp && resp.items ? resp.items.map(function(item) {
              var isParent = !item.properties || !item.properties._ParentVariant;
              var logoPropertiesCount = 0;
              var logoPropertyKeysSet = new Set(); // CRITICAL FIX (LOGO-URL-003): Use Set to prevent duplicates
              if (item.properties) {
                var logoPropertyKeysToCheck = ['Application Method', 'Position', 'Logo Type', 'Logo', 'Logo Text', '_logoVariant'];
                logoPropertyKeysToCheck.forEach(function(key) {
                  for (var prop in item.properties) {
                    if (prop.indexOf(key) === 0) {
                      logoPropertiesCount++;
                      logoPropertyKeysSet.add(prop); // Add to Set instead of array
                    }
                  }
                });
              }
              var logoPropertyKeys = Array.from(logoPropertyKeysSet); // Convert Set to Array
              return {
                variantId: item.variant_id,
                quantity: item.quantity,
                isPositionVariant: !!(item.properties && item.properties._ParentVariant),
                isParent: isParent,
                hasLogoProperties: logoPropertiesCount > 0,
                logoPropertiesCount: logoPropertiesCount,
                logoPropertyKeys: logoPropertyKeys.slice(0, 10), // Limit to first 10 for logging
                logoId: item.properties && item.properties['Logo Id'] || 'missing',
                position: item.properties && item.properties.Position || 'missing',
                parentVariant: item.properties && item.properties._ParentVariant || 'missing'
              };
            }) : []
          },
          time: new Date().toISOString()
        });
        
        // CRITICAL: Verify position variants were added
        if (positionVariantsInRequest.length > 0) {
          window.regularProductDebugLog.steps.push({
            step: 'position_variants_verification',
            status: positionVariantsInResponse.length === positionVariantsInRequest.length ? 'success' : 'error',
            details: {
              expected: positionVariantsInRequest.length,
              actual: positionVariantsInResponse.length,
              missing: positionVariantsInRequest.length - positionVariantsInResponse.length,
              expectedVariants: positionVariantsInRequest.map(function(item) {
                return {
                  variantId: item.id,
                  quantity: item.quantity,
                  logoId: item.properties && item.properties['Logo Id'] || 'missing',
                  position: item.properties && item.properties.Position || 'missing'
                };
              }),
              actualVariants: positionVariantsInResponse.map(function(item) {
                return {
                  variantId: item.variant_id,
                  quantity: item.quantity,
                  logoId: item.properties && item.properties['Logo Id'] || 'missing',
                  position: item.properties && item.properties.Position || 'missing'
                };
              }),
              note: positionVariantsInResponse.length < positionVariantsInRequest.length ? 
                'CRITICAL: Some position variants are missing from cart response!' : 
                'All position variants successfully added to cart'
            },
            time: new Date().toISOString()
          });
          
          // Log critical error if position variants are missing
          if (positionVariantsInResponse.length < positionVariantsInRequest.length) {
            if (window.regularProductDebugLog && window.regularProductDebugLog.errors) {
              window.regularProductDebugLog.errors.push({
                message: 'Position variants missing from cart response',
                details: {
                  expected: positionVariantsInRequest.length,
                  actual: positionVariantsInResponse.length,
                  missing: positionVariantsInRequest.length - positionVariantsInResponse.length,
                  impact: 'CRITICAL: Customer will not be charged for missing embroidery positions'
                },
                time: new Date().toISOString()
              });
            }
          }
        }
        
        // Set _ParentKey on child items so cart validation can scope children to the correct parent row (Order #55314)
        if (resp && resp.items && resp.items.length > 0) {
          var parentKeyByVariantId = {};
          resp.items.forEach(function(item) {
            if (!item.properties || !item.properties._ParentVariant) {
              parentKeyByVariantId[item.variant_id] = item.key;
            }
          });
          resp.items.forEach(function(child) {
            if (!child.properties || !child.properties._ParentVariant || child.properties._ParentKey) return;
            var parentKey = parentKeyByVariantId[parseInt(child.properties._ParentVariant, 10)];
            if (!parentKey) return;
            var mergedProps = {};
            for (var p in child.properties) { if (child.properties.hasOwnProperty(p)) mergedProps[p] = child.properties[p]; }
            mergedProps._ParentKey = parentKey;
            jQuery.ajax({
              type: 'POST',
              url: '/cart/change.js',
              contentType: 'application/json',
              data: JSON.stringify({ id: child.key, properties: mergedProps }),
              dataType: 'json'
            });
          });
        }
        
        // CRITICAL FIX (Order #Multi-Size Bug): Check if any parent variants are missing logo properties
        // This can happen when multiple sizes are added - Shopify might only attach properties to one parent
        var parentVariantsMissingProperties = [];
        var parentVariantsInRequest = data.items ? data.items.filter(function(item) {
          return !item.properties || !item.properties._ParentVariant;
        }) : [];
        
        // Also check if any parent variants have child items (if they do, they should have properties)
        var parentVariantsWithChildren = {};
        if (resp && resp.items) {
          resp.items.forEach(function(item) {
            if (item.properties && item.properties._ParentVariant) {
              var parentId = parseInt(item.properties._ParentVariant);
              if (!isNaN(parentId)) {
                if (!parentVariantsWithChildren[parentId]) {
                  parentVariantsWithChildren[parentId] = [];
                }
                parentVariantsWithChildren[parentId].push(item.variant_id);
              }
            }
          });
        }
        
        parentVariantsInRequest.forEach(function(requestParent) {
          // Find corresponding parent in response
          var responseParent = resp.items ? resp.items.find(function(item) {
            return item.variant_id === requestParent.id && (!item.properties || !item.properties._ParentVariant);
          }) : null;
          
          if (responseParent) {
            // BUG 1 FIX: Check for critical properties (_customization_data and Logo Id) for standard products
            var requestHasCustomizationData = !!(requestParent.properties && requestParent.properties._customization_data);
            var requestHasLogoId = !!(requestParent.properties && requestParent.properties['Logo Id']);
            var requestHasCustomization = !!(requestParent.properties && requestParent.properties._has_customization);
            
            var responseHasCustomizationData = !!(responseParent.properties && responseParent.properties._customization_data);
            var responseHasLogoId = !!(responseParent.properties && responseParent.properties['Logo Id']);
            var responseHasCustomization = !!(responseParent.properties && responseParent.properties._has_customization);
            
            // DEBUG LOG: Track when properties are confirmed in cart response
            if (requestHasCustomizationData || requestHasLogoId || requestHasCustomization) {
              mrkDebug.log('[PDP] ✅ PROPERTIES CONFIRMED IN CART RESPONSE:', {
                variantId: requestParent.id,
                responseVariantId: responseParent.variant_id,
                productTitle: responseParent.product_title || responseParent.title || 'Unknown',
                requestHasCustomizationData: requestHasCustomizationData,
                requestHasLogoId: requestHasLogoId,
                responseHasCustomizationData: responseHasCustomizationData,
                responseHasLogoId: responseHasLogoId,
                responseHasCustomization: responseHasCustomization,
                propertiesInRequest: requestParent.properties ? Object.keys(requestParent.properties).length : 0,
                propertiesInResponse: responseParent.properties ? Object.keys(responseParent.properties).length : 0,
                location: 'PDP',
                method: 'addItemToCart_success',
                note: 'Properties confirmed in cart API response'
              });
            }
            
            var requestHasCriticalProperties = requestHasCustomizationData || requestHasLogoId || requestHasCustomization;
            var responseHasCriticalProperties = responseHasCustomizationData && responseHasLogoId && responseHasCustomization;
            
            var hasChildItems = parentVariantsWithChildren[requestParent.id] && parentVariantsWithChildren[requestParent.id].length > 0;
            
            if ((requestHasCriticalProperties && !responseHasCriticalProperties) || (hasChildItems && !responseHasCriticalProperties)) {
              parentVariantsMissingProperties.push({
                variantId: requestParent.id,
                key: responseParent.key,
                requestProperties: requestParent.properties,
                responseProperties: responseParent.properties || {},
                missingProperties: {
                  _customization_data: requestHasCustomizationData && !responseHasCustomizationData,
                  'Logo Id': requestHasLogoId && !responseHasLogoId,
                  _has_customization: requestHasCustomization && !responseHasCustomization
                },
                hasChildItems: hasChildItems,
                childItemCount: hasChildItems ? parentVariantsWithChildren[requestParent.id].length : 0
              });
            }
          }
        });
        
        // CRITICAL FIX: Recover missing properties by updating parent variants
        // Store recovery promise so we can wait for it before navigation
        var recoveryPromise = null;
        if (parentVariantsMissingProperties.length > 0) {
          if (window.regularProductDebugLog && window.regularProductDebugLog.steps) {
            window.regularProductDebugLog.steps.push({
              step: 'parent_properties_missing_detected',
              status: 'warning',
              details: {
                missingCount: parentVariantsMissingProperties.length,
                affectedVariants: parentVariantsMissingProperties.map(function(p) {
                  return {
                    variantId: p.variantId,
                    key: p.key,
                    requestPropertyKeys: Object.keys(p.requestProperties || {}),
                    responsePropertyKeys: Object.keys(p.responseProperties || {}),
                    missingProperties: p.missingProperties,
                    hasChildItems: p.hasChildItems
                  };
                }),
                note: 'Parent variants missing logo properties in cart response - verifying actual cart state before recovery'
              },
              time: new Date().toISOString()
            });
          }
          
          // CRITICAL FIX: Fetch actual cart state to verify what's actually persisted
          // Shopify's API response may show properties that aren't actually persisted
          recoveryPromise = fetch('/cart.js')
            .then(function(response) {
              return response.json();
            })
            .then(function(actualCart) {
              // Re-check which parents are actually missing properties in persisted cart
              var actuallyMissingProperties = [];
              
              parentVariantsMissingProperties.forEach(function(missing) {
                // Find the parent item in the actual cart
                var actualCartItem = actualCart.items ? actualCart.items.find(function(item) {
                  return item.variant_id === missing.variantId && (!item.properties || !item.properties._ParentVariant);
                }) : null;
                
                if (actualCartItem) {
                  var actualHasCustomizationData = !!(actualCartItem.properties && actualCartItem.properties._customization_data);
                  var actualHasLogoId = !!(actualCartItem.properties && actualCartItem.properties['Logo Id']);
                  var actualHasCustomization = !!(actualCartItem.properties && actualCartItem.properties._has_customization);
                  var actualHasCriticalProperties = actualHasCustomizationData && actualHasLogoId && actualHasCustomization;
                  
                  // Only add to recovery list if properties are actually missing in persisted cart
                  if (!actualHasCriticalProperties) {
                    // Update the missing object with actual cart item key if different
                    if (actualCartItem.key && actualCartItem.key !== missing.key) {
                      missing.key = actualCartItem.key;
                    }
                    // Update response properties with actual cart properties
                    missing.responseProperties = actualCartItem.properties || {};
                    actuallyMissingProperties.push(missing);
                    
                    if (window.regularProductDebugLog && window.regularProductDebugLog.steps) {
                      window.regularProductDebugLog.steps.push({
                        step: 'parent_properties_verified_missing',
                        status: 'warning',
                        details: {
                          variantId: missing.variantId,
                          key: missing.key,
                          actualHasCustomizationData: actualHasCustomizationData,
                          actualHasLogoId: actualHasLogoId,
                          actualHasCustomization: actualHasCustomization,
                          hasChildItems: missing.hasChildItems
                        },
                        time: new Date().toISOString()
                      });
                    }
                  } else {
                    // Properties are actually present in cart - no recovery needed
                    if (window.regularProductDebugLog && window.regularProductDebugLog.steps) {
                      window.regularProductDebugLog.steps.push({
                        step: 'parent_properties_verified_present',
                        status: 'success',
                        details: {
                          variantId: missing.variantId,
                          key: missing.key,
                          note: 'Properties are present in actual cart - no recovery needed'
                        },
                        time: new Date().toISOString()
                      });
                    }
                  }
                } else {
                  // Parent not found in actual cart - still attempt recovery (may have been added)
                  actuallyMissingProperties.push(missing);
                }
              });
              
              if (actuallyMissingProperties.length === 0) {
                // All properties are actually present - no recovery needed
                if (window.regularProductDebugLog && window.regularProductDebugLog.steps) {
                  window.regularProductDebugLog.steps.push({
                    step: 'parent_properties_recovery_skipped',
                    status: 'success',
                    details: {
                      note: 'All parent properties verified as present in actual cart - recovery not needed'
                    },
                    time: new Date().toISOString()
                  });
                }
                return {
                  successCount: 0,
                  failCount: 0,
                  total: 0,
                  skipped: true
                };
              }
              
              // Attempt to recover by updating each parent variant with its properties
              // Use /cart/change.js with form-encoded data (not JSON) as per Shopify API
              var recoveryPromises = actuallyMissingProperties.map(function(missing, index) {
                return new Promise(function(resolve, reject) {
                  // CRITICAL: Only recover properties that were actually in the request
                  if (!missing.requestProperties || Object.keys(missing.requestProperties).length === 0) {
                    mrkDebug.warn('[Regular Product] Skipping recovery for variant', missing.variantId, '- no properties in request');
                    resolve(null);
                    return;
                  }
                  
                  // Add delay to prevent rate limiting
                  setTimeout(function() {
                    // CRITICAL FIX: Ensure we're sending all properties, not just missing ones
                    // Shopify's /cart/change.js replaces all properties, so we need to merge with existing ones
                    var propertiesToSend = {};
                    
                    // Start with existing properties from response (to preserve any that were attached)
                    if (missing.responseProperties) {
                      for (var key in missing.responseProperties) {
                        if (missing.responseProperties.hasOwnProperty(key)) {
                          propertiesToSend[key] = missing.responseProperties[key];
                        }
                      }
                    }
                    
                    // Override/add properties from request
                    if (missing.requestProperties) {
                      for (var key in missing.requestProperties) {
                        if (missing.requestProperties.hasOwnProperty(key)) {
                          propertiesToSend[key] = missing.requestProperties[key];
                        }
                      }
                    }
                    
                    mrkDebug.log('[Regular Product] Recovering properties for variant', missing.variantId, '- sending', Object.keys(propertiesToSend).length, 'properties');
                    
                    jQuery.ajax({
                      type: 'POST',
                      url: '/cart/change.js',
                      data: {
                        id: missing.key,
                        properties: propertiesToSend
                      },
                      dataType: 'json',
                      success: function(changeResp) {
                        if (window.regularProductDebugLog && window.regularProductDebugLog.steps) {
                          window.regularProductDebugLog.steps.push({
                            step: 'parent_properties_recovered',
                            status: 'success',
                            details: {
                              variantId: missing.variantId,
                              key: missing.key,
                              propertiesAttached: Object.keys(propertiesToSend || {}).length,
                              propertyKeys: Object.keys(propertiesToSend || {}).slice(0, 10),
                              hasCustomizationData: !!(propertiesToSend._customization_data),
                              hasLogoId: !!(propertiesToSend['Logo Id']),
                              hasCustomization: !!(propertiesToSend._has_customization)
                            },
                            time: new Date().toISOString()
                          });
                        }
                        resolve(changeResp);
                      },
                      error: function(jqXHR, textStatus, errorThrown) {
                        if (window.regularProductDebugLog && window.regularProductDebugLog.errors) {
                          window.regularProductDebugLog.errors.push({
                            message: 'Failed to recover missing properties for parent variant',
                            details: {
                              variantId: missing.variantId,
                              key: missing.key,
                              error: errorThrown,
                              status: jqXHR.status,
                              response: jqXHR.responseJSON,
                              propertiesAttempted: Object.keys(propertiesToSend || {}).length
                            },
                            time: new Date().toISOString()
                          });
                        }
                        reject(errorThrown);
                      }
                    });
                  }, index * 200); // Stagger requests by 200ms
                });
              });
              
              // Create recovery promise that can be awaited
              return Promise.allSettled(recoveryPromises).then(function(results) {
                var successCount = results.filter(function(r) { return r.status === 'fulfilled' && r.value !== null; }).length;
                var failCount = results.filter(function(r) { return r.status === 'rejected'; }).length;
                
                if (window.regularProductDebugLog && window.regularProductDebugLog.steps) {
                  window.regularProductDebugLog.steps.push({
                    step: 'parent_properties_recovery_complete',
                    status: failCount === 0 ? 'success' : 'warning',
                    details: {
                      total: actuallyMissingProperties.length,
                      successful: successCount,
                      failed: failCount
                    },
                    time: new Date().toISOString()
                  });
                }
                
                return {
                  successCount: successCount,
                  failCount: failCount,
                  total: actuallyMissingProperties.length
                };
              });
            })
            .catch(function(error) {
              mrkDebug.error('[Regular Product] Error fetching actual cart state for recovery verification:', error);
              if (window.regularProductDebugLog && window.regularProductDebugLog.errors) {
                window.regularProductDebugLog.errors.push({
                  message: 'Failed to fetch actual cart state for recovery verification',
                  details: {
                    error: error.toString()
                  },
                  time: new Date().toISOString()
                });
              }
              // Return empty result on error - recovery will be attempted by fallback mechanism
              return {
                successCount: 0,
                failCount: 0,
                total: 0,
                error: true
              };
            });
        }
        
        // Store recovery promise in a way that proceedToNavigation can access it
        if (recoveryPromise) {
          // Attach to resp object so it's accessible later
          resp._recoveryPromise = recoveryPromise;
        }
      }
      
      // Verify all items were added
      if (resp && resp.items) {
        var actualItemCount = resp.items.length;
        
        // CRITICAL: Verify logo products quantities match main product
        // CRITICAL FIX: Build a map of parent variant IDs to their quantities
        // This handles cases where multiple parent items exist with different quantities
        var parentVariantQuantities = {};
        resp.items.forEach(function(item) {
          if (!item.properties || !item.properties._ParentVariant) {
            // This is a parent product - store its quantity by variant ID
            var variantId = item.variant_id.toString();
            parentVariantQuantities[variantId] = item.quantity || 0;
          }
        });
        
        // Get main products for validation checks (could be multiple)
        var mainProductsInCart = resp.items.filter(function(item) {
          return !item.properties || !item.properties._ParentVariant;
        });
        
        // For backward compatibility, use first main product for general checks
        var mainProductInCart = mainProductsInCart.length > 0 ? mainProductsInCart[0] : null;
        var mainProductQty = mainProductInCart ? (mainProductInCart.quantity || 0) : 0;
        
        // CRITICAL VALIDATION: Check if main product has logo properties but no position variants in cart
        var mainProductHasLogoButNoVariants = false;
        var mainProductLogoProperties = [];
        if (mainProductInCart && mainProductInCart.properties) {
          var logoPropertyKeys = ['Application Method', 'Position', 'Logo Type', 'Logo', 'Logo Text', '_logoVariant'];
          logoPropertyKeys.forEach(function(key) {
            for (var prop in mainProductInCart.properties) {
              if (prop.indexOf(key) === 0) {
                mainProductHasLogoButNoVariants = true;
                mainProductLogoProperties.push(prop);
              }
            }
          });
          
          if (mainProductHasLogoButNoVariants) {
            // Check if position variants exist in cart for ANY main product
            var hasPositionVariantsInCart = resp.items.some(function(item) {
              return item.properties && item.properties._ParentVariant;
            });
            
            if (!hasPositionVariantsInCart) {
              // mrkDebug.error('[Regular Product] ❌ CRITICAL ERROR: Main product has logo properties but NO position variants in cart response!', {
                // mainProductVariantId: mainProductInCart.variant_id,
                // logoProperties: mainProductLogoProperties,
                // cartItems: resp.items.map(function(item) {
                  // return {
                    // variantId: item.variant_id,
                    // isPositionVariant: !!(item.properties && item.properties._ParentVariant),
                    // parentVariant: item.properties && item.properties._ParentVariant
                  // };
                // })
              // });
              
              trackRegularProductError('Main product has logo properties but no position variants in cart response', {
                mainProductVariantId: mainProductInCart.variant_id,
                logoProperties: mainProductLogoProperties
              });
              
              // Add to debug log
              if (window.regularProductDebugLog && window.regularProductDebugLog.data) {
                if (!window.regularProductDebugLog.data.cartResponseValidation) {
                  window.regularProductDebugLog.data.cartResponseValidation = {};
                }
                window.regularProductDebugLog.data.cartResponseValidation.missingPositionVariants = {
                  mainProductVariantId: mainProductInCart.variant_id,
                  logoProperties: mainProductLogoProperties,
                  cartItems: resp.items.map(function(item) {
                    return {
                      variantId: item.variant_id,
                      isPositionVariant: !!(item.properties && item.properties._ParentVariant),
                      parentVariant: item.properties && item.properties._ParentVariant
                    };
                  })
                };
              }
            }
          }
        }
        
          var logoProductsRequested = 0;
          var logoProductsAdded = 0;
        var logoProductsQtyMismatches = [];
          
        // Count requested logo products
          if (data.items) {
            data.items.forEach(function(item) {
              if (item.properties && item.properties._ParentVariant) {
                logoProductsRequested++;
              }
            });
          }
          
        // Verify added logo products and check quantities
          if (resp.items) {
            resp.items.forEach(function(item) {
              if (item.properties && item.properties._ParentVariant) {
                logoProductsAdded++;
              
              // CRITICAL FIX: Check if quantity matches the SPECIFIC parent product's quantity
              // Not all parent products - each child should match its own parent
              var positionQty = item.quantity || 0;
              var parentVariantId = item.properties._ParentVariant.toString();
              var expectedParentQty = parentVariantQuantities[parentVariantId] || 0;
              
              if (expectedParentQty > 0 && positionQty !== expectedParentQty) {
                logoProductsQtyMismatches.push({
                  variantId: item.variant_id,
                  position: item.properties.Position || 'Unknown',
                  parentVariantId: parentVariantId,
                  expectedQty: expectedParentQty,
                  positionQty: positionQty,
                  difference: expectedParentQty - positionQty,
                  lineItemKey: item.key
                });
              }
              }
            });
          }
        
        if (actualItemCount < expectedItemCount) {
          // mrkDebug.error('[Regular Product] Not all items added to cart!', {
            // expected: expectedItemCount,
            // actual: actualItemCount,
            // requestData: data,
            // response: resp
          // });
          trackRegularProductError('Not all items added to cart', {
            expected: expectedItemCount,
            actual: actualItemCount
          });
        }
        
        if (logoProductsQtyMismatches.length > 0) {
          // mrkDebug.error('[Regular Product] ❌ CRITICAL: Logo product quantity mismatches in cart!', {
            // mismatches: logoProductsQtyMismatches,
            // totalMismatches: logoProductsQtyMismatches.length
          // });
          
          // Build a summary message showing the mismatches
          var mismatchSummary = logoProductsQtyMismatches.map(function(mismatch) {
            return 'Position: ' + (mismatch.position || 'Unknown') + ', Expected: ' + mismatch.expectedQty + ', Found: ' + mismatch.positionQty;
          }).join('; ');
          
          trackRegularProductError('Logo product quantity mismatches in cart response', {
            mismatches: logoProductsQtyMismatches,
            totalMismatches: logoProductsQtyMismatches.length
          });
          
          // Add to debug log
          if (window.regularProductDebugLog && window.regularProductDebugLog.data) {
            if (!window.regularProductDebugLog.data.cartResponseValidation) {
              window.regularProductDebugLog.data.cartResponseValidation = {};
            }
            window.regularProductDebugLog.data.cartResponseValidation.quantityMismatches = logoProductsQtyMismatches;
            window.regularProductDebugLog.data.cartResponseValidation.totalMismatches = logoProductsQtyMismatches.length;
          }
          
          // Error logged but no alert shown
          }
          
          if (logoProductsRequested > logoProductsAdded) {
          // mrkDebug.error('[Regular Product] ❌ Some logo products could not be added to cart!', {
            // requested: logoProductsRequested,
            // added: logoProductsAdded,
            // missing: logoProductsRequested - logoProductsAdded
          // });
          trackRegularProductError('Missing logo products in cart', {
            requested: logoProductsRequested,
            added: logoProductsAdded
          });
        } else if (logoProductsQtyMismatches.length === 0) {
          // mrkDebug.log('[Regular Product] ✅ Quantity validation passed:', {
            // mainProductQty: mainProductQty,
            // logoProductsCount: logoProductsAdded,
            // allQuantitiesMatch: true
          // });
        }
        
        // Calculate expected vs actual totals
        // CRITICAL FIX (VALIDATION-001): Use sum of all parent quantities, not just first variant
        var totalMainProductQty = 0;
        var parentVariantQuantities = {};
        
        // Sum all parent variant quantities from the cart response
        resp.items.forEach(function(item) {
          if (!item.properties || !item.properties._ParentVariant) {
            // This is a parent item
            var variantId = item.variant_id || item.id;
            var qty = item.quantity || 0;
            parentVariantQuantities[variantId] = qty;
            totalMainProductQty += qty;
          }
        });
        
        var expectedTotalPositionQty = totalMainProductQty * logoProductsRequested;
        var actualTotalPositionQty = resp.items.filter(function(item) {
          return item.properties && item.properties._ParentVariant;
        }).reduce(function(sum, item) {
          return sum + (item.quantity || 0);
        }, 0);
        
        if (actualTotalPositionQty !== expectedTotalPositionQty && expectedTotalPositionQty > 0) {
          // mrkDebug.error('[Regular Product] ❌ CRITICAL: Total position items quantity mismatch in cart!', {
            // mainProductQty: mainProductQty,
            // positionsCount: logoProductsRequested,
            // expectedTotal: expectedTotalPositionQty,
            // actualTotal: actualTotalPositionQty,
            // difference: expectedTotalPositionQty - actualTotalPositionQty
          // });
          trackRegularProductError('Total position items quantity mismatch in cart', {
            mainProductQty: mainProductQty, // Keep for backward compatibility
            totalMainProductQty: totalMainProductQty, // CRITICAL FIX: Add sum of all sizes
            positionsCount: logoProductsRequested,
            expectedTotal: expectedTotalPositionQty,
            actualTotal: actualTotalPositionQty,
            parentVariantQuantities: parentVariantQuantities // CRITICAL FIX: Add breakdown
          });
          
          // Add to debug log
          if (window.regularProductDebugLog && window.regularProductDebugLog.data) {
            if (!window.regularProductDebugLog.data.cartResponseValidation) {
              window.regularProductDebugLog.data.cartResponseValidation = {};
            }
            window.regularProductDebugLog.data.cartResponseValidation.totalQuantityMismatch = {
              expected: expectedTotalPositionQty,
              actual: actualTotalPositionQty,
              difference: expectedTotalPositionQty - actualTotalPositionQty,
              mainProductQty: mainProductQty,
              totalMainProductQty: totalMainProductQty, // CRITICAL FIX: Add sum
              positionsCount: logoProductsRequested,
              parentVariantQuantities: parentVariantQuantities // CRITICAL FIX: Add breakdown
            };
          }
        }
        
        // CRITICAL FIX: Log cart add success with position variant verification (Order #51786 fix, #52426 enhancement)
        if (window.regularProductDebugLog && window.regularProductDebugLog.steps) {
          var positionVariantsInResponse = resp.items.filter(function(item) {
            return item.properties && item.properties._ParentVariant;
          });
          var positionVariantsInRequest = data.items ? data.items.filter(function(item) {
            return item.properties && item.properties._ParentVariant;
          }) : [];
          
          window.regularProductDebugLog.steps.push({
            step: 'cart_add_success',
            status: positionVariantsInResponse.length === positionVariantsInRequest.length && logoProductsQtyMismatches.length === 0 ? 'success' : 'warning',
            details: {
              expectedItems: data.items ? data.items.length : 0,
              actualItems: resp.items.length,
              positionVariantsExpected: positionVariantsInRequest.length,
              positionVariantsAdded: positionVariantsInResponse.length,
              allPositionVariantsAdded: positionVariantsInResponse.length === positionVariantsInRequest.length,
              quantityMismatches: logoProductsQtyMismatches.length,
              logoProductsAdded: logoProductsAdded,
              note: positionVariantsInResponse.length < positionVariantsInRequest.length ? 
                'WARNING: Not all position variants were added to cart!' : 
                'All position variants successfully added'
            },
            time: new Date().toISOString()
          });
        }
        
        // ====================================================================
        // CRITICAL FIX (Order #52426): Missing Logo Line Item in Orders
        // ====================================================================
        // PROBLEM: Logo items were being added to cart but disappearing before order creation.
        // Debug log showed cart_data_prepared but no response steps, suggesting items
        // weren't actually added or were removed.
        //
        // ROOT CAUSES:
        // 1. Debug log saved BEFORE Cart API call, so response steps never persisted
        // 2. No verification that all items were added before navigation
        // 3. No immediate recovery for missing items
        // 4. Navigation happened even if items were missing
        //
        // SOLUTION:
        // 1. Persist updated debug log AFTER Cart API response
        // 2. Verify all items were added before allowing navigation
        // 3. Add immediate recovery for missing items
        // 4. Block navigation if items are missing
        // ====================================================================
        
        // CRITICAL FIX (Order #52426): Verify all items were added before navigation
        var missingItems = [];
        if (data.items && resp.items) {
          // Build map of response items by variant ID + logo ID for accurate matching
          var responseItemsByKey = {};
          resp.items.forEach(function(item) {
            if (item.properties && item.properties._ParentVariant) {
              var key = item.variant_id + '_' + (item.properties['Logo Id'] || '') + '_' + (item.properties.Position || '').replace(/\s/g, '_');
              if (!responseItemsByKey[key]) {
                responseItemsByKey[key] = [];
              }
              responseItemsByKey[key].push(item);
            }
          });
          
          // Check each requested item (keep full requestItem for recovery so we send all properties)
          data.items.forEach(function(requestItem) {
            if (requestItem.properties && requestItem.properties._ParentVariant) {
              var key = requestItem.id + '_' + (requestItem.properties['Logo Id'] || '') + '_' + (requestItem.properties.Position || '').replace(/\s/g, '_');
              var found = responseItemsByKey[key] && responseItemsByKey[key].length > 0;
              if (!found) {
                missingItems.push({
                  variantId: requestItem.id,
                  quantity: requestItem.quantity,
                  logoId: requestItem.properties['Logo Id'],
                  position: requestItem.properties.Position,
                  parentVariant: requestItem.properties._ParentVariant,
                  requestItem: requestItem
                });
              }
            }
          });
        }
        
        // CRITICAL FIX (Order #52426): Immediate recovery for missing items
        // FIX (Windbreaker): Send recovery as JSON with full properties (Application Method, Logo Type, etc.)
        // so the added item matches the main request and consolidates correctly.
        if (missingItems.length > 0) {
          if (window.regularProductDebugLog && window.regularProductDebugLog.steps) {
            window.regularProductDebugLog.steps.push({
              step: 'cart_add_missing_items_detected',
              status: 'error',
              details: {
                missingCount: missingItems.length,
                missingItems: missingItems.map(function(m) {
                  return {
                    variantId: m.variantId,
                    quantity: m.quantity,
                    logoId: m.logoId,
                    position: m.position
                  };
                }),
                note: 'Items missing from cart response - attempting immediate recovery'
              },
              time: new Date().toISOString()
            });
          }
          
          _attemptRecoveryThenProceed(missingItems);
        } else {
          // BUG 4: post_add_verification - fetch /cart.js and verify all items before navigation
          var expectedItemCount = data.items ? data.items.length : 0;
          var expectedLogoCount = data.items ? data.items.filter(function(i) {
            return i.properties && i.properties._ParentVariant;
          }).length : 0;
          fetch('/cart.js')
            .then(function(r) { return r.json(); })
            .then(function(cart) {
              var cartItemCount = cart.items ? cart.items.length : 0;
              var parentInCart = cart.items ? cart.items.filter(function(i) {
                return !i.properties || !i.properties._ParentVariant;
              }).length : 0;
              
              // CRITICAL FIX: Only count child items that belong to parents WITH customization properties
              // This prevents child items from previous customizations from being incorrectly associated
              // with new parent items added WITHOUT customization
              var allParents = cart.items ? cart.items.filter(function(item) {
                return !item.properties || !item.properties._ParentVariant;
              }) : [];
              
              // DEBUG LOG: Show what properties each parent has
              var parentPropertyDetails = allParents.map(function(parent) {
                var props = parent.properties || {};
                return {
                  variantId: parent.variant_id,
                  key: parent.key,
                  productTitle: parent.product_title || parent.title,
                  hasCustomizationData: !!props._customization_data,
                  hasApplicationMethod1: !!props['Application Method 1'],
                  hasPosition1: !!props['Position 1'],
                  hasCustomizationFlag: props._has_customization === 'true',
                  hasLogoId: !!props['Logo Id'],
                  allPropertyKeys: Object.keys(props).filter(function(k) { 
                    return k.includes('Logo') || k.includes('Position') || k.includes('Application') || k.includes('customization');
                  }),
                  propertyCount: Object.keys(props).length
                };
              });
              
              mrkDebug.log('[Regular Product] 🔍 POST_ADD_VERIFICATION - Parent property details:', {
                totalParents: allParents.length,
                parentDetails: parentPropertyDetails,
                note: 'Detailed breakdown of each parent\'s customization properties'
              });
              
              var parentsWithCustomization = allParents.filter(function(item) {
                return item.properties && (
                  item.properties._customization_data ||
                  item.properties['Application Method 1'] ||
                  item.properties['Position 1'] ||
                  item.properties._has_customization === 'true'
                );
              });
              
              // Only count child items that reference parents WITH customization
              var logoInCart = cart.items ? cart.items.filter(function(i) {
                if (!i.properties || !i.properties._ParentVariant) return false;
                var parentVariantId = i.properties._ParentVariant;
                return parentsWithCustomization.some(function(parent) {
                  return parent.variant_id.toString() === parentVariantId.toString();
                });
              }).length : 0;
              
              // Log for debugging
              mrkDebug.log('[Regular Product] 🔍 POST_ADD_VERIFICATION - Parent matching:', {
                totalParents: parentInCart,
                parentsWithCustomization: parentsWithCustomization.length,
                parentsWithCustomizationDetails: parentsWithCustomization.map(function(p) {
                  return {
                    variantId: p.variant_id,
                    key: p.key,
                    hasCustomizationData: !!(p.properties && p.properties._customization_data),
                    hasApplicationMethod1: !!(p.properties && p.properties['Application Method 1']),
                    hasPosition1: !!(p.properties && p.properties['Position 1']),
                    hasCustomizationFlag: !!(p.properties && p.properties._has_customization === 'true')
                  };
                }),
                totalChildItems: cart.items ? cart.items.filter(function(i) { return i.properties && i.properties._ParentVariant; }).length : 0,
                validChildItems: logoInCart,
                note: 'Only counting child items that belong to parents WITH customization properties'
              });
              // BUG FIX (CART-VAL-005): Track parent quantities immediately after add-to-cart
              var parentQuantities = {};
              if (cart.items) {
                cart.items.forEach(function(item) {
                  if (!item.properties || !item.properties._ParentVariant) {
                    var variantId = item.variant_id;
                    if (!parentQuantities[variantId]) {
                      parentQuantities[variantId] = [];
                    }
                    parentQuantities[variantId].push({
                      key: item.key,
                      quantity: item.quantity,
                      title: item.title
                    });
                  }
                });
              }
              var allPresent = cartItemCount >= expectedItemCount && logoInCart >= expectedLogoCount;
              
              // CRITICAL FIX (Order #67156086817141): Check for cart count mismatch
              var hasCountMismatch = false;
              if (expectedItemCount > 0 && cartItemCount > expectedItemCount * 1.5) {
                hasCountMismatch = true;
                mrkDebug.warn('[Cart] ⚠️ Cart item count significantly exceeds expected', {
                  cartItemCount: cartItemCount,
                  expectedItemCount: expectedItemCount,
                  ratio: (cartItemCount / expectedItemCount).toFixed(2),
                  possibleDuplicates: true
                });
              }
              
              // CRITICAL FIX (Order #67156086817141): Check for naked parent instances
              var nakedParents = [];
              if (cart.items && data && data.items) {
                var requestedParentVariants = data.items
                  .filter(function(item) { return !item.properties || !item.properties._ParentVariant; })
                  .map(function(item) { return item.id; });
                
                requestedParentVariants.forEach(function(parentVariantId) {
                  var allInstancesOfParent = cart.items.filter(function(item) {
                    return item.variant_id === parentVariantId;
                  });
                  
                  var nakedInstances = allInstancesOfParent.filter(function(item) {
                    return !item.properties || 
                           (!item.properties._customization_data && 
                            !item.properties._has_customization &&
                            !item.properties['Application Method 1']);
                  });
                  
                  if (nakedInstances.length > 0) {
                    nakedInstances.forEach(function(naked) {
                      nakedParents.push({
                        variantId: naked.variant_id,
                        key: naked.key,
                        quantity: naked.quantity,
                        title: naked.title
                      });
                    });
                  }
                });
              }
              
              if (nakedParents.length > 0) {
                mrkDebug.error('[Cart] 🚨 NAKED PARENT VARIANTS DETECTED - these should not exist for customizable products!', {
                  count: nakedParents.length,
                  nakedParents: nakedParents
                });
              }
              
              if (window.regularProductDebugLog && window.regularProductDebugLog.steps) {
                window.regularProductDebugLog.steps.push({
                  step: 'post_add_verification',
                  status: allPresent ? 'success' : 'error',
                  details: {
                    cartItemCount: cartItemCount,
                    expectedItemCount: expectedItemCount,
                    parentFound: parentInCart >= 1,
                    logoItemsFound: logoInCart,
                    logoItemsExpected: expectedLogoCount,
                    allPresent: allPresent,
                    missingItems: allPresent ? [] : (expectedItemCount - cartItemCount),
                    parentQuantities: parentQuantities, // BUG FIX: Track parent quantities
                    hasCountMismatch: hasCountMismatch, // FIX #67156086817141: Flag suspicious cart states
                    nakedParentsCount: nakedParents.length, // FIX #67156086817141: Track naked parents
                    nakedParents: nakedParents // FIX #67156086817141: Detailed naked parent info
                  },
                  time: new Date().toISOString()
                });
              }
              // BUG FIX (CART-VAL-005): Log parent quantities for debugging
              mrkDebug.log('[Cart] 🔍 POST_ADD_VERIFICATION - Parent quantities:', parentQuantities);
              
              // CRITICAL FIX: Check for quantity mismatches and fix them immediately
              var quantityFixes = [];
              if (data && data.items && cart.items) {
                var parentItemsInRequest = data.items.filter(function(item) {
                  return !item.properties || !item.properties._ParentVariant;
                });
                
                parentItemsInRequest.forEach(function(requestItem) {
                  var cartItem = cart.items.find(function(item) {
                    return item.variant_id === requestItem.id && (!item.properties || !item.properties._ParentVariant);
                  });
                  
                  if (cartItem && cartItem.quantity !== requestItem.quantity) {
                    mrkDebug.error('[Regular Product] ❌ QUANTITY MISMATCH DETECTED! Requested:', requestItem.quantity, 'but cart has:', cartItem.quantity, 'for variant:', requestItem.id);
                    mrkDebug.log('[Regular Product] 🔧 Fixing quantity from', cartItem.quantity, 'to', requestItem.quantity, 'for variant:', requestItem.id);
                    
                    quantityFixes.push({
                      key: cartItem.key,
                      variantId: requestItem.id,
                      requestedQuantity: requestItem.quantity,
                      actualQuantity: cartItem.quantity
                    });
                  }
                });
              }
              
              // Fix quantity mismatches immediately
              if (quantityFixes.length > 0) {
                mrkDebug.log('[Regular Product] 🔧 Fixing', quantityFixes.length, 'quantity mismatch(es)...');
                var fixPromises = quantityFixes.map(function(fix) {
                  return new Promise(function(resolve, reject) {
                    jQuery.ajax({
                      type: 'POST',
                      url: '/cart/change.js',
                      data: {
                        id: fix.key,
                        quantity: fix.requestedQuantity
                      },
                      dataType: 'json',
                      success: function(response) {
                        mrkDebug.log('[Regular Product] ✅ Fixed quantity for variant', fix.variantId, 'from', fix.actualQuantity, 'to', fix.requestedQuantity);
                        resolve(response);
                      },
                      error: function(jqXHR, textStatus, errorThrown) {
                        mrkDebug.error('[Regular Product] ❌ Failed to fix quantity for variant', fix.variantId, ':', errorThrown);
                        reject(errorThrown);
                      }
                    });
                  });
                });
                
                Promise.allSettled(fixPromises).then(function() {
                  mrkDebug.log('[Regular Product] ✅ Completed quantity fixes');
                  proceedToNavigation();
                });
              } else {
                // Cart-fetch verification path: response said items were added, but Shopify's
                // async cart-merge can drop a child between /cart/add.js and /cart.js. Build
                // missingItemsFromCart by comparing the original payload to what /cart.js
                // actually returned (#60463 — child dropped after a successful response). The
                // key format mirrors the response-based check above (variantId_logoId_position).
                var missingItemsFromCart = [];
                if (data.items && cart.items) {
                  var cartItemsByKey = {};
                  cart.items.forEach(function(item) {
                    if (item.properties && item.properties._ParentVariant) {
                      var key = item.variant_id + '_' + (item.properties['Logo Id'] || '') + '_' + (item.properties.Position || '').replace(/\s/g, '_');
                      if (!cartItemsByKey[key]) cartItemsByKey[key] = [];
                      cartItemsByKey[key].push(item);
                    }
                  });

                  data.items.forEach(function(requestItem) {
                    if (requestItem.properties && requestItem.properties._ParentVariant) {
                      var rkey = requestItem.id + '_' + (requestItem.properties['Logo Id'] || '') + '_' + (requestItem.properties.Position || '').replace(/\s/g, '_');
                      var found = cartItemsByKey[rkey] && cartItemsByKey[rkey].length > 0;
                      if (!found) {
                        missingItemsFromCart.push({
                          variantId: requestItem.id,
                          quantity: requestItem.quantity,
                          logoId: requestItem.properties['Logo Id'],
                          position: requestItem.properties.Position,
                          parentVariant: requestItem.properties._ParentVariant,
                          requestItem: requestItem
                        });
                      }
                    }
                  });
                }

                if (missingItemsFromCart.length > 0) {
                  if (window.regularProductDebugLog && window.regularProductDebugLog.steps) {
                    window.regularProductDebugLog.steps.push({
                      step: 'cart_add_missing_items_detected',
                      status: 'error',
                      details: {
                        missingCount: missingItemsFromCart.length,
                        missingItems: missingItemsFromCart.map(function(m) {
                          return {
                            variantId: m.variantId,
                            quantity: m.quantity,
                            logoId: m.logoId,
                            position: m.position
                          };
                        }),
                        note: 'Items missing from /cart.js verification (Shopify async drop) - attempting silent recovery'
                      },
                      time: new Date().toISOString()
                    });
                  }
                  _attemptRecoveryThenProceed(missingItemsFromCart);
                } else {
                  proceedToNavigation();
                }
              }
            })
            .catch(function(err) {
              if (window.regularProductDebugLog && window.regularProductDebugLog.steps) {
                window.regularProductDebugLog.steps.push({
                  step: 'post_add_verification',
                  status: 'error',
                  details: { error: String(err), note: 'Failed to fetch cart for verification' },
                  time: new Date().toISOString()
                });
              }
              proceedToNavigation(); // Proceed on fetch error to avoid blocking user
            });
        }
        
        function proceedToNavigation() {
          // P0.8 — Universal post-add verification + recovery via JRS.CartValidator.
          // Fires in parallel; the validator recovers truly-missing children sequentially and persists
          // its result via _persistValidationSummary. Result is logged but does not block navigation.
          if (window.JRS && JRS.CartValidator && typeof JRS.CartValidator.verifyAfterAdd === 'function') {
            try {
              JRS.CartValidator.verifyAfterAdd(data, resp).then(function(validatorResult) {
                if (window.regularProductDebugLog && window.regularProductDebugLog.steps) {
                  window.regularProductDebugLog.steps.push({
                    step: 'jrs_validator_verifyAfterAdd',
                    status: validatorResult && validatorResult.valid ? 'success' : 'error',
                    details: {
                      valid: !!(validatorResult && validatorResult.valid),
                      issuesFound: validatorResult && validatorResult.issues ? validatorResult.issues.length : 0,
                      issuesFixed: (validatorResult && validatorResult.issuesFixed) || 0,
                      issues: (validatorResult && validatorResult.issues) || []
                    },
                    time: new Date().toISOString()
                  });
                }
              }).catch(function(err) {
                if (window.regularProductDebugLog && window.regularProductDebugLog.steps) {
                  window.regularProductDebugLog.steps.push({
                    step: 'jrs_validator_verifyAfterAdd',
                    status: 'error',
                    details: { error: (err && err.message) || String(err) },
                    time: new Date().toISOString()
                  });
                }
              });
            } catch (e) {
              mrkDebug.warn('[Regular Product] JRS.CartValidator.verifyAfterAdd threw:', e && e.message);
            }
          }

          // CRITICAL FIX (Order #Multi-Size Bug): Wait for property recovery to complete before navigating
          // This ensures missing properties are attached before user sees the cart
          var doNavigate = function() {
            // CRITICAL FIX (Order #52426): Persist updated debug log AFTER Cart API response
            persistDebugLogToCart();

            // Run 3 (revert 2026-09-02) — the router fires post_add_complete;
            // on the REDIRECT arm it takes over the navigation. On the modal
            // arm we fall through UNCHANGED to the original variantaug
            // branches (cart-notification-mrk popup / redirect). The
            // in-customizer cart refresh branch (refreshCart truthy,
            // non-notification) is not an add completion — untouched.
            if (window.JRS && window.JRS.PostAdd && typeof window.JRS.PostAdd.complete === 'function' &&
                (refreshCart == 'notification' || !refreshCart) &&
                window.JRS.PostAdd.complete({
                  path: refreshCart == 'notification' ? 'legacy_notification' : 'legacy_regular'
                }) === 'redirect') {
              $('[data-submit-button] [data-submit-button-text]').removeClass('loading');
              $('.loading-overlay__spinner').addClass('hidden');
              return;
            }

            if (refreshCart == 'notification') {
              initNotification(resp);
            } else if (refreshCart) {
              $('.mrk-customizer-cart').hide()
              updateCart();
            } else {
              location.pathname = '/cart';
            }
          };
          
          // If recovery is in progress, wait for it to complete
          if (resp && resp._recoveryPromise) {
            // Add timeout fallback to prevent indefinite waiting (max 5 seconds)
            var timeoutId = setTimeout(function() {
              mrkDebug.warn('[Regular Product] Property recovery timeout - proceeding with navigation');
              doNavigate();
            }, 5000);
            
            resp._recoveryPromise.then(function(recoveryResult) {
              clearTimeout(timeoutId);
              mrkDebug.log('[Regular Product] Property recovery completed:', recoveryResult);
              // Small delay to ensure cart is updated before navigation
              setTimeout(doNavigate, 300);
            }).catch(function(error) {
              clearTimeout(timeoutId);
              mrkDebug.warn('[Regular Product] Property recovery failed, proceeding with navigation:', error);
              doNavigate();
            });
          } else {
            // No recovery needed, proceed immediately
            doNavigate();
          }
        }

        // Re-add child line items that Shopify dropped during the bulk add. Caller passes the
        // missingItem objects produced by either the response-based check or the /cart.js fetch
        // verification. Each missingItem MUST carry `requestItem` (the original payload entry)
        // so the recovery POSTs identical properties (Logo URL, Logo Filename, Logo Text*, etc.)
        // — falling back to a minimal property set drops fulfilment data and is only used when
        // requestItem isn't available.
        //
        // Always proceeds to navigation when done, regardless of whether every item recovered.
        // The cart-page validateCart heal (jrs-v2-cart-validator.js _applyFixesSequentially
        // 'missing' handler) is the safety net for whatever this attempt couldn't recover.
        function _attemptRecoveryThenProceed(missingItemsToRecover) {
          if (!missingItemsToRecover || missingItemsToRecover.length === 0) {
            proceedToNavigation();
            return;
          }

          var recoveryPromises = missingItemsToRecover.map(function(missingItem, idx) {
            return new Promise(function(resolve) {
              setTimeout(function() {
                var payload = missingItem.requestItem
                  ? {
                      items: [{
                        id: missingItem.requestItem.id,
                        quantity: missingItem.requestItem.quantity || 1,
                        properties: missingItem.requestItem.properties || {}
                      }]
                    }
                  : {
                      items: [{
                        id: missingItem.variantId,
                        quantity: missingItem.quantity,
                        properties: {
                          '_ParentVariant': String(missingItem.parentVariant || ''),
                          'Logo Id': missingItem.logoId,
                          'Position': missingItem.position
                        }
                      }]
                    };
                jQuery.ajax({
                  type: 'POST',
                  url: '/cart/add.js',
                  contentType: 'application/json',
                  data: JSON.stringify(payload),
                  dataType: 'json'
                }).done(function() {
                  if (window.regularProductDebugLog && window.regularProductDebugLog.steps) {
                    window.regularProductDebugLog.steps.push({
                      step: 'cart_add_recovery_success',
                      status: 'success',
                      details: {
                        variantId: missingItem.variantId,
                        logoId: missingItem.logoId,
                        quantity: missingItem.quantity
                      },
                      time: new Date().toISOString()
                    });
                  }
                  resolve({ success: true, item: missingItem });
                }).fail(function(jqXHR, textStatus) {
                  if (window.regularProductDebugLog && window.regularProductDebugLog.steps) {
                    window.regularProductDebugLog.steps.push({
                      step: 'cart_add_recovery_failed',
                      status: 'error',
                      details: {
                        variantId: missingItem.variantId,
                        logoId: missingItem.logoId,
                        error: textStatus,
                        status: jqXHR.status
                      },
                      time: new Date().toISOString()
                    });
                  }
                  resolve({ success: false, item: missingItem, error: textStatus });
                });
              }, idx * 200);
            });
          });

          Promise.all(recoveryPromises).then(function(results) {
            var recovered = results.filter(function(r) { return r.success; }).length;
            var failed = results.filter(function(r) { return !r.success; });

            if (window.regularProductDebugLog && window.regularProductDebugLog.steps) {
              window.regularProductDebugLog.steps.push({
                step: 'cart_add_recovery_complete',
                status: recovered === missingItemsToRecover.length ? 'success' : 'error',
                details: {
                  attempted: missingItemsToRecover.length,
                  recovered: recovered,
                  failed: failed.length,
                  failedItems: failed.map(function(f) {
                    return {
                      variantId: f.item.variantId,
                      logoId: f.item.logoId,
                      error: f.error
                    };
                  })
                },
                time: new Date().toISOString()
              });
            }

            persistDebugLogToCart();
            proceedToNavigation();
          }).catch(function(err) {
            mrkDebug.warn('[Cart Recovery] Recovery promise rejected — proceeding silently', err);
            persistDebugLogToCart();
            proceedToNavigation();
          });
        }

        function persistDebugLogToCart() {
          // CRITICAL FIX (Order #52426): Persist debug log AFTER Cart API response
          // Save to cart attributes (persists to order notes) AND update main product properties
          if (window.regularProductDebugLog && resp && resp.items && JRS_DEBUG_PROPERTIES_IN_CART) {
            var debugLogJson = JSON.stringify(window.regularProductDebugLog);
            
            // Save to cart attributes (persists to order notes)
            // Use a consistent key name so it's easy to find in order notes
            jQuery.ajax({
              type: 'POST',
              url: '/cart/update.js',
              data: {
                attributes: {
                  '_regular_product_debug_log': debugLogJson
                }
              },
              dataType: 'json'
            }).fail(function() {
              mrkDebug.warn('[Regular Product] Failed to persist debug log to cart attributes');
            });
            
            // Also try to update the main product's properties using cart/change.js
            var mainProductInResponse = resp.items.find(function(item) {
              return !item.properties || !item.properties._ParentVariant;
            });
            
            if (mainProductInResponse && mainProductInResponse.key) {
              // Bug K: Merge ALL existing properties before sending — cart/change.js replaces ALL properties
              var mergedProperties = {};
              if (mainProductInResponse.properties) {
                for (var pk in mainProductInResponse.properties) {
                  if (mainProductInResponse.properties.hasOwnProperty(pk)) {
                    mergedProperties[pk] = mainProductInResponse.properties[pk];
                  }
                }
              }
              mergedProperties['_regular_product_debug_log'] = debugLogJson;
              jQuery.ajax({
                type: 'POST',
                url: '/cart/change.js',
                data: {
                  id: mainProductInResponse.key,
                  properties: mergedProperties
                },
                dataType: 'json'
              }).done(function() {
                if (window.regularProductDebugLog && window.regularProductDebugLog.steps) {
                  window.regularProductDebugLog.steps.push({
                    step: 'debug_log_persisted_to_cart',
                    status: 'success',
                    details: {
                      logSize: debugLogJson.length,
                      stepsCount: window.regularProductDebugLog.steps.length,
                      persistedToAttributes: true,
                      persistedToProperties: true
                    },
                    time: new Date().toISOString()
                  });
                }
              }).fail(function() {
                // Properties update failed, but attributes should have succeeded
                if (window.regularProductDebugLog && window.regularProductDebugLog.steps) {
                  window.regularProductDebugLog.steps.push({
                    step: 'debug_log_persisted_to_cart',
                    status: 'warning',
                    details: {
                      logSize: debugLogJson.length,
                      stepsCount: window.regularProductDebugLog.steps.length,
                      persistedToAttributes: true,
                      persistedToProperties: false,
                      note: 'Log saved to cart attributes (order notes) but not item properties'
                    },
                    time: new Date().toISOString()
                  });
                }
              });
            }
          }
        }
      }                
    },
    error: function(jqXHR, textStatus, errorThrown) {
      $('.mrk-loader-main').css('display', 'none');
      
      // CRITICAL FIX (Order #52358): Log Cart API error with request details
      if (window.regularProductDebugLog && window.regularProductDebugLog.steps) {
        var positionVariantsInRequest = data.items ? data.items.filter(function(item) {
          return item.properties && item.properties._ParentVariant;
        }) : [];

        window.regularProductDebugLog.steps.push({
          step: 'cart_add_api_error',
          status: 'error',
          details: {
            status: jqXHR.status,
            statusText: textStatus,
            error: errorThrown,
            response: jqXHR.responseJSON,
            requestPayload: {
              itemsCount: data.items ? data.items.length : 0,
              positionVariantsInRequest: positionVariantsInRequest.length,
              note: 'Cart API call failed - items were NOT added to cart'
            }
          },
          time: new Date().toISOString()
        });

        // P1.4 — Spec-named cart_add_failed step.
        window.regularProductDebugLog.steps.push({
          step: 'cart_add_failed',
          status: 'error',
          details: {
            httpStatus: jqXHR.status,
            statusText: textStatus,
            error: errorThrown,
            itemsRequested: data.items ? data.items.length : 0,
            itemsAdded: 0,
            itemsLost: data.items ? data.items.length : 0
          },
          time: new Date().toISOString()
        });
      }
      
      // CRITICAL FIX: Log cart add errors to debug log (Order #51786 fix)
      if (window.regularProductDebugLog) {
        var positionVariantsInRequest = data.items ? data.items.filter(function(item) {
          return item.properties && item.properties._ParentVariant;
        }) : [];
        
        if (window.regularProductDebugLog.steps) {
          window.regularProductDebugLog.steps.push({
            step: 'cart_add_error',
            status: 'error',
            details: {
              status: jqXHR.status,
              statusText: textStatus,
              error: errorThrown,
              response: jqXHR.responseJSON,
              expectedItems: data.items ? data.items.length : 0,
              positionVariantsInRequest: positionVariantsInRequest.length,
              requestItems: data.items ? data.items.map(function(item) {
                return {
                  id: item.id,
                  quantity: item.quantity,
                  isChild: !!(item.properties && item.properties._ParentVariant),
                  logoId: item.properties && item.properties['Logo Id'] || null,
                  position: item.properties && item.properties.Position || null,
                  parentVariant: item.properties && item.properties._ParentVariant || null
                };
              }) : [],
              errorDetails: {
                statusCode: jqXHR.status,
                statusText: textStatus,
                errorMessage: errorThrown,
                responseText: jqXHR.responseText ? jqXHR.responseText.substring(0, 500) : null,
                responseJSON: jqXHR.responseJSON
              }
            },
            time: new Date().toISOString()
          });
        }
        
        if (window.regularProductDebugLog.errors) {
          window.regularProductDebugLog.errors.push({
            message: 'Cart add API error',
            details: {
              status: jqXHR.status,
              statusText: textStatus,
              error: errorThrown,
              response: jqXHR.responseJSON,
              positionVariantsInRequest: positionVariantsInRequest.length,
              impact: 'CRITICAL: Cart add failed - items not added to cart'
            },
            time: new Date().toISOString()
          });
        }
      }
      
      // Order #55693: Persist debug log on error so order/cart has record of failure
      if (typeof JRS_DEBUG_PROPERTIES_IN_CART !== 'undefined' && JRS_DEBUG_PROPERTIES_IN_CART && window.regularProductDebugLog) {
        var errorLogJson = JSON.stringify(window.regularProductDebugLog);
        jQuery.ajax({
          type: 'POST',
          url: window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/update.js' : '/cart/update.js',
          data: {
            attributes: {
              '_regular_product_debug_log': errorLogJson
            }
          },
          dataType: 'json'
        }).fail(function() {
          mrkDebug.warn('[addItemToCart] Failed to persist debug log to cart attributes on error');
        });
      }
      
      // Order #55693: Optional recovery when cart add fails — if parent was added in a previous request, try to add missing children
      if (typeof window.validateCartItems === 'function' && typeof window.addMissingChildItems === 'function') {
        window.validateCartItems(false).then(function(result) {
          if (result && result.missingItems && result.missingItems.length > 0) {
            mrkDebug.log('[addItemToCart] Cart add failed; attempting recovery for', result.missingItems.length, 'missing child item(s)');
            window.addMissingChildItems(result.missingItems, false);
          }
        }).catch(function() { /* recovery is best-effort */ });
      }
      
      // mrkDebug.error('[Regular Product] Cart API Error:', {
        // status: jqXHR.status,
        // statusText: textStatus,
        // error: errorThrown,
        // response: jqXHR.responseJSON,
        // requestData: data
      // });
      
      var errorMessage = 'Unable to add items to cart. Please try again.';
      
      if (jqXHR.responseJSON) {
        if (jqXHR.responseJSON.description) {
          errorMessage = jqXHR.responseJSON.description;
        } else if (jqXHR.responseJSON.message) {
          errorMessage = jqXHR.responseJSON.message;
        } else if (jqXHR.responseJSON.errors) {
          errorMessage = 'Error: ' + JSON.stringify(jqXHR.responseJSON.errors);
        }
      }
      
      // Check if it's a variant-related error
      if (jqXHR.responseJSON && jqXHR.responseJSON.status === 422) {
        errorMessage = 'Some items could not be added (possibly out of stock or invalid). Please check your selections and try again.';
      }
      
      // Error logged but no alert shown
    }
  });
}

function buildMainVariant(ParentVariantId, qty, hasPositionsChecked) {
    window.__noopLog('[buildMainVariant] ✅ Function called!', {
        parentVariantId: ParentVariantId,
        qty: qty,
        hasPositionsChecked: hasPositionsChecked
    });
    
    // Defensive validation
    if (!ParentVariantId || ParentVariantId === 0 || isNaN(Number(ParentVariantId))) {
        console.error('[buildMainVariant] ❌ Invalid ParentVariantId:', ParentVariantId);
        // mrkDebug.error('[Regular Product] buildMainVariant called with invalid ParentVariantId:', ParentVariantId);
        trackRegularProductError('Invalid ParentVariantId in buildMainVariant', {
            ParentVariantId: ParentVariantId,
            qty: qty
        });
        return null;
    }
    
    if (!qty || qty <= 0 || isNaN(Number(qty))) {
        window.__noopLog('[buildMainVariant] ⚠️ Invalid qty, defaulting to 1');
        // mrkDebug.warn('[Regular Product] buildMainVariant called with invalid qty:', qty, 'defaulting to 1');
        qty = 1;
    }
    
    // Default hasPositionsChecked to true for backward compatibility
    if (hasPositionsChecked === undefined) {
        hasPositionsChecked = true;
    }
    
    window.__noopLog('[buildMainVariant] Building properties object...');
    
    // CRITICAL FIX (Order #Multi-Size Bug): Create a NEW properties object for EACH parent variant
    // This ensures properties are not shared between multiple sizes of the same product
    var properties = {};
    
    window.__noopLog('[buildMainVariant] hasPositionsChecked:', hasPositionsChecked);
    
    // CRITICAL FIX: Only read hidden fields if positions are actually checked
    // If no positions are checked, skip reading hidden fields to prevent stale customization data
    // from being attached to products added without customization
    if (hasPositionsChecked) {
        window.__noopLog('[buildMainVariant] Reading hidden fields for customization data...');
        try {
            // Filter hidden fields by variant ID if they have a data-variant-id attribute
            // Otherwise, read all hidden fields (for backward compatibility)
            $('.mrk-hidden-field-item').each(function() {
            try {
                var $field = $(this);
                var variantIdAttr = $field.data('variant-id') || $field.data('variantId') || $field.attr('data-variant-id');
                
                // If hidden field has a variant ID attribute, only include it if it matches current ParentVariantId
                if (variantIdAttr !== undefined && variantIdAttr !== null) {
                    var fieldVariantId = Number(variantIdAttr);
                    if (!isNaN(fieldVariantId) && fieldVariantId !== ParentVariantId) {
                        return; // Skip this field - it belongs to a different variant
                    }
                }
                
                var htmlContent = $field.html();
                if (!htmlContent || htmlContent.trim() === '') {
                    return; // Skip empty hidden fields
                }
                var obj = JSON.parse(htmlContent);
                if (obj && typeof obj === 'object') {
                    $.each(obj, function(key, value) {
                        // Only add non-empty values
                        if (value !== null && value !== undefined && value !== '') {
                            // CRITICAL: Create a deep copy of the value to prevent reference sharing
                            if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
                                properties[key] = $.extend({}, value);
                            } else if (Array.isArray(value)) {
                                properties[key] = value.slice(); // Clone array
                            } else {
                                properties[key] = value; // Primitive value - safe to copy
                            }
                        }
                    });
                }
            } catch(e) {
                // mrkDebug.error('[Regular Product] Failed to parse hidden field in buildMainVariant:', e, $(this).html());
                trackRegularProductError('Failed to parse hidden field', {
                    error: e.message,
                    htmlContent: $(this).html()
                });
            }
        });
        } catch(e) {
            // mrkDebug.error('[Regular Product] Error processing hidden fields:', e);
            trackRegularProductError('Error processing hidden fields', {
                error: e.message
            });
        }
    } else {
        // No positions checked - skip reading hidden fields to prevent stale data
        // mrkDebug.log('[Regular Product] Skipping hidden fields read - no positions checked for variant:', ParentVariantId);
    }
    
    // CRITICAL FIX: Return a deep copy of properties to ensure each parent variant gets its own copy
    // This prevents properties from being shared/modified between multiple sizes
    var clonedProperties = {};
    for (var key in properties) {
        if (properties.hasOwnProperty(key)) {
            var value = properties[key];
            if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
                clonedProperties[key] = $.extend({}, value);
            } else if (Array.isArray(value)) {
                clonedProperties[key] = value.slice();
            } else {
                clonedProperties[key] = value;
            }
        }
    }
    
    window.__noopLog('[buildMainVariant] ✅ Returning main variant', {
        id: ParentVariantId,
        qty: qty,
        propertiesCount: Object.keys(clonedProperties).length
    });
    
    return {
        quantity: Number(qty),
        id: Number(ParentVariantId),
        properties: clonedProperties
    };
}

function buildItem(id, qty, ParentVariantId, logo, logo_id, logoContext) {
    // Validate inputs
    if (!id || id === 0 || isNaN(Number(id))) {
        // mrkDebug.error('[Regular Product] buildItem called with invalid id:', id);
        return null;
    }
    
    if (!qty || qty <= 0) {
        qty = 1;
    }
    
    if (ParentVariantId === '' || !ParentVariantId) {
        // Plain item (no customization). Use distinct properties so Shopify keeps a separate line
        // and never merges with an existing customized line (same variant, different properties).
        var plainProps = {
            _plain_item: '1',
            'Customization': 'None'
        };
        
        // Add comprehensive debug properties
        var debugProps = generateCustomizerDebugProperties('plain', {});
        for (var key in debugProps) {
            if (debugProps.hasOwnProperty(key)) {
                plainProps[key] = debugProps[key];
            }
        }
        
        return {
            quantity: qty,
            id: Number(id),
            properties: plainProps
        };
    } else {
        // Keep parent variant as string for stable Shopify property hashing.
        var parentVariantStr = String(ParentVariantId || '').trim();
        if (!parentVariantStr || parentVariantStr === '0' || parentVariantStr === 'NaN' || parentVariantStr === 'undefined') {
            // mrkDebug.error('[Regular Product] Invalid ParentVariantId:', ParentVariantId);
            return null;
        }
        
        let properties = {
            '_ParentVariant': parentVariantStr,
            '_qty': String(qty),
            '_time': String(Date.now()) // Use current timestamp for regular products
        };
        
        if (logo && logo !== '') {
            properties['Logo'] = logo;
        }
        
        if (logo_id && logo_id !== '') {
            properties['Logo Id'] = logo_id;
        }
        
        // Derive logo filename for image-based logos (Upload / Existing)
        // Use original filename from cache if available, otherwise extract from URL
        if (logo && logo !== '') {
            var logoFileName = getOriginalLogoFilename(logo);
            if (logoFileName) {
                properties['Logo Filename'] = logoFileName;
            }
        }
        
        // BUG FIX (Order #53563 - BUG 4): Use logoContext if provided, otherwise derive from logo URL
        var logoSource = 'unknown';
        var logoType = '';
        var logoValue = logo || '';
        
        if (logoContext) {
            // Use provided context (preferred - more accurate)
            logoSource = logoContext.logoSource || 'unknown';
            logoType = logoContext.logoType || '';
            logoValue = logoContext.logoValue || '';
        } else {
            // Fallback: derive from logo URL (old behavior)
            if (logo && logo.indexOf('upload') !== -1) {
                logoSource = 'upload';
                logoType = 'Upload Your Logo';
            } else if (logo && logo.indexOf('existing') !== -1) {
                logoSource = 'existing';
                logoType = 'Existing Logo';
            } else if (logo && logo.indexOf('text') !== -1) {
                logoSource = 'text';
                logoType = 'Text Logo';
            }
        }
        
        // CRITICAL FIX (BUG 1): Add text logo content to child items for fulfillment
        // When logoType is "Text Logo", the child item needs Logo Text properties
        // so fulfillment staff can see what to embroider/print
        if (logoType === 'Text Logo' && logoContext && logoContext.textLogoData) {
            mrkDebug.log('[buildItem] Adding text logo properties to child:', {
                hasLogoContext: !!logoContext,
                hasTextData: !!logoContext.textLogoData,
                text1: logoContext.textLogoData.text1 || 'missing',
                text2: logoContext.textLogoData.text2 || 'missing',
                color: logoContext.textLogoData.color || 'missing',
                font: logoContext.textLogoData.font || 'missing',
                willAddToProperties: true
            });
            
            var textData = logoContext.textLogoData;
            if (textData.text1) properties['Logo Text'] = textData.text1;
            if (textData.text2) properties['Logo Text 2'] = textData.text2;
            if (textData.text3) properties['Logo Text 3'] = textData.text3;
            if (textData.text4) properties['Logo Text 4'] = textData.text4;
            if (textData.color) properties['Logo Color'] = textData.color;
            if (textData.font) properties['Logo Font'] = textData.font;
            if (textData.note) properties['Note'] = textData.note;
        } else if (logoType === 'Text Logo') {
            mrkDebug.warn('[buildItem] Text Logo but no textLogoData available:', {
                hasLogoContext: !!logoContext,
                hasTextData: logoContext ? !!logoContext.textLogoData : false,
                logoContextKeys: logoContext ? Object.keys(logoContext) : []
            });
        }
        
        var debugProps = generateCustomizerDebugProperties('child', {
            qtyRatio: qty,
            positionValidated: true, // Position set via customizer
            methodValidated: true, // Method set via customizer
            logoSource: logoSource,
            logoType: logoType,
            logoValue: logoValue,
            textLogoData: logoContext ? logoContext.textLogoData : null // CRITICAL FIX (BUG 3): Pass text logo data for debug properties
        });
        
        // Merge debug properties
        for (var key in debugProps) {
            if (debugProps.hasOwnProperty(key)) {
                properties[key] = debugProps[key];
            }
        }

        return {
            quantity: qty,
            id: Number(id),
            properties: properties
        };
    }
}



// new js code  
function getLogoDetails(index,logoType,checkedLogo) {
    var logo = {};

if (document.querySelector(".same-logo-label").classList.contains("selected")){
    if (logoType == 'Upload Your Logo') {
        // Order #55535: Method 0 - Check session memory FIRST (highest priority), mirrors different-logo branch
        var logoUrl = '';
        var noteValue = $('.customerNotesFilesUploadedLogo-original').val() || '';
        if (window._currentSessionLogoData) {
            var allPositions = Object.keys(window._currentSessionLogoData);
            for (var sp = 0; sp < allPositions.length; sp++) {
                var sessionData = window._currentSessionLogoData[allPositions[sp]];
                if (sessionData && sessionData.logoUrl && sessionData.logoType === 'Upload Your Logo') {
                    logoUrl = sessionData.logoUrl;
                    break;
                }
            }
        }
        // Existing DOM fallbacks (only if session memory didn't have it)
        if (!logoUrl) {
            logoUrl = $('.input-file-logo-original[name="properties[Uploaded Logo]"]').val() || '';
        }
        // Fallback 1: Check .input-file-logo-original without name attribute
        if (!logoUrl) {
            logoUrl = $('.input-file-logo-original').val() || '';
        }
        // Fallback 2: Check any .input-file-logo with a value
        if (!logoUrl) {
            var allInputs = $('.input-file-logo');
            for (var i = 0; i < allInputs.length; i++) {
                var val = $(allInputs[i]).val();
                if (val && val.indexOf('http') === 0) {
                    logoUrl = val;
                    break;
                }
            }
        }
        
        // Debug logging
        if (typeof console !== 'undefined') {
            mrkDebug.log('[CUSTOMIZER] getLogoDetails for Upload Your Logo (same-logo mode, ISSUE-1 fix):', {
                index: index,
                mode: 'same-logo',
                foundUrl: !!logoUrl,
                urlPreview: logoUrl ? logoUrl.substring(0, 60) + '...' : 'NOT FOUND'
            });
        }
        
        // Derive filename from URL for image logos
        // Use original filename from cache if available
        var logoFileName = '';
        if (logoUrl) {
          logoFileName = getOriginalLogoFilename(logoUrl);
        }
        
        logo = {
            [`Logo ${index}`]: logoUrl,
            [`Logo Filename ${index}`]: logoFileName,
            [`Note ${index}`]: noteValue
        };
    } else if (logoType == 'Existing Logo') {
        // Order #55535: Method 0 - Check session memory FIRST (highest priority), mirrors different-logo branch
        var existingUrlSame = '';
        if (window._currentSessionLogoData) {
            var allPositionsExisting = Object.keys(window._currentSessionLogoData);
            for (var spEx = 0; spEx < allPositionsExisting.length; spEx++) {
                var sessionDataExisting = window._currentSessionLogoData[allPositionsExisting[spEx]];
                if (sessionDataExisting && sessionDataExisting.logoUrl && sessionDataExisting.logoType === 'Existing Logo') {
                    existingUrlSame = sessionDataExisting.logoUrl;
                    break;
                }
            }
        }
        if (!existingUrlSame) {
            existingUrlSame = $('.input-file-logo-existing-original[name="properties[Existing Logo]"]').val() || '';
        }
        var existingFileNameSame = '';
        if (existingUrlSame) {
          existingFileNameSame = getOriginalLogoFilename(existingUrlSame);
        }
        logo = {
            [`Logo ${index}`]: existingUrlSame,
            [`Logo Filename ${index}`]: existingFileNameSame,
            [`Note ${index}`]: $('.customerNotesFilesExisting-original').val()
        };
    } else if (logoType == 'Text Logo') {
        logo = {
            [`Logo Text ${index}`]: $('.logoText-original-1[name="properties[Text Line]"]').val(),
            [`Logo Text 2 ${index}`]: $('.logoText-original-2[name="properties[Text Line 2]"]').val(),
            [`Logo Text 3 ${index}`]: $('.logoText-original-3[name="properties[Text Line 3]"]').val(),
            [`Logo Text 4 ${index}`]: $('.logoText-original-4[name="properties[Text Line 4]"]').val(),
            [`Logo Color ${index}`]: $('.logoColor-original').val(),
            [`Logo Font ${index}`]: $('.font-family-original').val(),
            [`Note ${index}`]: $('.notesLogoText-original').val()
        };
    }  

} 
else {
  // mrkDebug.log(checkedLogo)
  // FIXED (ISSUE-1): Improved idxPosition derivation with fallback logic
  // Previous code: checkedLogo.firstElementChild.getAttribute("name").slice(-1)
  // Problem: slice(-1) only gets last character, fails for multi-digit indices
  let idxPosition = index; // Default to function parameter
  
  // Try to get from name attribute with regex (handles multi-digit indices)
  try {
      if (checkedLogo && checkedLogo.firstElementChild) {
          var nameAttr = checkedLogo.firstElementChild.getAttribute("name");
          if (nameAttr) {
              // Extract number from name (handle multi-digit indices)
              var match = nameAttr.match(/\d+$/);
              if (match) {
                  idxPosition = match[0];
              }
          }
      }
  } catch(e) {
      // Use default (index parameter)
  }
  
  // Fallback: Use data-position-index if available
  if (!idxPosition || idxPosition === index) {
      try {
          if (checkedLogo && checkedLogo.getAttribute('data-position-index')) {
              idxPosition = checkedLogo.getAttribute('data-position-index');
          }
      } catch(e) {}
  }
  
  // Debug logging
  if (typeof console !== 'undefined') {
      mrkDebug.log('[CUSTOMIZER] Position index derived (ISSUE-1 fix):', {
          index: index,
          idxPosition: idxPosition,
          nameAttr: (checkedLogo && checkedLogo.firstElementChild) ? checkedLogo.firstElementChild.getAttribute("name") : 'N/A'
      });
  }
  
    if (logoType == 'Upload Your Logo') {
        // FIXED (ISSUE-1): Enhanced logo URL lookup with multiple fallback methods
        // Previous code relied on a single fragile selector that failed to find uploaded URLs
        var logoUrl = '';
        var noteValue = '';
        
        // CRITICAL FIX (LOGO-URL-001): Method 0 - Check session memory FIRST (highest priority)
        if (window._currentSessionLogoData) {
            var positionNameForLookup = checkedLogo ? 
                (checkedLogo.firstElementChild ? checkedLogo.firstElementChild.value : null) : null;
            
            if (positionNameForLookup && window._currentSessionLogoData[positionNameForLookup]) {
                logoUrl = window._currentSessionLogoData[positionNameForLookup].logoUrl || '';
                if (logoUrl) {
                    mrkDebug.log('[CUSTOMIZER] Logo URL from session memory (Method 0):', {
                        index: index,
                        position: positionNameForLookup,
                        urlPreview: logoUrl.substring(0, 60) + '...',
                        source: 'session_memory_priority'
                    });
                }
            }
        }
        
        // Method 1: Position-specific container (only if session memory didn't have it)
        if (!logoUrl) {
            try {
                var posSpecific = document.querySelector(`.mrk-step-upload-your-logo-position-${idxPosition}`);
                if (posSpecific) {
                    var propInput = posSpecific.querySelector('input[name="properties[Uploaded Logo]"]');
                    if (propInput && propInput.value) logoUrl = propInput.value;
                    var noteInput = posSpecific.querySelector('textarea.customerNotesFilesUploadedLogo-position');
                    if (noteInput && noteInput.value) noteValue = noteInput.value;
                }
            } catch(e) {
                // Continue to fallback methods
            }
        }
        
        // Method 2: Fallback to .input-file-logo in checked position container
        if (!logoUrl && checkedLogo) {
            try {
                var inputFileLogo = checkedLogo.querySelector('.input-file-logo');
                if (inputFileLogo && inputFileLogo.value) {
                    logoUrl = inputFileLogo.value;
                }
            } catch(e) {}
        }
        
        // Method 3: Fallback to same-logo mode container (if user switched modes)
        if (!logoUrl) {
            try {
                var sameLogo = document.querySelector('.input-file-logo-original[name="properties[Uploaded Logo]"]');
                if (sameLogo && sameLogo.value) {
                    logoUrl = sameLogo.value;
                }
            } catch(e) {}
        }
        
        // Method 4: Check any properties[Uploaded Logo] input in the position container
        if (!logoUrl && checkedLogo) {
            try {
                var anyUploadInput = checkedLogo.querySelector('[name="properties[Uploaded Logo]"]');
                if (anyUploadInput && anyUploadInput.value) {
                    logoUrl = anyUploadInput.value;
                }
            } catch(e) {}
        }
        
        // Method 5: Last resort - check for any .input-file-logo with a value in the DOM
        if (!logoUrl) {
            try {
                var allFileInputs = document.querySelectorAll('.input-file-logo');
                for (var i = 0; i < allFileInputs.length; i++) {
                    if (allFileInputs[i].value && allFileInputs[i].value.indexOf('http') === 0) {
                        logoUrl = allFileInputs[i].value;
                        break;
                    }
                }
            } catch(e) {}
        }
        
        // Debug logging
        if (typeof console !== 'undefined') {
            mrkDebug.log('[CUSTOMIZER] getLogoDetails for Upload Your Logo (ISSUE-1 fix):', {
                index: index,
                idxPosition: idxPosition,
                foundUrl: !!logoUrl,
                urlPreview: logoUrl ? logoUrl.substring(0, 60) + '...' : 'NOT FOUND',
                urlLength: logoUrl ? logoUrl.length : 0,
                methods: {
                    posSpecific: !!document.querySelector(`.mrk-step-upload-your-logo-position-${idxPosition}`),
                    inputFileLogo: !!(checkedLogo && checkedLogo.querySelector('.input-file-logo')),
                    sameLogo: !!document.querySelector('.input-file-logo-original'),
                    anyUploadInput: !!(checkedLogo && checkedLogo.querySelector('[name="properties[Uploaded Logo]"]'))
                }
            });
        }
        
        // Warning if URL still not found
        if (!logoUrl) {
            if (window.regularProductDebugLog && window.regularProductDebugLog.warnings) {
                window.regularProductDebugLog.warnings.push({
                    message: 'Logo URL not found for Upload Your Logo after all fallback methods',
                    details: {
                        index: index,
                        logoType: logoType,
                        idxPosition: idxPosition,
                        checkedLogoElement: checkedLogo ? checkedLogo.outerHTML.substring(0, 150) : 'N/A'
                    },
                    time: new Date().toISOString()
                });
            }
        }
        
        // Derive filename from URL for image logos
        // Use original filename from cache if available
        var logoFileName = '';
        if (logoUrl) {
          logoFileName = getOriginalLogoFilename(logoUrl);
        }
        
        logo = {
            [`Logo ${index}`]: logoUrl,
            [`Logo Filename ${index}`]: logoFileName,
            [`Note ${index}`]: noteValue
        };
    } else if (logoType == 'Existing Logo') {
        // FIXED (ISSUE-1): Enhanced existing logo URL lookup with multiple fallback methods
        var logoUrl = '';
        var noteValue = '';
        
        // Method 1: Position-specific container (original logic)
        try {
            var posSpecific = document.querySelector(`.mrk-step-existing-logo-position-${idxPosition}`);
            if (posSpecific) {
                var propInput = posSpecific.querySelector('input[name="properties[Existing Logo]"]');
                if (propInput && propInput.value) logoUrl = propInput.value;
                var noteInput = posSpecific.querySelector('textarea.customerNotesFilesExisting-position');
                if (noteInput && noteInput.value) noteValue = noteInput.value;
            }
        } catch(e) {}
        
        // Method 2: Fallback to same-logo mode container
        if (!logoUrl) {
            try {
                var sameLogo = document.querySelector('.input-file-logo-existing-original[name="properties[Existing Logo]"]');
                if (sameLogo && sameLogo.value) logoUrl = sameLogo.value;
            } catch(e) {}
        }
        
        // Method 3: Check .input-file-logo in checked position container
        if (!logoUrl && checkedLogo) {
            try {
                var inputFileLogo = checkedLogo.querySelector('.input-file-logo');
                if (inputFileLogo && inputFileLogo.value) logoUrl = inputFileLogo.value;
            } catch(e) {}
        }
        
        // Method 4: Check any properties[Existing Logo] input
        if (!logoUrl && checkedLogo) {
            try {
                var anyExistingInput = checkedLogo.querySelector('[name="properties[Existing Logo]"]');
                if (anyExistingInput && anyExistingInput.value) logoUrl = anyExistingInput.value;
            } catch(e) {}
        }
        
        // Method 5: Check checked existing logo radio button
        if (!logoUrl) {
            try {
                var existingLogoRadio = document.querySelector('.mrk-existing-logo-item:checked');
                if (existingLogoRadio && existingLogoRadio.value) logoUrl = existingLogoRadio.value;
            } catch(e) {}
        }
        
        // Debug logging
        if (typeof console !== 'undefined') {
            mrkDebug.log('[CUSTOMIZER] getLogoDetails for Existing Logo (ISSUE-1 fix):', {
                index: index,
                idxPosition: idxPosition,
                foundUrl: !!logoUrl,
                urlPreview: logoUrl ? logoUrl.substring(0, 60) + '...' : 'NOT FOUND'
            });
        }
        
        // Warning if URL not found
        if (!logoUrl) {
            if (window.regularProductDebugLog && window.regularProductDebugLog.warnings) {
                window.regularProductDebugLog.warnings.push({
                    message: 'Logo URL not found for Existing Logo after all fallback methods',
                    details: {
                        index: index,
                        logoType: logoType,
                        idxPosition: idxPosition
                    },
                    time: new Date().toISOString()
                });
            }
        }
        
        // Derive filename from URL for image logos
        // Use original filename from cache if available
        var existingFileName = '';
        if (logoUrl) {
          existingFileName = getOriginalLogoFilename(logoUrl);
        }
        
        logo = {
            [`Logo ${index}`]: logoUrl,
            [`Logo Filename ${index}`]: existingFileName,
            [`Note ${index}`]: noteValue
        };
    } else if (logoType == 'Text Logo') {
      // mrkDebug.log(document.querySelector(`.mrk-step-text-logo-position-${idxPosition}`).querySelector('textarea.notesLogoText-position').value)
        logo = {
            [`Logo Text ${index}`]: document.querySelector(`.mrk-step-text-logo-position-${idxPosition}`).querySelector('input.logoText-position-1').value,
            [`Logo Text 2 ${index}`]: document.querySelector(`.mrk-step-text-logo-position-${idxPosition}`).querySelector('input.logoText-position-2').value,
            [`Logo Text 3 ${index}`]: document.querySelector(`.mrk-step-text-logo-position-${idxPosition}`).querySelector('input.logoText-position-3').value,
            [`Logo Text 4 ${index}`]: document.querySelector(`.mrk-step-text-logo-position-${idxPosition}`).querySelector('input.logoText-position-4').value,
            [`Logo Color ${index}`]: document.querySelector(`.mrk-step-text-logo-position-${idxPosition}`).querySelector('.logoColor-position').value,
            [`Logo Font ${index}`]: document.querySelector(`.mrk-step-text-logo-position-${idxPosition}`).querySelector('.font-family-position').value,
            [`Note ${index}`]: document.querySelector(`.mrk-step-text-logo-position-${idxPosition}`).querySelector('textarea.notesLogoText-position').value
        };
    }   
}
  
    return logo;
}

function addHiddenField(index, properties, logoUrl, logoId) {
    var hiddenField = $('<div class="mrk-hidden-field-item"></div>').attr('data-index', index);
    
    // CRITICAL FIX (LOGO-URL-001): Add data attributes for logo URL and ID
    if (index) {
        hiddenField.attr('data-position-index', index);
    }
    if (logoUrl) {
        hiddenField.attr('data-logo-url', logoUrl);
    }
    if (logoId) {
        hiddenField.attr('data-logo-id', logoId);
    }
    
    $(hiddenField).html(JSON.stringify(properties));
    // mrkDebug.log(JSON.stringify(properties), properties);
    $('.mrk-hidden-fields').append(hiddenField);
}

function updateMeta() {
  try {
  // Hotfix: ensure Finish is idempotent.
  // Previously, clicking Finish again appended new hidden fields, causing duplicates
  // and stale logo IDs to be used when building child (position) line items.
  var hiddenFieldsBefore = $('.mrk-hidden-field-item').length;
  $('.mrk-hidden-fields .mrk-hidden-field-item').remove();

  if (document.querySelector(".same-logo-label").classList.contains("selected")) {
    // mrkDebug.log("updateMeta() is called...")

    let allCheckedLogoPositions = document.querySelectorAll(".logo-position-checked");

    allCheckedLogoPositions.forEach((el, idx) => {
      let checkedLogo = el;
      let indexValue = idx + 1;
      let applicationMethod;
      let logoVariant;
      checkedLogo.querySelectorAll(".application-method-container-input").forEach((inputEl) => {
        if (inputEl.checked) {
          applicationMethod = inputEl.value;
        }
      })
      if (applicationMethod == "Print") {
        logoVariant = checkedLogo.firstElementChild.getAttribute("data-printvariant");
      }
      else if (applicationMethod == "Embroidery") {
        logoVariant = checkedLogo.firstElementChild.getAttribute("data-embroideryvariant");
      }
      let position = checkedLogo.firstElementChild.value;
      let logoType = $('[name="logo-type"]:checked').val();
      let logoId = Math.floor(Math.random() * (999998 + 1));
      let logoDetails = getLogoDetails(indexValue, logoType);
      let logo_url = logoDetails[`Logo ${indexValue}`];
      // Order #55535: Track when same_logo produces blank URL after all fallbacks
      if (!logo_url && (logoType === 'Upload Your Logo' || logoType === 'Existing Logo')) {
        mrkDebug.warn('[CUSTOMIZER] same_logo: Logo URL is blank after all fallbacks', {
          index: indexValue,
          logoType: logoType,
          sessionMemoryAvailable: !!window._currentSessionLogoData
        });
      }
      window.logoIdByUrl = window.logoIdByUrl || {};
      if (logo_url && window.logoIdByUrl[logo_url]) {
        logoId = window.logoIdByUrl[logo_url];
      } else {
        if (logo_url) window.logoIdByUrl[logo_url] = logoId;
      }

      // BUG FIX (Order #53563 - BUG 2): Store logo data in session memory
      // This provides fallback if hidden fields are unavailable
      if (!window._currentSessionLogoData) {
        window._currentSessionLogoData = {};
      }
      window._currentSessionLogoData[position] = {
        logoId: logoId,
        logoUrl: logo_url ? encodeURI(logo_url) : logo_url, // CRITICAL FIX (LOGO-URL-003): Encode URL
        logoType: logoType,
        applicationMethod: applicationMethod,
        timestamp: Date.now()
      };
      
      // CRITICAL FIX (TEXT-LOGO-001): Store text logo data in session memory
      if (logoType === 'Text Logo' && logoDetails) {
        window._currentSessionLogoData[position].textLogoData = {
          text1: logoDetails[`Logo Text ${indexValue}`] || '',
          text2: logoDetails[`Logo Text 2 ${indexValue}`] || '',
          text3: logoDetails[`Logo Text 3 ${indexValue}`] || '',
          text4: logoDetails[`Logo Text 4 ${indexValue}`] || '',
          color: logoDetails[`Logo Color ${indexValue}`] || '',
          font: logoDetails[`Logo Font ${indexValue}`] || ''
        };
      }
      
      var genericProperties = {
        [`Application Method ${indexValue}`]: applicationMethod,
        [`Position ${indexValue}`]: position,
        [`Logo Type ${indexValue}`]: logoType,
        [`Logo Id ${indexValue}`]: logoId,
        [`_logoVariant${indexValue}`]: logoVariant
      };
      var properties = Object.assign({}, genericProperties, logoDetails);
      // mrkDebug.log(properties)
      // CRITICAL FIX (LOGO-URL-001): Pass logo URL and ID to addHiddenField
      addHiddenField(indexValue, properties, logo_url, logoId);
    })
    
    trackRegularProductStateChange('hiddenFields_created_sameLogo', {
      before: hiddenFieldsBefore
    }, {
      after: allCheckedLogoPositions.length,
      mode: 'same_logo'
    });
  }
  else {

    let allCheckedLogoPositions = document.querySelectorAll(".logo-position-checked");

    allCheckedLogoPositions.forEach((el, idx) => {
      let checkedLogo = el;
      let indexValue = idx + 1;
      let applicationMethod;
      let logoVariant;
      checkedLogo.querySelectorAll(".application-method-container-input").forEach((inputEl) => {
        if (inputEl.checked) {
          applicationMethod = inputEl.value;
        }
      })
      if (applicationMethod == "Print") {
        logoVariant = checkedLogo.firstElementChild.getAttribute("data-printvariant");
      }
      else if (applicationMethod == "Embroidery") {
        logoVariant = checkedLogo.firstElementChild.getAttribute("data-embroideryvariant");
      }
      let position = checkedLogo.firstElementChild.value;
      let logoType = el.getAttribute("data-logo-type");
      let logoId = Math.floor(Math.random() * (999998 + 1));
      let logoDetails = getLogoDetails(indexValue, logoType, checkedLogo);
      let logo_url = logoDetails[`Logo ${indexValue}`];
      window.logoIdByUrl = window.logoIdByUrl || {};
      if (logo_url && window.logoIdByUrl[logo_url]) {
        logoId = window.logoIdByUrl[logo_url];
      } else {
        if (logo_url) window.logoIdByUrl[logo_url] = logoId;
      }
      // Order #52352: Trace logo URL when building hidden field (for debugging missing URL in bundle_raw)
      if (typeof console !== 'undefined') {
        try {
          mrkDebug.log('[CUSTOMIZER] Logo URL read for hidden field:', { indexValue: indexValue, logoType: logoType, logoId: logoId, hasUrl: !!(logo_url && logo_url.length), urlPreview: logo_url ? String(logo_url).substring(0, 50) + '...' : 'empty', timestamp: Date.now() });
        } catch (e) {}
      }
      
      // BUG FIX (Order #53563 - BUG 2): Store logo data in session memory
      // This provides fallback if hidden fields are unavailable
      if (!window._currentSessionLogoData) {
        window._currentSessionLogoData = {};
      }
      window._currentSessionLogoData[position] = {
        logoId: logoId,
        logoUrl: logo_url ? encodeURI(logo_url) : logo_url, // CRITICAL FIX (LOGO-URL-003): Encode URL
        logoType: logoType,
        applicationMethod: applicationMethod,
        timestamp: Date.now()
      };
      
      // CRITICAL FIX (TEXT-LOGO-001): Store text logo data in session memory
      if (logoType === 'Text Logo' && logoDetails) {
        window._currentSessionLogoData[position].textLogoData = {
          text1: logoDetails[`Logo Text ${indexValue}`] || '',
          text2: logoDetails[`Logo Text 2 ${indexValue}`] || '',
          text3: logoDetails[`Logo Text 3 ${indexValue}`] || '',
          text4: logoDetails[`Logo Text 4 ${indexValue}`] || '',
          color: logoDetails[`Logo Color ${indexValue}`] || '',
          font: logoDetails[`Logo Font ${indexValue}`] || ''
        };
      }
      
      var genericProperties = {
        [`Application Method ${indexValue}`]: applicationMethod,
        [`Position ${indexValue}`]: position,
        [`Logo Type ${indexValue}`]: logoType,
        [`Logo Id ${indexValue}`]: logoId,
        [`_logoVariant${indexValue}`]: logoVariant
      };
      var properties = Object.assign({}, genericProperties, logoDetails);
      // mrkDebug.log(properties)
      // CRITICAL FIX (LOGO-URL-001): Pass logo URL and ID to addHiddenField
      addHiddenField(indexValue, properties, logo_url, logoId);
    })
    
    trackRegularProductStateChange('hiddenFields_created_differentLogo', {
      before: hiddenFieldsBefore
    }, {
      after: allCheckedLogoPositions.length,
      mode: 'different_logo'
    });
  }
  
  // Track completion
  var hiddenFieldsAfter = $('.mrk-hidden-field-item').length;
  trackRegularProductInteraction('updateMeta_completed', {
    hiddenFieldsBefore: hiddenFieldsBefore,
    hiddenFieldsAfter: hiddenFieldsAfter,
    hiddenFieldsCreated: hiddenFieldsAfter, // kept for backward compatibility with existing dashboards
    checkedPositions: document.querySelectorAll(".logo-position-checked").length
  });
  
  } catch(e) {
    trackRegularProductError('updateMeta error', {
      error: e.message,
      stack: e.stack
    });
    // mrkDebug.error('[Regular Product] Error in updateMeta:', e);
    throw e; // Re-throw to prevent silent failures
  }

  // var index = $('.mrk-hidden-fields .mrk-hidden-field-item').length + 1;
  // var logoDetails = getLogoDetails(index),
  //     applicationMethod = $('[name="application-type"]:checked').val(),
  //     logoVariant = $('[name="logo-type"]:checked').attr('variant'),
  //     position = $('.mrk-position-item input:checked').val(),
  //     logoType = $('[name="logo-type"]:checked').val(),
  //     logoId = Math.floor(Math.random() * (999998 + 1)),
  //     logo_url = logoDetails[`Logo ${index}`];
  // mrkDebug.log(logoDetails)
  // if (logoType == 'Existing Logo' && window.logoId && logo_url == window.logoUrl) {
  //     logoId = window.logoId;
  // } else {
  //     window.logoId = logoId;
  //     window.logoUrl = logo_url;
  // }

  // var genericProperties = {
  //     [`Application Method ${index}`]: applicationMethod,
  //     [`Position ${index}`]: position,
  //     [`Logo Type ${index}`]: logoType,
  //     [`Logo Id ${index}`]: logoId,
  //     [`_logoVariant${index}`]: logoVariant
  // };
  // var properties = Object.assign({}, genericProperties, logoDetails);
  // addHiddenField(index, properties);
  // Disable current checked positions
  // not needed now since all logos can be selected at once, this is to show already selected message on logos so user can not select same position again
  // $('.mrk-position-item input:checked').each(function() {
  //     $(this).prop('disabled', true).parents('.mrk-position-item').addClass('mrk-checked-position');
  // });
}


// this is not needed as it was being used to handle the addition of another logo
function handleLogo() {
    $('.mrk-add-another-logo').on('click', function() {
        updateMeta();
        $('.mrk-close-btn').click();
        initExistingLogos();
        // Reset position selections
        $('[name="mrk-main-logo-position"]').prop('checked', false);

        // Reset logo type and details
        $('[name="logo-type"]').prop('checked', false);
        $('[name="properties[Uploaded Logo]"]').val('');
        $('#customerNotesFilesUploadedLogo').val('');
        $('[name="properties[Existing Logo]"]').val('');
        $('#customerNotesFilesExisting').val('');
        $('[name="properties[Text Line]"]').val('');
        $('#logoColor').val('');
        $('#font-family').val('');
        $('#notesLogoText').val('');
        // $('#previewDiv').text('JRS');
        $('#logoText').val('JRS');
        $('#previewDivLine1').html('JRS');
        $('#previewDivLine2').html('');
        $('#previewDivLine3').html('');
        $('#previewDivLine4').html('');
        window.mrknavigateTo(0);
    });
}

function initPopup() {
  window.__noopLog('✅ [initPopup] Function called - attaching click handlers');
  window.__noopLog('[initPopup] Found .mrk-final-add-to-cart buttons:', $('.mrk-final-add-to-cart').length);
  
  // this is kind of not related
  $('.mrk-product-csutomizer input').change(function (e) {
    e.preventDefault();
    calculatePrice()
  });
  // this is kind of not related
  $('[name="application-type"]').change(function (e) {
    e.preventDefault();
    UpdatePositionPrices();
  });
  let lastSelected = document.querySelectorAll('.selected-position.active');
  let lastElement = lastSelected[lastSelected.length - 1];

  function updateLastSelectedElement() {
    lastSelected = document.querySelectorAll('.selected-position.active');
    lastElement = lastSelected[lastSelected.length - 1];
  }
  routineSetup()
    function enableNextButton() {
  let positionChecked = false;
  document.querySelectorAll(".logo-position-checkbox").forEach((checkboxEl) => {
    if (checkboxEl.checked) {
      positionChecked = true;
    }
  })
  if (positionChecked) {
    document.querySelector(".mrk-steps-footer-buttons-container").querySelector("button.next").classList.remove("disabled");
  }
  else if (!positionChecked) {
    document.querySelector(".mrk-steps-footer-buttons-container").querySelector("button.next").classList.add("disabled");
  }
}
let allLogoPositionItems = document.querySelectorAll(".logo-position-checkbox");
allLogoPositionItems.forEach((el) => {
  el.addEventListener("input", () => {
    try {
      let positionName = el.getAttribute("data-position-name") || 'Unknown';
      let wasChecked = el.checked;
      
      // Track position selection
      trackRegularProductInteraction('position_' + (wasChecked ? 'selected' : 'deselected'), {
        position: positionName,
        checked: wasChecked,
        totalCheckedPositions: document.querySelectorAll('.logo-position-checkbox:checked').length
      });
      
      var selectedPositionEl = document.querySelector(`.selected-position[data-position-name="${positionName}"]`);
      if (selectedPositionEl) {
        if (!wasChecked) {
          selectedPositionEl.classList.remove("active");
        } else {
          selectedPositionEl.classList.add("active");
    }
      }
      
      if (el.parentElement) {
        el.parentElement.classList.toggle("logo-position-checked", wasChecked);
      }
      
      enableNextButton();
      updateLastSelectedElement();
    } catch(e) {
      trackRegularProductError('Position selection error', {
        error: e.message,
        position: el.getAttribute("data-position-name")
      });
      // mrkDebug.error('[Regular Product] Error handling position selection:', e);
    }
  })
})
    let applicationMethodInputs = document.querySelectorAll(".application-method-container-input");
    applicationMethodInputs.forEach((el) => {
        el.addEventListener("input", () => {
            try {
                let positionName = el.getAttribute("data-position-name") || 'Unknown';
                let inputValue = el.getAttribute("value") || 'Unknown';
                let previousValue = el.getAttribute('data-previous-value') || 'Unknown';
                
                // Track application method change
                trackRegularProductInteraction('application_method_changed', {
                    position: positionName,
                    method: inputValue,
                    previousMethod: previousValue
                });
                
                el.setAttribute('data-previous-value', inputValue);
                
                var selectedPositionEl = document.querySelector(`.selected-position[data-position-name="${positionName}"]`);
                if (selectedPositionEl) {
                    var selectPositionMethodLabel = selectedPositionEl.querySelector(`label[data-value="${inputValue}"]`);
                    if (selectPositionMethodLabel) {
            selectPositionMethodLabel.classList.add("active");
            if (selectPositionMethodLabel.nextElementSibling) {
                selectPositionMethodLabel.nextElementSibling.classList.remove("active");
                        } else if (selectPositionMethodLabel.previousElementSibling) {
                selectPositionMethodLabel.previousElementSibling.classList.remove("active");
                        }
                    }
                }
            } catch(e) {
                trackRegularProductError('Application method change error', {
                    error: e.message,
                    position: el.getAttribute("data-position-name")
                });
                // mrkDebug.error('[Regular Product] Error handling application method change:', e);
            }            
        })
    })
    let assignmentStyleInputs = document.querySelectorAll('input[name="same-logo"]');
  assignmentStyleInputs.forEach((input) => {
      input.addEventListener("input", () => {
          document.querySelectorAll('.logo-assignment-label').forEach(label => {
              label.classList.remove('selected');
          });
          input.closest('label').classList.add('selected');
          if (input.value == "yes"){
              document.querySelector(".assignment-style-1").classList.remove("hidden")
              document.querySelector(".assignment-style-2").classList.add("hidden")

              //Ak custom code
              document.querySelector("button.next-inner.mrk-final-add-to-cart").setAttribute("style", "display: none;")
              document.querySelector("button.next-inner.mrk-final-add-to-cart").classList.add("disabled");
              //End Ak custom code
          }
          else if (input.value == "no"){
              document.querySelector(".assignment-style-1").classList.add("hidden")
              document.querySelector(".assignment-style-2").classList.remove("hidden")

              //Ak custom code
              let remainingNumber;
              let allActivePositions = document.querySelectorAll(".selected-position.active").length;
              let allActiveDonePositions = document.querySelectorAll(".selected-position.active.done").length;
              remainingNumber = Number(allActivePositions - allActiveDonePositions);
              // remainingNumber = checkRemainingActivePositions();
              if (remainingNumber < 2) {
                // document.querySelector("button.next-inner.mrk-final-add-to-cart").setAttribute("style", "display: block !important;");
              }
              else if (remainingNumber > 1) {
                document.querySelector("button.next-inner.mrk-final-add-to-cart").setAttribute("style", "display: none;");
              }

              // mrkDebug.log('remainingNumber',remainingNumber);
              if(remainingNumber < 1){
                // button.next-inner
                document.querySelector("button.next-inner.mrk-final-add-to-cart").setAttribute("style", "display: block;")
                document.querySelector("button.next-inner.mrk-final-add-to-cart").classList.remove("disabled");
              }
              //Ak custom code
          }

      });
  });
  stepOneScript()
  popupContentScript()
  // related, then final atc is clicked
  // CRITICAL FIX: Unbind existing handlers before attaching new one
  // This prevents multiple handlers from being attached when initPopup() is called multiple times
  $('.mrk-final-add-to-cart').off('click.finishButton');
  
  // DEBUG: Check button state before attaching handler
  var $button = $('.mrk-final-add-to-cart');
  window.__noopLog('[initPopup] Button state before handler attachment:', {
    exists: $button.length,
    hasDisabledClass: $button.hasClass('disabled'),
    propDisabled: $button.prop('disabled'),
    isVisible: $button.is(':visible'),
    display: $button.css('display')
  });
  
  // CRITICAL DEBUG: Add backup plain JavaScript click handler to diagnose jQuery issues
  document.querySelectorAll('.mrk-final-add-to-cart').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      window.__noopLog('🔥 [Plain JS] Button clicked! (backup handler)', {
        classList: Array.from(btn.classList),
        disabled: btn.disabled,
        style: btn.getAttribute('style')
      });
    });
  });
  
  $('.mrk-final-add-to-cart').on('click.finishButton', function (e) {
    window.__noopLog("✅ [jQuery Handler] Click handler triggered!");
    
    // CRITICAL FIX: Check if button is disabled FIRST (before flag check)
    // This prevents handler execution if button was disabled by "No Buy Plain" click
    var $finishButton = $(this);
    var isButtonDisabled = $finishButton.hasClass('disabled') || 
                          $finishButton.prop('disabled') === true ||
                          !$finishButton.is(':visible');
    
    window.__noopLog('[Finish Button] Disabled check:', {
      hasDisabledClass: $finishButton.hasClass('disabled'),
      propDisabled: $finishButton.prop('disabled'),
      isVisible: $finishButton.is(':visible'),
      isButtonDisabled: isButtonDisabled
    });
    
    if (isButtonDisabled) {
      window.__noopLog('[Finish Button] 🚫 BUTTON DISABLED - Skipping handler', {
        hasDisabledClass: $finishButton.hasClass('disabled'),
        propDisabled: $finishButton.prop('disabled'),
        isVisible: $finishButton.is(':visible'),
        note: 'Button is disabled - should not process'
      });
      
      // Prevent default and stop propagation
      e.preventDefault();
      e.stopPropagation();
      
      // Return immediately
      return false;
    }
    
    // CRITICAL FIX: Check flag SECOND - after disabled check
    // This ensures that even if button is somehow clicked, handler won't run if flag is set
    var userWantsNoCustomization = window.userWantsNoCustomization === true;
    var timeSinceNoCustomizationClick = window.userWantsNoCustomizationTimestamp 
      ? (Date.now() - window.userWantsNoCustomizationTimestamp) 
      : Infinity;
    
    window.__noopLog('[Finish Button] Flag check:', {
      userWantsNoCustomization: userWantsNoCustomization,
      timeSinceClick: timeSinceNoCustomizationClick
    });
    
    if (userWantsNoCustomization && timeSinceNoCustomizationClick < 5000) {
      window.__noopLog('[Finish Button] 🚫 FLAG DETECTED - Skipping', {
        timestamp: window.userWantsNoCustomizationTimestamp,
        timeSinceClick: timeSinceNoCustomizationClick
      });
      
      // Prevent default and stop propagation
      e.preventDefault();
      e.stopPropagation();
      
      // Return immediately - don't process anything
      return false;
    }
    
    window.__noopLog('[Finish Button] ✅ Preventing default and continuing...');
    e.preventDefault();
    
    // CRITICAL FIX (Order #52475): Prevent double-click on Finish button
    if ($finishButton.data('isProcessing')) {
      window.__noopLog('[Finish Button] Already processing, ignoring click');
      return;
    }
    
    window.__noopLog('[Finish Button] ✅ Starting add to cart process...');
    
    // Mark as processing
    $finishButton.data('isProcessing', true);
    $finishButton.prop('disabled', true);
    var originalText = $finishButton.text() || $finishButton.html();
    $finishButton.text('Adding to cart...').html('Adding to cart...');
    
    window.__noopLog('[Finish Button] Button marked as processing');
    
    // Track Finish button click with comprehensive state
    var finishButtonTime = new Date().toISOString();
    trackRegularProductInteraction('finish_button_clicked', {
      timestamp: finishButtonTime,
      checkedPositions: $('.logo-position-checkbox:checked').length,
      hiddenFieldsBefore: $('.mrk-hidden-field-item').length,
      timeOnPage: Date.now() - new Date(window.regularProductUserJourney.startTime).getTime()
    });
    
    try {
    window.__noopLog('[Finish Button] Starting validation...');
    
    // updateMeta() is important
    var hiddenFieldsBeforeUpdate = $('.mrk-hidden-field-item').length;
    window.__noopLog('[Finish Button] Calling updateMeta()...');
    updateMeta();
    window.__noopLog('[Finish Button] updateMeta() completed');
      
    const positionsCount = $('.mrk-checked-position').length + $('.logo-position-checkbox:checked').length;
      const hiddenFieldsAfter = $('.mrk-hidden-field-item').length;
      
      window.__noopLog('[Finish Button] Position count:', positionsCount);
      
      trackRegularProductStateChange('hiddenFields_created', {
        before: hiddenFieldsBeforeUpdate
      }, {
        after: hiddenFieldsAfter,
        checkedPositions: positionsCount
      });
      
    if (positionsCount == 0) {
        window.__noopLog('[Finish Button] ❌ No positions selected, navigating to step 2');
        trackRegularProductError('No positions selected', {
          positionsCount: positionsCount
        });
      // window.mrknavigateTo(1);
      window.mrknavigateTo(2);
      return;
    }
      
    const logoType = $('[type="radio"]:checked');
    window.__noopLog('[Finish Button] Logo type checked:', logoType.length);
    
    if (logoType.length == 0) {
        window.__noopLog('[Finish Button] ❌ No logo type selected, navigating to step 3');
        trackRegularProductError('No logo type selected', {
          positionsCount: positionsCount
        });
      // window.mrknavigateTo(2);
      window.mrknavigateTo(3);
      return;
    }
      
    window.__noopLog('[Finish Button] ✅ Validation passed, calling addBulkItems()...');
    addBulkItems();
    } catch(e) {
      console.error('[Finish Button] ❌ ERROR:', e.message, e);
      trackRegularProductError('Finish button click error', {
        error: e.message,
        stack: e.stack
      });
      // mrkDebug.error('[Regular Product] Error in finish button handler:', e);
      
      // CRITICAL FIX (Order #52475): Re-enable button on error
      $finishButton.data('isProcessing', false);
      $finishButton.prop('disabled', false);
      $finishButton.text(originalText).html(originalText);
    } finally {
      // CRITICAL FIX (Order #52475): Re-enable button after a delay to allow addBulkItems to complete
      // Note: addBulkItems may redirect, so this may not execute, but it's safe to have
      setTimeout(function() {
        if ($finishButton && $finishButton.data('isProcessing')) {
          $finishButton.data('isProcessing', false);
          $finishButton.prop('disabled', false);
          $finishButton.text(originalText).html(originalText);
        }
      }, 5000); // 5 second timeout - should be enough for cart add
    }
  });
  multiStepForm($(".mrk-multistep"), {
    defaultStep: 0
  });

  var _customizerPopupScrollTop = 0;
  function _lockBodyScrollForCustomizerPopup() {
    if (typeof window.matchMedia !== 'undefined' && !window.matchMedia('(max-width: 768px)').matches) return;
    _customizerPopupScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + _customizerPopupScrollTop + 'px';
    document.body.style.width = '100%';
  }
  function _unlockBodyScrollForCustomizerPopup() {
    if (typeof window.matchMedia !== 'undefined' && !window.matchMedia('(max-width: 768px)').matches) return;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, _customizerPopupScrollTop);
  }
  window._mrkCustomizerPopupLockBody = _lockBodyScrollForCustomizerPopup;
  window._mrkCustomizerPopupUnlockBody = _unlockBodyScrollForCustomizerPopup;

  $('.popup__close.customizer-popup').click(function (e) {
    e.preventDefault();
    _unlockBodyScrollForCustomizerPopup();
    // Track popup close
    trackRegularProductInteraction('popup_closed', {
      timestamp: new Date().toISOString(),
      timeInPopup: Date.now() - new Date(window.regularProductUserJourney.startTime).getTime(),
      fromCart: $(this).parents('.mrk-customizer-cart').length > 0
    });
    
    if ($(this).parents('.mrk-customizer-cart').length)
      $('.mrk-customizer-cart').hide()
    else
      $('.mrk-customizer-popup-form .popup-overlay').removeClass('show')
  });
  $('.mrk-open-popup,.custom-product-form-next-new.combine_add_logo_btn').click(function (e) {
    e.preventDefault();
    
    // FIXED (WARN-4): Prevent double popup open on mobile (touchstart + click both firing)
    // ENHANCED (LOGO-URL-002): Increased debounce from 2s to 5s for mobile Safari
    var now = Date.now();
    if (!window.lastPopupOpenTimestamp) {
      window.lastPopupOpenTimestamp = 0;
    }
    var timeSinceLastOpen = now - window.lastPopupOpenTimestamp;
    
    // CRITICAL FIX (LOGO-URL-002): Increase debounce from 2s to 5s for mobile Safari
    if (timeSinceLastOpen < 5000) {
      // Popup opened within last 5 seconds, skip to prevent double open
      mrkDebug.log('[Regular Product] 🚫 Popup open blocked (debounce):', {
        timeSinceLastOpen: timeSinceLastOpen,
        lastOpenTimestamp: window.lastPopupOpenTimestamp,
        currentTimestamp: now,
        trigger: $(this).hasClass('combine_add_logo_btn') ? 'combine_button' : 'open_popup'
      });
      return;
    }
    
    // Update timestamp
    window.lastPopupOpenTimestamp = now;
    
    // CRITICAL FIX: When user clicks "Yes, customize" (opens popup), clear the "no customization" flag
    if (window.userWantsNoCustomization) {
      mrkDebug.log('[Regular Product] ✅ USER CLICKED "YES, CUSTOMIZE" - Clearing no customization flag');
      window.userWantsNoCustomization = false;
      delete window.userWantsNoCustomizationTimestamp;
    }
    
    try {
    var sizes = $('.mrk-qty-item');
    var count = 0;
    sizes.each(function () {
          var qty = parseInt($(this).val()) || 0;
          if (qty > 0)
        count++
    });
        
        // Track popup open attempt
        trackRegularProductInteraction('popup_open_attempt', {
          sizesWithQty: count,
          totalSizes: sizes.length,
          trigger: $(this).hasClass('combine_add_logo_btn') ? 'combine_button' : 'open_popup'
        });
        
    if (count) {
          // Track popup opened
          trackRegularProductInteraction('popup_opened', {
            timestamp: new Date().toISOString(),
            sizesWithQty: count,
            checkedPositions: $('.logo-position-checkbox:checked').length
          });
          
      if($(this).hasClass('combine_add_logo_btn')){
        window.mrknavigateTo(0);
        $('.mrk-steps-footer').addClass('hidden');
      }
      calculatePrice();
      $('.mrk-customizer-popup-form .popup-overlay').addClass('show');
      _lockBodyScrollForCustomizerPopup();
      const color = $('[name="options[Color]"]:checked').val() || $('[name="options[Colour]"]:checked').val();
      const image = $('.productGallery .swiper-slide-active img').attr('src');
      updateContentInfo(image, color);
    }
    } catch(e) {
      trackRegularProductError('Popup open error', {
        error: e.message,
        stack: e.stack
      });
      // mrkDebug.error('[Regular Product] Error opening popup:', e);
    }
  });

  // On change of text input
  $('#logoText').on('input', function () {
    // $('#previewDiv').html($(this).val());
    $('#previewDivLine1').html($(this).val());
    if ($(this).val() != '') {
      $('.mrk-steps-footer').removeClass('mrk-disable-btn');
    } else {
      $('.mrk-steps-footer').addClass('mrk-disable-btn');
    }

  });
  $('#logoText2').on('input', function () {
    $('#previewDivLine2').html($(this).val());
  });
  $('#logoText3').on('input', function () {
    $('#previewDivLine3').html($(this).val());
  });
  $('#logoText4').on('input', function () {
    $('#previewDivLine4').html($(this).val());
  });

  // On change of font dropdown
  $('#font-family').change(function () {
    const fontFamily = $(this).val();
    $('#previewDiv').css('font-style', fontFamily);
  });

  // On change of color dropdown
  $('#logoColor').change(function () {
    const color = $(this).val();
    const bg = $('#logoColor option:selected').attr('bg') || 'black';
    $('#previewDiv').css('color', color).css('background', bg);
  });
  $('.mrk-close-btn').click(function () {
    $('.input-file-logo').val('');
    $('[data-mrk-thumbnail]').attr('src', '');
    $('.preview-template').hide();
    $('.hiddenFileInput').val('').change();
  });
  // uploader
  // When a file is chosen using the file input, upload it
  $('.hiddenFileInput').change(function () {
    var container = $(this).parents('.mrk-step-upload-logo');
    var file = this.files[0];
    if (file) {
      preparePreview(file, container);
      uploadFile(file, container);
    }
  });


  // Handle input change 
  function handleInputChange(input) {
    const container = $(input).parents('.mrk-step-existing-logo'); // Find the parent tab container
    const file = $(input).val(); // Get the value (URL)

    // Display the file name and show the preview
    $(container).find('.input-file-logo').val(file);
    // mrkDebug.log($(container).find('.input-file-logo'), file, $(container));
    $(container).find('.mrk-filename span[data-mrk-name]').text(file.replace('https://jrsindustrial-files.com/uploads/', ''));
    $(container).find('.preview-template').show();
    $(container).find('.mrk-image img').attr('src', file);
    $(container).find('.mrk-progress').hide(); // Hide the progress bar on success
    $('.mrk-steps-footer').removeClass('loading');
    $('.mrk-steps-footer').removeClass('mrk-disable-btn');
  }

  // Enable ADD TO CART button(s) when existing logo is selected (multistep PDP: enable all so visible one is enabled)
  function enableAddToCartButtonsForExistingLogo() {
    if (!$('.mrk-existing-logo-item:checked').length) return;
    document.querySelectorAll('button.mrk-next-custom.mrk-final-add-to-cart').forEach(function (btn) {
      btn.classList.remove('disabled');
      btn.removeAttribute('disabled');
      $(btn).prop('disabled', false);
    });
  }

  // Attach change event listener to dynamically created inputs
  $(document).on('change', '.mrk-existing-logo-item', function () {
    handleInputChange($('.mrk-existing-logo-item:checked'));
    enableAddToCartButtonsForExistingLogo();
  });
  initExistingLogos();
  handleLogo()
    let allOriginalExistingLogoSelectors = document.querySelectorAll(".mrkexisting-logo-select-original");
  // mrkDebug.log(allOriginalExistingLogoSelectors)
  allOriginalExistingLogoSelectors.forEach((el) => {
    el.querySelectorAll("input").forEach((inputEl) => {
      inputEl.addEventListener("input", () => {
        enableAddToCartButtonsForExistingLogo();
      })
    })
  })
  // If an existing logo is already selected after init (e.g. restored state), enable ADD TO CART
  setTimeout(function () {
    enableAddToCartButtonsForExistingLogo();
  }, 100);
  // After popup open (multistep: existing logo step may be visible with selection already made)
  setTimeout(function () {
    enableAddToCartButtonsForExistingLogo();
  }, 500);

  window.__noopLog('✅ [initPopup] Function completed - all handlers attached');
}

function initNotification(resp) {
  if (!resp || !resp.items || !resp.items.length) {
    $('[data-submit-button] [data-submit-button-text]').removeClass('loading');
    $('.loading-overlay__spinner').addClass('hidden');
    $('body').addClass('js-cart-open');
    return;
  }
  const items = resp.items;
  // 1. Get the image of the first item (plain add may have different response shape)
  var image = (items[0] && items[0].image) || (items[0] && items[0].featured_image && items[0].featured_image.url) || '';
  // 2. Get the value of the color option from form, or from first added item (e.g. multistep PDP has no options[Color] in form)
  var selectedColor = $('[name="options[Color]"]:checked').val() || $('[name="options[Colour]"]:checked').val();
  if (!selectedColor && items[0] && items[0].options_with_values && Array.isArray(items[0].options_with_values)) {
    var colorOpt = items[0].options_with_values.find(function (option) { return option.name === 'Color' || option.name === 'Colour'; });
    selectedColor = colorOpt ? colorOpt.value : '';
  }
  // 3. Loop through all items to get all sizes and push into array (guard missing options_with_values)
  var sizes = [];
  items.forEach(function (item) {
    var opts = item.options_with_values;
    if (!opts || !Array.isArray(opts)) return;
    var colorOpt = opts.find(function (option) { return option.name === 'Color' || option.name === 'Colour'; });
    var color = colorOpt ? colorOpt.value : '';
    if (color === selectedColor || !selectedColor) {
      var sizeOpt = opts.find(function (option) { return option.name === 'Size'; });
      var size = sizeOpt ? sizeOpt.value : '';
      if (size && sizes.indexOf(size) === -1) {
        sizes.push(size);
      }
    }
  });

  // 4. Display color and sizes in popup
  var sizesStr = sizes.join(', ');
  if ($('.popup-color-name').length) $('.popup-color-name').html(selectedColor || '');
  if ($('.popup-size-name').length) $('.popup-size-name').html(sizesStr);
  var $img = $('cart-notification-mrk .cart-notification-product__image img');
  if ($img.length && image) $img.attr('src', image);
  $('body').addClass('js-cart-open');
  $('[data-submit-button] [data-submit-button-text]').removeClass('loading');
  $('.loading-overlay__spinner').addClass('hidden');
  $('cart-notification-mrk [type="close"]').click(function (e) {
    e.preventDefault();
    $('body').removeClass('js-cart-open');
  });
}

function initExistingLogos() {
  // Parse the stored logos from localStorage
  const logos = JSON.parse(localStorage.getItem('logos')) || [];

  // Generate the HTML and append it to a container
  // const $container = $('.mrkexisting-logo-select-original'); // Replace with your actual container selector
  if (logos.length) {
    $('.mrk-existing-logo-wrapper').show();
    $('.mrk-existing-logo-selector').show()
  }

  document.querySelectorAll(".mrkexisting-logo-select").forEach((el, idxPosition) => {
    if (logos.length) {
      el.innerHTML = "";
    }

    logos.forEach((logo, index) => {
      let logoItem = document.createElement("div");
      logoItem.classList.add("logo-item")
      logoItem.innerHTML = `
      <input type="radio" name="mrk-existing-logo" value="${logo}" class="mrk-existing-logo-item" id="mrk-existing-logo-${index}-${idxPosition}" />
      <label for="mrk-existing-logo-${index}-${idxPosition}">
        <img src="${logo}" class="mrk-exiting-logo-image" />
      </label>
  `;
      el.append(logoItem);
    });
  })

}

// Plain add-to-cart (no customization). Reads .mrk-qty-item and data-variant-id from the form
// (populated by pdp-multistep-form-v2 _syncHiddenInputs when v2 is used). Do not change selector.
function initSingleAdd() {
  $('product-form-mrk form').submit(function (e) {
    e.preventDefault();
    
    // CRITICAL FIX: Check if user clicked "No, buy plain" - if so, ensure no customization logic runs
    var userWantsNoCustomization = window.userWantsNoCustomization === true;
    var timeSinceNoCustomizationClick = window.userWantsNoCustomizationTimestamp 
      ? (Date.now() - window.userWantsNoCustomizationTimestamp) 
      : Infinity;
    
    mrkDebug.log('[initSingleAdd] 🔍 FLAG CHECK:', {
      flagExists: typeof window.userWantsNoCustomization !== 'undefined',
      flagValue: window.userWantsNoCustomization,
      timestampExists: typeof window.userWantsNoCustomizationTimestamp !== 'undefined',
      timestamp: window.userWantsNoCustomizationTimestamp,
      currentTime: Date.now(),
      timeSinceClick: timeSinceNoCustomizationClick,
      willRespectFlag: userWantsNoCustomization && timeSinceNoCustomizationClick < 5000
    });
    
    // If flag is set and recent, clear it after processing to prevent stale state
    var shouldClearFlag = userWantsNoCustomization && timeSinceNoCustomizationClick < 5000;
    
    var sizes = $(this).find('.mrk-qty-item');
    var sizesGlobal = $('.mrk-qty-item');
    console.log('[initSingleAdd] .mrk-qty-item counts', { inForm: sizes.length, global: sizesGlobal.length, formId: this.id || '(no id)' });
    var ids = [];
    sizes.each(function () {
      var qty = Number($(this).val());
      var variantId = Number($(this).data('variant-id'));
      console.log('[initSingleAdd] Size input', { variantId: variantId, qty: qty, name: this.name });
      if (qty > 0) {
        // mrkDebug.log($(this))
        const variantObj = buildItem(variantId, qty, '', '', '');
        ids.push(variantObj);
      }
    });
    console.log('[initSingleAdd] Payload variant IDs', ids.map(function(i) { return i.id; }));
    var data = {
      items: ids
    };
    if (ids.length > 0) {
      var payloadLog = ids.map(function(i) {
        return { id: i.id, quantity: i.quantity, propertyKeys: i.properties ? Object.keys(i.properties) : [] };
      });
      mrkDebug.log('[initSingleAdd] 📤 Plain add payload (separate line):', { itemCount: ids.length, items: payloadLog });
    }
    if (ids.length == 0) {
      // Clear flag if it was set, even if no items to add
      if (shouldClearFlag) {
        window.userWantsNoCustomization = false;
        delete window.userWantsNoCustomizationTimestamp;
        mrkDebug.log('[initSingleAdd] 🧹 CLEARED flag (no items to add)');
      }
      return;
    }

    $(this).find('[data-submit-button] [data-submit-button-text]').addClass('loading');
    $(this).find('.loading-overlay__spinner').removeClass('hidden');
    addItemToCart(data, 'notification');

    // Clear flag only after addItemToCart has been invoked so any other sync/microtask code on this submit still sees "plain"
    if (shouldClearFlag) {
      window.userWantsNoCustomization = false;
      delete window.userWantsNoCustomizationTimestamp;
      mrkDebug.log('[initSingleAdd] 🧹 CLEARED flag after processing');
    }
  });
}

// CRITICAL FIX: Clear all checkboxes on page load to prevent stale state from previous products
// This ensures that when navigating between products, checkboxes from previous products don't affect new products
$(document).ready(function() {
  // CRITICAL FIX (Order #67156086817141): Track page load timestamp for phantom add detection
  window.pageLoadTimestamp = Date.now();
  mrkDebug.log('[Regular Product] 📍 Page load timestamp set:', window.pageLoadTimestamp);
  
  $('.logo-position-checkbox:checked').prop('checked', false);
  $('.selected-position').removeClass('active');
  mrkDebug.log('[Regular Product] 🧹 Cleared all checkboxes on page load to prevent stale state');
});

// CRITICAL FIX (TEXT-LOGO-001): Track text logo input events
$(document).on('input', '.logoText-position-1, .logoText-position-2, .logoText-position-3, .logoText-position-4, .logoText-original-1, .logoText-original-2, .logoText-original-3, .logoText-original-4', function() {
  var $input = $(this);
  var value = $input.val();
  
  // Debounce to avoid excessive logging
  clearTimeout(window.textLogoInputTimeout);
  window.textLogoInputTimeout = setTimeout(function() {
    trackRegularProductInteraction('text_logo_entered', {
      textLength: value ? value.length : 0,
      textPreview: value ? value.substring(0, 30) + '...' : 'empty',
      inputClass: $input.attr('class'),
      timestamp: new Date().toISOString()
    });
  }, 1000);
});

// CRITICAL FIX (Order #67156086817141): Prevent phantom re-submission on Safari bfcache restoration
window.addEventListener('pageshow', function(event) {
  if (event.persisted) {
    // Page was loaded from bfcache (back/forward cache)
    mrkDebug.log('[Regular Product] 🔄 Page restored from bfcache - clearing stale state');
    
    // Clear all customization state
    $('.logo-position-checkbox:checked').prop('checked', false);
    $('.selected-position').removeClass('active');
    $('.mrk-hidden-field-item').remove();
    
    // Clear in-memory state
    if (window.capturedPositionsForAddToCart) {
      window.capturedPositionsForAddToCart = [];
    }
    window._preservedPositionData = null;
    window._currentSessionLogoData = null;
    
    // Prevent any form submission
    window.bfcacheRestored = true;
    window.bfcacheRestoredTimestamp = Date.now();
    
    mrkDebug.log('[Regular Product] ✅ bfcache state cleared, flag set to prevent phantom submissions');
  }
});

// CRITICAL FIX: Wrap initialization in DOM ready to ensure elements exist before attaching handlers
$(document).ready(function() {
  window.__noopLog('✅ [betterconversions-customizer.js] Document ready fired');
  window.__noopLog('[Init Check] .mrk-customizer-cart elements:', $('.mrk-customizer-cart').length);
  window.__noopLog('[Init Check] .mrk-qty-item elements:', $('.mrk-qty-item').length);
  
  // if there is no mrk-customizer-cart then popup is called - kind of related
  if (!$('.mrk-customizer-cart').length) {
    window.__noopLog('[Init] Calling initPopup() - no mrk-customizer-cart found');
    initPopup();
  } else {
    window.__noopLog('[Init] Skipping initPopup() - mrk-customizer-cart exists');
  }

  // Bind plain add-to-cart when: (1) legacy .mrk-qty-item exist at load, or (2) multistep/bulk
  // form is present (pdp-v2 or bulk-element) so .mrk-qty-item will be added by _syncHiddenInputs
  var hasQtyInputs = $('.mrk-qty-item').length > 0;
  var hasBulkForm = $('product-form-mrk form.bulk-element').length > 0;
  var hasPdpV2Mount = !!(document.getElementById('pdp-v2-mount') || document.querySelector('[data-pdp-v2-mount]'));
  if (hasQtyInputs || hasBulkForm || hasPdpV2Mount) {
    window.__noopLog('[Init] Calling initSingleAdd()', { hasQtyInputs: hasQtyInputs, hasBulkForm: hasBulkForm, hasPdpV2Mount: hasPdpV2Mount });
    initSingleAdd();
  }
});

function routineSetup() {
  document.querySelectorAll('input[name="mrk-existing-logo"]').forEach((el) => {
    el.addEventListener("input", () => {
      document.querySelector(".mrk-steps-footer").querySelector(".mrk-next-btn").firstElementChild.classList.remove("disabled");
    })
  })

  document.querySelectorAll('input[name="properties[Text Line]"]').forEach((el) => {
    el.addEventListener("input", () => {
      document.querySelector(".mrk-steps-footer").querySelector(".mrk-next-btn").firstElementChild.classList.remove("disabled");
    })
  })

  document.querySelectorAll('input[name="properties[Text Line 2]"]').forEach((el) => {
    el.addEventListener("input", () => {
      document.querySelector(".mrk-steps-footer").querySelector(".mrk-next-btn").firstElementChild.classList.remove("disabled");
    })
  })

  document.querySelectorAll('input[name="properties[Text Line 3]"]').forEach((el) => {
    el.addEventListener("input", () => {
      document.querySelector(".mrk-steps-footer").querySelector(".mrk-next-btn").firstElementChild.classList.remove("disabled");
    })
  })

  document.querySelectorAll('input[name="properties[Text Line 4]"]').forEach((el) => {
    el.addEventListener("input", () => {
      document.querySelector(".mrk-steps-footer").querySelector(".mrk-next-btn").firstElementChild.classList.remove("disabled");
    })
  })

  let allLogoSelectionIcons = document.querySelectorAll(".selected-position-logo-style-icon-position");
  allLogoSelectionIcons.forEach((el) => {
    el.addEventListener("click", () => {
      let logoTypeValue = el.firstElementChild.value;
      let positionName = el.parentElement.parentElement.getAttribute("data-position-name");
      document.querySelector(`.logo-position-checked[data-logo-position="${positionName}"]`).setAttribute("data-logo-type", logoTypeValue)
    })
  })
}

function stepOneScript(){

}

function popupContentScript(){
  let allExistingLogoSelectorEls = document.querySelectorAll(".mrk-existing-logo-selector-position");
let allTextSelectorEls = document.querySelectorAll(".mrk-text-logo-selector-position");
let allUploadLogoSelectorEls = document.querySelectorAll(".mrk-upload-your-logo-selector-position");

let originalExistingLogoButton = document.querySelector(".mrk-existing-logo-selector-original");
let originalTextLogoButton = document.querySelector(".mrk-text-logo-selector-original");
let originalUploadLogoButton = document.querySelector(".mrk-upload-your-logo-selector-original");

// let existingLogoContainerBackButtons = document.querySelectorAll(".custom-tabs-back-btn");

let footerNextButton = document.querySelector(".mrk-steps-footer-next-buttons-container").querySelector("button.next");
let multiStepContainer = document.querySelector(".mrk-multistep");
let backToFirst = document.querySelector(".back-to-first");
let backToSecond = document.querySelector(".back-to-second");
let backToFirstInner = document.querySelector(".back-to-first-inner");
let backFromFinalInner = document.querySelector(".back-from-final-inner");
let continueToNextPositionBtns = document.querySelectorAll("button.next-inner");

allExistingLogoSelectorEls.forEach((el) => {
  el.addEventListener("click", () => {
    let stepClassName = el.firstElementChild.getAttribute("data-target");
    hideAllNonRelatedElements();
    document.querySelector(`.${stepClassName}`).classList.remove("hidden")
  })
})

allTextSelectorEls.forEach((el) => {
  el.addEventListener("click", () => {
    let stepClassName = el.firstElementChild.getAttribute("data-target");
    hideAllNonRelatedElements();
    document.querySelector(`.${stepClassName}`).classList.remove("hidden")
  })
})

allUploadLogoSelectorEls.forEach((el) => {
  el.addEventListener("click", () => {
    let stepClassName = el.firstElementChild.getAttribute("data-target");
    hideAllNonRelatedElements();
    document.querySelector(`.${stepClassName}`).classList.remove("hidden")
  })
})

originalExistingLogoButton.addEventListener("click", () => {
  document.querySelector(".mrk-step-2").classList.remove("current");
  document.querySelector(".mrk-step-existing-logo-original").classList.add("current");
  setTheFooterButtons()
})

originalTextLogoButton.addEventListener("click", () => {
  document.querySelector(".mrk-step-2").classList.remove("current");
  document.querySelector(".mrk-step-text-logo-original").classList.add("current");
  setTheFooterButtons()
})

originalUploadLogoButton.addEventListener("click", () => {
  document.querySelector(".mrk-step-2").classList.remove("current");
  document.querySelector(".mrk-step-upload-logo-original").classList.add("current");
  setTheFooterButtons()
})

function setTheFooterButtons() {
  document.querySelector(".mrk-steps-footer").querySelector(".mrk-next-btn").lastElementChild.classList.add("hidden");
  document.querySelector(".mrk-steps-footer").querySelector(".mrk-next-btn").firstElementChild.classList.add("disabled");
  document.querySelector(".mrk-steps-footer").querySelector(".mrk-next-btn").firstElementChild.removeAttribute("style");
}

// existingLogoContainerBackButtons.forEach((el) => {
//   el.addEventListener("click", () => {
//     window.mrknavigateTo(1);
//     $('.mrk-next-btn .next').show();
//     $('.mrk-prev-btn .previous').show();
//     $('.mrk-prev-custom').hide();
//     $('.mrk-next-custom').hide();
//     showAllNonRelatedElements()
//   })
// })

function hideAllNonRelatedElements() {
  let activeStep = document.querySelector(".tab.mrk-step-2.mrk-print-active");
  activeStep.classList.remove("current");
  // let stepsFooter = document.querySelector(".mrk-steps-footer");
  // stepsFooter.classList.add("hidden");
}

function showAllNonRelatedElements() {
  let activeStep = document.querySelector(".tab.mrk-step-2.mrk-print-active");
  activeStep.classList.add("current");
  let stepsFooter = document.querySelector(".mrk-steps-footer");
  stepsFooter.classList.remove("hidden");
  document.querySelectorAll(".mrk-step-custom-logo-tabs").forEach((el) => {
    el.classList.add("hidden");
  })
}

footerNextButton.addEventListener("click", increaseOneStep)

backToFirst.addEventListener("click", () => {
  var fromStep = Number(multiStepContainer.getAttribute("data-step-number")) || 2;
  if (typeof trackCustomizerStep === 'function') trackCustomizerStep(fromStep, 1);
  if (typeof trackCustomizerUserAction === 'function') trackCustomizerUserAction('back_to_first', { fromStep: fromStep });
  // window.mrknavigateTo(0);
  window.mrknavigateTo(1);
  multiStepContainer.setAttribute("data-step-number", 1)
  document.querySelector(".mrk-steps-footer").querySelector(".mrk-next-btn").lastElementChild.classList.remove("hidden");

  //Ak custom code
  // const no_cart_btn = document.querySelector('.mrk-steps-footer .add_to_cart_direct');
  // if(no_cart_btn){
  //   no_cart_btn.style.display = 'block';
  // }
  //End Ak custom code
})

backToSecond.addEventListener("click", () => {
  var fromStep = Number(multiStepContainer.getAttribute("data-step-number")) || 3;
  if (typeof trackCustomizerStep === 'function') trackCustomizerStep(fromStep, 2);
  if (typeof trackCustomizerUserAction === 'function') trackCustomizerUserAction('back_to_second', { fromStep: fromStep });
  // window.mrknavigateTo(1);
  window.mrknavigateTo(2);
  multiStepContainer.setAttribute("data-step-number", 2)
  originalSelectorBtns.forEach((btn) => {
    btn.querySelector("input").checked = false;
  })
  document.querySelectorAll('input.mrk-existing-logo-item').forEach((inputEl) => {
    inputEl.checked = false;
  })
})

backToFirstInner.addEventListener("click", () => {
  var fromStep = Number(multiStepContainer.getAttribute("data-step-number")) || 2;
  if (typeof trackCustomizerStep === 'function') trackCustomizerStep(fromStep, 2);
  if (typeof trackCustomizerUserAction === 'function') trackCustomizerUserAction('back_to_inner', { fromStep: fromStep });
  // window.mrknavigateTo(1);
  window.mrknavigateTo(2);
  showAllNonRelatedElements()
  multiStepContainer.setAttribute("data-step-number", 2)
  positionSelectorBtns.forEach((btn) => {
    btn.querySelector("input").checked = false;
  })
  document.querySelectorAll('input.mrk-existing-logo-item').forEach((inputEl) => {
    inputEl.checked = false;
  })
  multiStepContainer.removeAttribute("data-selector-value")
})

backFromFinalInner.addEventListener("click", () => {
  var fromStep = Number(multiStepContainer.getAttribute("data-step-number")) || 2;
  if (typeof trackCustomizerStep === 'function') trackCustomizerStep(fromStep, 2);
  if (typeof trackCustomizerUserAction === 'function') trackCustomizerUserAction('back_from_final_inner', { fromStep: fromStep });
  // window.mrknavigateTo(1);
  window.mrknavigateTo(2);
  showAllNonRelatedElements()
  multiStepContainer.setAttribute("data-step-number", 2)
  positionSelectorBtns.forEach((btn) => {
    btn.querySelector("input").checked = false;
  })
  document.querySelectorAll('input.mrk-existing-logo-item').forEach((inputEl) => {
    inputEl.checked = false;
  })
  multiStepContainer.removeAttribute("data-selector-value")
  multiStepContainer.removeAttribute("data-step-final")
})

continueToNextPositionBtns.forEach((conitnueBtn) => {
  conitnueBtn.addEventListener("click", () => {
    var positionNumber = conitnueBtn.getAttribute("data-position-number");
    if (typeof trackCustomizerUserAction === 'function') trackCustomizerUserAction('continue_to_next_position', { positionNumber: positionNumber || '' });
    // window.mrknavigateTo(1);
    window.mrknavigateTo(2);
    showAllNonRelatedElements()
    multiStepContainer.setAttribute("data-step-number", 2)
    multiStepContainer.removeAttribute("data-selector-value")
    multiStepContainer.removeAttribute("data-step-final")
    if (positionNumber){
       document.querySelectorAll(".selected-position")[Number(positionNumber) - 1].classList.add("done"); 
    }    

    //Ak custom code
    let remainingNumber;
    remainingNumber = checkRemainingActivePositions();
    // mrkDebug.log('remainingNumber',remainingNumber);
    if(remainingNumber < 1){
      // button.next-inner
      document.querySelector("button.next-inner.mrk-final-add-to-cart").setAttribute("style", "display: block;")
      document.querySelector("button.next-inner.mrk-final-add-to-cart").classList.remove("disabled");
    }
    //Ak custom code

  })
})

function increaseOneStep() {
  let oldStep = Number(multiStepContainer.getAttribute("data-step-number")) || 1;
  let stepNum = oldStep + 1;
  if (oldStep === 1 && typeof trackCustomizerUserAction === 'function') trackCustomizerUserAction('customizer_opened', { source: 'pdp' });
  if (typeof trackCustomizerStep === 'function') trackCustomizerStep(oldStep, stepNum);
  if (typeof trackCustomizerUserAction === 'function') trackCustomizerUserAction('step_forward', { step: stepNum });
  multiStepContainer.setAttribute("data-step-number", stepNum)

  //Ak custom code
  // const no_cart_btn = document.querySelector('.mrk-steps-footer .add_to_cart_direct');
  // if(no_cart_btn){
  //   no_cart_btn.style.display = 'none';
  // }
  //End Ak custom code
}

let originalSelectorBtns = document.querySelectorAll(".original-selector-btn");
originalSelectorBtns.forEach((btn) => {
  btn.querySelector("input").addEventListener("input", function() {
    if (typeof trackCustomizerUserAction === 'function') trackCustomizerUserAction('logo_type_selected', { value: (btn.querySelector("input").value || '').substring(0, 80) });
    increaseOneStep();
  });
})
let lastSelected = document.querySelectorAll('.selected-position.active');
  let lastElement = lastSelected[lastSelected.length - 1];
let positionSelectorBtns = document.querySelectorAll(".position-selector-btn");
positionSelectorBtns.forEach((btn) => {
  btn.querySelector("input").addEventListener("input", () => {
    if (typeof trackCustomizerUserAction === 'function') trackCustomizerUserAction('position_selected', { position: (btn.getAttribute('data-position') || btn.textContent || '').toString().trim().substring(0, 80) });
    multiStepContainer.setAttribute("data-selector-value", "inner")
    let closestParent = btn.closest(".selected-position.active");
    if (closestParent == lastElement) {
      multiStepContainer.setAttribute("data-step-final", "true")
    }
    updateExistingPositionEvent()
  })
})


//Ak custom code  for commented code

function updateExistingPositionEvent() {
  let remainingNumber;
  let allPositionExistingLogoSelectors = document.querySelectorAll(".mrkexisting-logo-select-position");
  allPositionExistingLogoSelectors.forEach((el) => {
    el.querySelectorAll("input").forEach((inputEl) => {
      inputEl.addEventListener("input", () => {
        el.closest(".mrk-step-existing-logo-position").querySelector(".next-inner").classList.remove("disabled");
        remainingNumber = checkRemainingActivePositions();
        if (remainingNumber < 2) {
          document.querySelector("button.next-inner.mrk-final-add-to-cart").classList.remove("disabled");
          // el.closest(".mrk-step-existing-logo-position").querySelector(".next-inner").setAttribute("style", "display: none;")
        }
      })
    })
  })
  let textLogoSelectors = document.querySelectorAll(".mrk-step-text-logo-position");
  textLogoSelectors.forEach((el) => {
    el.querySelectorAll("input").forEach((inputEl) => {
      inputEl.addEventListener("input", () => {
        el.closest(".mrk-step-text-logo-position").querySelector(".next-inner").classList.remove("disabled");
        remainingNumber = checkRemainingActivePositions();
        if (remainingNumber < 2) {
          document.querySelector("button.next-inner.mrk-final-add-to-cart").classList.remove("disabled");
          // el.closest(".mrk-step-text-logo-position").querySelector(".next-inner").setAttribute("style", "display: none;")
        }
      })
    })
  })  
  let uploadLogoSelectors = document.querySelectorAll(".mrk-step-upload-logo-position");
  uploadLogoSelectors.forEach((el) => {
    el.querySelectorAll("input").forEach((inputEl) => {
      inputEl.addEventListener("input", () => {
        el.closest(".mrk-step-upload-logo-position").querySelector(".next-inner").classList.remove("disabled");
        // mrkDebug.log('remainingNumber',remainingNumber);
        remainingNumber = checkRemainingActivePositions();
        if (remainingNumber < 2) {
          document.querySelector("button.next-inner.mrk-final-add-to-cart").classList.remove("disabled");
          // el.closest(".mrk-step-upload-logo-position").querySelector(".next-inner").setAttribute("style", "display: none;")
        }
      })
    })
  })  
  remainingNumber = checkRemainingActivePositions();
  // mrkDebug.log('remainingNumberout',remainingNumber);
  if (remainingNumber < 2) {
    // document.querySelector("button.next-inner.mrk-final-add-to-cart").setAttribute("style", "display: block;")
    // allPositionExistingLogoSelectors.forEach((el) => {
    //   el.closest(".mrk-step-existing-logo-position").querySelector(".next-inner").setAttribute("style", "display: none;")
    // })
    // textLogoSelectors.forEach((el) => {
    //   el.closest(".mrk-step-text-logo-position").querySelector(".next-inner").setAttribute("style", "display: none;")
    // })
    // uploadLogoSelectors.forEach((el) => {
    //   el.closest(".mrk-step-upload-logo-position").querySelector(".next-inner").setAttribute("style", "display: none;")
    // })
  }
}
//Ak custom code  for commented code

let allChangeSelectionBtns = document.querySelectorAll(".change-selection-btn");
allChangeSelectionBtns.forEach((btn) => {
  btn.addEventListener("click", () => {
    btn.closest(".selected-position.active").classList.remove("done");
    btn.closest(".selected-position.active").querySelectorAll("input").forEach((inputEl) => {
      inputEl.checked = false;
    })

    //Ak custom code
    let remainingNumber;
    remainingNumber = checkRemainingActivePositions();
    // mrkDebug.log('remainingNumber',remainingNumber);
    if(remainingNumber > 0){
      // button.next-inner
      document.querySelector("button.next-inner.mrk-final-add-to-cart").setAttribute("style", "display: none;")
      document.querySelector("button.next-inner.mrk-final-add-to-cart").classList.add("disabled");
    }
    //Ak custom code

  })
})

function checkRemainingActivePositions() {
  let allActivePositions = document.querySelectorAll(".selected-position.active").length;
  let allActiveDonePositions = document.querySelectorAll(".selected-position.active.done").length;
  let remainingPositions = Number(allActivePositions - allActiveDonePositions);
  // mrkDebug.log(remainingPositions)
  if (remainingPositions < 2) {
    // document.querySelector("button.next-inner.mrk-final-add-to-cart").setAttribute("style", "display: block !important;");
  }
  else if (remainingPositions > 1) {
    document.querySelector("button.next-inner.mrk-final-add-to-cart").setAttribute("style", "display: none;");
  }
  return remainingPositions;
}    



  //Ak-dd custom code
  const goto_step1 = document.querySelector(".mrk-product-csutomizer .mrk-product-steps .mrk-step-0 .choose_customization .mrk-open-popup");
  if(goto_step1){
    goto_step1.addEventListener('click',function(){
      window.mrknavigateTo(1);
      // $(".mrk-multistep .mrk-step-0").removeClass('current');
      // $(".mrk-multistep .mrk-step-1").addClass('current');
      // multiStepForm($(".mrk-multistep"), {
      //   defaultStep: 1
      // });
      const customizer_popup_footer = document.querySelector(".mrk-product-csutomizer .mrk-steps-footer");
      if(customizer_popup_footer){
        customizer_popup_footer.classList.remove('hidden');
      }
      
    });
  }

  //Ak-dd custom code
  const no_add_to_cart_popup = document.querySelector(".mrk-product-csutomizer .mrk-product-steps .mrk-step-0 .choose_customization .custom-product-form-logo-row-column-no");
  if(no_add_to_cart_popup){
    no_add_to_cart_popup.addEventListener('click',function(){
      const logoRowButtonNo = document.querySelector(".custom-product-form-dropdown-content .custom-product-form-logo-row-column-no");
      if(logoRowButtonNo){
        logoRowButtonNo.click();
        if (typeof window._mrkCustomizerPopupUnlockBody === 'function') window._mrkCustomizerPopupUnlockBody();
        $('.mrk-customizer-popup-form .popup-overlay').removeClass('show')
      }
    });
  }
  //End Ak custom code
}